<template>
  <div v-if="showEventLanguages">
    <Events-Languages
      :setEventName="setEventName"
      :newEventId="newEventId"
      @interface="handleFcAfterDateBack"
      @closeEventLanguages="handleCloseEventLanguages"
    ></Events-Languages>
  </div>
  <div v-else>
    <DeliveryFeesDialogComponent
      v-if="deliveryFeesDialog"
      :eventId="newEventId"
      @turnDeliveryFeesDialogOff="deliveryFeesDialog = false"
    />
    <Generic_Translations
      v-if='openPriceCategoryTranslations'
      :columns="priceCategoryColumns"
      :translations="priceCategoryTranslations"
      @closeTranslations="closePriceCategoryTranslations"
      @saveTranslations="savePriceCategoryTranslations"
    ></Generic_Translations>
    <Generic_Translations
      v-if='openProductCategoriesTranslations'
      :columns="productCategoriesColumns"
      :translations="productCategoriesTranslations"
      @closeTranslations="closeProductCategoriesTranslations"
      @saveTranslations="saveProductCategoriesTranslations"
    ></Generic_Translations>
    <v-form v-model="valid" lazy-validation ref="eventCreationForm">
      <v-container>
        <v-flex xs12 class="mx-auto containerBackground">
          <v-container style="width:auto" grid-list-xl>
            <v-layout row wrap>
              <v-flex xs12>
                <v-card class="transparent elevation-0 addEventScreen">
                  <v-layout align-start justify-start row class="mb-4">
                    <v-icon :style="`color: ${$vuetify.theme.primary}`" large>border_color</v-icon>
                    <h1
                      v-if="this.properties.params == null"
                      :style="`color: ${$vuetify.theme.primary}`"
                      class="mt-3 ml-4"
                    >{{$translate('NEW_EVENT')}}
                    </h1>
                    <h1
                      v-else
                      :style="`color: ${$vuetify.theme.primary}`"
                      class="mt-3 ml-4"
                    >{{$translate('EDITING')}} "{{eventCreationForm.name}}"
                    </h1>
                  </v-layout>
                    <v-card class="transparent elevation-0 innerEventSection">
                      <v-layout align-start justify-start row class="mb-4">
                          <v-icon :style="`color: ${$vuetify.theme.secondary}`" large>
                            format_list_bulleted
                          </v-icon>
                          <h2
                            :style="`color: ${$vuetify.theme.secondary}`"
                            class="ml-4"
                          >{{$translate('EVENT_DESCRIPTION_EC')}}</h2>
                      </v-layout>
                      <v-layout align-start justify-start row wrap class="mb-4">
                        <v-flex xs12 sm5>
                          <v-layout row align-center class="ml-2">
                            <h4>{{$translate('EVENT_NAME')}}</h4>
                            <h5 class="requiredField"> - {{$translate('REQUIRED')}}</h5>
                          </v-layout>
                          <v-text-field
                            :label="$translate('EVENT_NAME')"
                            v-model="eventCreationForm.name"
                            outline
                            required
                            :rules="eventNameRule"
                            item-text="label"
                            item-value="value"
                          />
                        </v-flex>
                        <v-flex xs12 sm5>
                          <v-layout row align-center class="ml-2">
                            <h4>{{$translate('EVENT_TYPE')}}</h4>
                            <h5 class="requiredField"> - {{$translate('REQUIRED')}}</h5>
                          </v-layout>
                          <v-select
                            :disabled="this.properties.params !== null"
                            v-model="eventCreationForm.type"
                            :items="types"
                            required
                            :rules="eventTypeRule"
                            :label="$translate('EVENT_TYPE')"
                            outline
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm5 v-if="eventCreationForm.type === 'External'">
                          <v-layout row align-center class="ml-2">
                            <h4>{{$translate('EVENT_EXTERNAL_PLATFORM')}}</h4>
                            <h5 class="requiredField"> - {{$translate('REQUIRED')}}</h5>
                          </v-layout>
                          <v-select
                            :disabled="this.properties.params !== null"
                            @change="getExternalEventsForPartner()"
                            v-model="eventCreationForm.externalPlatform"
                            :items="externalPlatforms"
                            required
                            :rules="eventTypeRule"
                            :label="$translate('EVENT_TYPE')"
                            outline
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm5 v-if="eventCreationForm.type === 'External'">
                          <v-layout row align-center class="ml-2">
                            <h4>{{$translate('EVENT_EXTERNAL_EVENT')}}</h4>
                            <h5 class="requiredField"> - {{$translate('REQUIRED')}}</h5>
                          </v-layout>
                          <v-select
                            :disabled="eventCreationForm.externalPlatform === ''"
                            v-model="eventCreationForm.externalEvent"
                            :items="externalEvents"
                            required
                            item-text="externalName"
                            return-object
                            :rules="eventTypeRule"
                            :label="$translate('EVENT_EXTERNAL_EVENT')"
                            outline
                          ></v-select>
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type !== 'Standard'
                                && eventCreationForm.type !== 'Webshop'
                                && eventCreationForm.type !== 'Promotion'
                                && eventCreationForm.type !== 'PartnerPromotion'"
                        >
                          <v-layout row align-center class="ml-2">
                            <h4>{{$translate('EVENT_CAPACITY')}}</h4>
                            <h5 class="requiredField"> - {{$translate('REQUIRED')}}</h5>
                          </v-layout>
                          <v-text-field
                            type="number"
                            min="0"
                            step="1"
                            :label="$translate('CAP_EVENT_CAP')"
                            v-model="eventCreationForm.maxEventCapacity"
                            outline
                            required
                            :rules="eventCapacityRule"
                            item-text="label"
                            item-value="value"
                            ref="eventCreationForm"
                          />
                        </v-flex>
                        <!-- LORENZO BEGIN-->
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type === 'Promotion'"
                        >
                          <v-layout row align-center class="ml-2">
                            <h4>Promotion release date</h4>
                            <h5 class="requiredField"> - {{$translate('REQUIRED')}}</h5>
                          </v-layout>
                          <!-- below text-field should be date-picker, settings: allowed dates: from today -->
                          <v-menu
                            ref="menu1"
                            :close-on-content-click="true"
                            v-model="menu1"
                            :nudge-right="40"
                            :return-value.sync="chosenStartDate"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <v-text-field
                              outline
                              slot="activator"
                              v-model="computedDateFormattedStartDate"
                              :label="$translate('STARTDATE')"
                              hide-details
                              append-icon="event"
                              readonly
                              ref="eventForm"
                            ></v-text-field>
                            <v-date-picker
                              first-day-of-week="1"
                              :min="today"
                              color="primary"
                              v-model="chosenStartDate"
                              @input="$refs.menu1.save(chosenStartDate)"
                              no-title
                            />
                          </v-menu>
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type === 'Promotion'"
                        >
                          <v-layout row align-center class="ml-2">
                            <h4>Promotion release time</h4>
                            <h5 class="requiredField"> - {{$translate('REQUIRED')}}</h5>
                          </v-layout>
                          <!-- below text-field should be time-picker -->
                          <v-text-field
                            rows="1"
                            type="time"
                            text-truncate
                            label="Promotion release time"
                            v-model="startTime"
                            outline
                            item-text="label"
                            item-value="value"
                            ref="eventCreationForm"
                          />
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type === 'Promotion'"
                        >
                          <v-layout row align-center class="ml-2">
                            <h4>Promotion expiration date</h4>
                            <h5 class="requiredField"> - {{$translate('REQUIRED')}}</h5>
                          </v-layout>
                          <!-- below text-field should be date-picker, settings: allowed dates are from start-date -->
                          <v-menu
                            ref="menu2"
                            :close-on-content-click="true"
                            v-model="menu2"
                            :disabled="chosenStartDate === ''"
                            :nudge-right="40"
                            :return-value.sync="chosenEndDate"
                            lazy
                            transition="scale-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <v-text-field
                              outline
                              :disabled="chosenStartDate === ''"
                              slot="activator"
                              v-model="computedDateFormattedEndDate"
                              :label="$translate('ENDDATE')"
                              hide-details
                              append-icon="event"
                              readonly
                              ref="eventForm"
                            ></v-text-field>
                            <v-date-picker
                              first-day-of-week="1"
                              :min="chosenStartDate"
                              color="primary"
                              v-model="chosenEndDate"
                              @input="$refs.menu2.save(chosenEndDate)"
                              no-title
                            />
                          </v-menu>
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type === 'Promotion'"
                        >
                          <v-layout row align-center class="ml-2">
                            <h4>Promotion expiration time</h4>
                            <h5 class="requiredField"> - {{$translate('REQUIRED')}}</h5>
                          </v-layout>
                          <!-- below text-field should be time-picker, settings: if start and end date are equal, at least 1 minute from start-time -->
                          <v-text-field
                            rows="1"
                            type="time"
                            text-truncate
                            label="Promotion expiration time"
                            v-model="endTime"
                            outline
                            item-text="label"
                            item-value="value"
                            ref="eventCreationForm"
                          />
                          <p style="color: red;" v-show="endTimeIncorrect">Endtime is incorrect</p>
                        </v-flex>
                        <!-- LORENZO EINDE -->
                        <v-flex xs12 sm5>
                          <v-layout row align-center class="ml-2">
                            <h4>Info-video URL</h4>
                          </v-layout>
                          <v-text-field
                              rows="1"
                              text-truncate
                              label="Info-video URL"
                              v-model="eventCreationForm.infoUrl"
                              outline
                              item-text="label"
                              item-value="value"
                              ref="eventCreationForm"
                            />
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          v-if="!partnerIsActive && eventCreationForm.type !== 'Theme'"
                        >
                          <v-layout row align-center class="ml-2">
                            <h4>{{$translate('EVENT_PARTNER')}}</h4>
                            <h5 class="requiredField"> - {{$translate('REQUIRED')}}</h5>
                          </v-layout>
                          <v-select
                            required
                            :rules="eventPartnerRule"
                            @change="getExternalEventsForPartner()"
                            v-model="eventCreationForm.eventPartner"
                            :items="users"
                            item-text="Name"
                            :disabled="partnerIsActive"
                            :label="$translate('EVENT_PARTNER')"
                            clearable
                            item-value="id"
                            outline
                          ></v-select>
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          v-if="!partnerIsActive &&
                                eventCreationForm.type !== 'Delivery' &&
                                eventCreationForm.type !== 'PickUp'"
                        >
                          <v-layout row align-center class="ml-2">
                          <h4>{{$translate('EVENT_RANKING')}}</h4>
                          </v-layout>
                          <v-text-field
                            type="number"
                            min="0"
                            max="100"
                            step="1"
                            :label="$translate('EVENT_RANKING')"
                            v-model="eventCreationForm.eventRanking"
                            outline
                            item-text="label"
                            item-value="value"
                            ref="eventCreationForm"
                          />
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type !== 'Standard'
                                && eventCreationForm.type !== 'Webshop'
                                && eventCreationForm.type !== 'Promotion'
                                && eventCreationForm.type !== 'PartnerPromotion'"
                        >
                          <v-layout row align-center class="ml-2">
                          <h4>{{$translate('LEAD_TIME')}}</h4>
                          </v-layout>
                          <v-text-field
                            min="0"
                            type="number"
                            suffix="min"
                            :label="$translate('LEAD_TIME')"
                            v-model="eventCreationForm.leadTimeMin"
                            outline
                          />
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type !== 'Rental'
                                && eventCreationForm.type !== 'Standard'
                                && eventCreationForm.type !== 'Webshop'
                                && eventCreationForm.type !== 'Delivery'
                                && eventCreationForm.type !== 'PickUp'
                                && eventCreationForm.type !== 'Promotion'
                                && eventCreationForm.type !== 'PartnerPromotion'"
                        >
                          <v-layout row align-center class="ml-2">
                            <h4>{{$translate('COOLDOWN_TIME')}}</h4>
                          </v-layout>
                          <v-text-field
                            min="0"
                            type="number"
                            suffix="min"
                            :label="$translate('COOLDOWN_TIME')"
                            v-model="eventCreationForm.cooldownTimeMin"
                            outline
                          />
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type !== 'Rental'
                                && eventCreationForm.type !== 'Standard'
                                && eventCreationForm.type !== 'Webshop'
                                && eventCreationForm.type !== 'Promotion'
                                && eventCreationForm.type !== 'PartnerPromotion'"
                        >
                          <v-layout row align-center class="ml-2">
                            <h4>{{$translate('EVENT_DURATION_EC')}}</h4>
                          </v-layout>
                          <v-text-field
                            min="0"
                            type="number"
                            suffix="min"
                            :label="$translate('EVENT_DURATION_EC')"
                            v-model="eventCreationForm.durationMin"
                            outline
                          />
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type === 'OrderEvent'"
                        >
                          <h4>{{$translate('DELIVERY_PARTNER')}}</h4>
                          <v-text-field
                            rows="1"
                            auto-grow
                            :label="$translate('DELIVERY_PARTNER')"
                            v-model="eventCreationForm.deliveryPartner"
                            outline
                            item-text="label"
                            item-value="value"
                          />
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type !== 'Delivery' &&
                                eventCreationForm.type !== 'PickUp'"
                        >
                          <v-layout row align-center class="ml-2">
                          <h4
                            v-if="eventCreationForm.type !== 'Theme' &&
                                  eventCreationForm.type !== 'Main'"
                          >{{$translate('EVENT_PART_OF_THEMES_EC')}}</h4>
                          <v-checkbox
                            v-else
                            v-model="hiddenTheme"
                            label="This theme is hidden"
                          ></v-checkbox>
                          </v-layout>
                          <v-select
                            chips
                            :label="$translate('EVENT_PART_OF_THEMES_EC')"
                            v-if="eventCreationForm.type !== 'Theme' &&
                                  eventCreationForm.type !== 'Main'"
                            v-model="themesSelected"
                            :items="themes"
                            item-text="Name"
                            item-value="EventId"
                            persistent-hint
                            return-object
                            clearable
                            outline
                            multiple
                          ></v-select>
                        </v-flex>
                        <v-flex xs12 sm5>
                          <v-layout row align-center class="ml-2">
                          <h4>{{$translate('AVAILABLE_OTHER_ACCOUNTS')}}</h4>
                          </v-layout>
                          <v-select
                            chips
                            :label="$translate('VISIBILITY')"
                            v-model="accountsSelected"
                            :items="accounts"
                            item-text="accountName"
                            item-value="accountId"
                            persistent-hint
                            return-object
                            clearable
                            outline
                            multiple
                          ></v-select>
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type !== 'Delivery' &&
                                eventCreationForm.type !== 'PickUp'"
                        >
                          <v-layout row align-center class="ml-2">
                          <h4 class="outlineH4">{{$translate('CATEGORIES')}}</h4>
                          </v-layout>
                          <CategoriesTree
                            v-if="eventCategoriesAll.length > 0"
                            id="categoryForEventCreation"
                            key="categoryForEventCreation"
                            :categoriesAll="eventCategoriesAll"
                            v-on:categoriesSelected="setSelectedEventCategories"
                            class="mt-4 mb-4"
                            :style="`border: 1px solid black; border-radius: 5px`"
                          ></CategoriesTree>
                        </v-flex>
                      </v-layout>
                      <v-layout align-start justify-start row wrap class="mb-2">
                      <v-flex
                        xs12
                        sm4
                        v-if="eventCreationForm.type !== 'Standard'
                              && eventCreationForm.type !== 'Webshop'
                              && eventCreationForm.type !== 'Delivery'
                              && eventCreationForm.type !== 'PickUp'
                                && eventCreationForm.type !== 'Promotion'
                                && eventCreationForm.type !== 'PartnerPromotion'"
                      >
                          <v-layout row align-center class="ml-2">
                          <h4>{{$translate('EVENT_BUDGET_EC')}}</h4>
                          </v-layout>
                            <v-text-field
                              min="0"
                              type="number"
                              :label="$translate('EVENT_BUDGET_EC')"
                              v-model="eventCreationForm.eventBudget"
                              outline
                              prefix="€"
                            />
                        </v-flex>
                        <v-flex
                          xs12
                          sm4
                          v-if="eventCreationForm.type !== 'Standard'
                                && eventCreationForm.type !== 'Webshop'
                                && eventCreationForm.type !== 'Delivery'
                                && eventCreationForm.type !== 'PickUp'
                                && eventCreationForm.type !== 'Promotion'
                                && eventCreationForm.type !== 'PartnerPromotion'"
                        >
                          <v-layout row align-center class="ml-2">
                          <h4>{{$translate('EVENT_REM_BUDGET_EC')}}</h4>
                          </v-layout>
                          <v-text-field
                            min="0"
                            type="number"
                            :label="$translate('EVENT_REM_BUDGET_EC')"
                            v-model="eventCreationForm.remainingBudget"
                            outline
                            disabled
                            prefix="€"
                          />
                        </v-flex>
                        <v-flex
                          xs12
                          sm2
                          class="mt-2"
                          v-if="eventCreationForm.type !== 'Standard'
                                && eventCreationForm.type !== 'Webshop'
                                && eventCreationForm.type !== 'Delivery'
                                && eventCreationForm.type !== 'PickUp'
                                && eventCreationForm.type !== 'Promotion'
                                && eventCreationForm.type !== 'PartnerPromotion'"
                        >
                          <v-btn
                            class="text-capitalize"
                            color="secondary"
                            round
                            @click="resetBudget"
                          >{{$translate('EVENT_RESET')}}</v-btn>
                        </v-flex>
                      </v-layout>
                      <v-layout align-start justify-start row wrap class="mb-4">
                      <v-flex
                        xs12
                        sm5
                        v-if="eventCreationForm.type !== 'Standard'
                              && eventCreationForm.type !== 'Webshop'
                              && eventCreationForm.type !== 'Delivery'
                              && eventCreationForm.type !== 'PickUp'
                              && eventCreationForm.type !== 'Promotion'
                              && eventCreationForm.type !== 'PartnerPromotion'"
                      >
                          <v-checkbox
                            class="mb-2"
                            label="Pre event Question"
                            color="primary"
                            hide-details
                            v-model="eventCreationForm.preEvent"
                          />
                          <h4>{{$translate('EVENT_PRE_EVENT_Q_EC')}}</h4>
                          <v-text-field
                            :disabled="!eventCreationForm.preEvent"
                            rows="1"
                            auto-grow
                            type="text"
                            :label="$translate('EVENT_PRE_EVENT_Q_SMALL_EC')"
                            v-model="eventCreationForm.preEventQuestion"
                            outline
                            item-text="label"
                            item-value="value"
                          />
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          class="mt-4 ml-2"
                          v-if="eventCreationForm.type !== 'Delivery' &&
                                eventCreationForm.type !== 'PickUp'"
                        >
                          <v-layout row align-center class="ml-2">
                            <h4>{{$translate('EVENT_PICTURE')}}</h4>
                          </v-layout>
                          <multiple-image-loader
                            class="imageBorder mt-1 ml-1"
                            :properties="multiPicturesProperties"
                            v-on:load_image="setImageElement"
                          ></multiple-image-loader>
                        </v-flex>
                      </v-layout>
                      <v-layout
                        align-start
                        justify-start
                        row
                        class="mb-4"
                        v-if="eventCreationForm.type !== 'Standard'
                              && eventCreationForm.type !== 'Promotion'
                              && eventCreationForm.type !== 'PartnerPromotion'"
                      >
                        <v-icon :style="`color: ${$vuetify.theme.secondary}`" class="ml-2" large>
                          edit_location
                        </v-icon>
                        <h2
                          v-if="eventCreationForm.type === 'Tour' ||
                                eventCreationForm.type === 'Relay'"
                          :style="`color: ${$vuetify.theme.secondary}`"
                          class="ml-4"
                        >{{$translate('EVENT_ROUTE')}}</h2>
                        <h2
                          v-else
                          :style="`color: ${$vuetify.theme.secondary}`"
                          class="ml-2"
                        >{{$translate('EVENT_LOCATION')}}</h2>
                      </v-layout>
                      <v-layout
                        align-start
                        justify-start
                        row
                        wrap
                        v-if="eventCreationForm.type !== 'Standard'
                              && eventCreationForm.type !== 'Promotion'
                              && eventCreationForm.type !== 'PartnerPromotion'"
                      >
                        <v-flex xs12 sm5>
                          <v-layout row align-center class="ml-2">
                            <h4 v-if="eventCreationForm.type === 'Relay' ||
                                      eventCreationForm.type === 'Tour'">
                              {{$translate('EVENT_START_LOCATION')}}
                            </h4>
                            <h4 v-else>{{$translate('LOCATION')}}</h4>
                            <h5 class="requiredField"> - {{$translate('REQUIRED')}}</h5>
                          </v-layout>
                          <v-select
                            v-if="eventCreationForm.type !== 'Relay' &&
                                  eventCreationForm.type !== 'Tour'"
                            v-model="eventCreationForm.locationId"
                            @change="tourInputCheck(true)"
                            :items="locations"
                            clearable
                            item-text="name"
                            :label="$translate('LOCATION')"
                            item-value="locationId"
                            outline
                          ></v-select>
                          <v-select
                            v-else
                            v-model="eventCreationForm.locationId"
                            @change="tourInputCheck(true)"
                            :items="locations"
                            item-text="name"
                            :label="$translate('LOCATION')"
                            item-value="locationId"
                            outline
                          ></v-select>
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type === 'Relay' ||
                                eventCreationForm.type === 'Tour'"
                          class="ml-4"
                        >
                          <v-layout row align-center class="ml-2">
                            <h4>{{$translate('EVENT_END_LOCATION')}}</h4>
                          </v-layout>
                          <v-select
                            v-model="eventCreationForm.endLocationId"
                            @change="tourInputCheck(true)"
                            :items="locations"
                            item-text="name"
                            clearable
                            :label="$translate('LOCATION')"
                            item-value="locationId"
                            outline
                          ></v-select>
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type === 'Relay' ||
                                eventCreationForm.type === 'Tour'"
                        >
                          <v-layout row align-center class="ml-2">
                            <h4>{{$translate('TRAVEL_MODE')}}</h4>
                            <h5 class="requiredField"> - {{$translate('REQUIRED')}}</h5>
                          </v-layout>
                          <v-select
                            v-model="eventCreationForm.travelMode"
                            @change="tourInputCheck(true)"
                            :items="transportationTypes"
                            item-text="name"
                            required
                            :rules="eventTravelModeRule"
                            :label="$translate('TRAVEL_MODE')"
                            item-value="travelModeVal"
                            outline
                          ></v-select>
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type === 'Relay' ||
                                eventCreationForm.type === 'Tour'"
                          class="ml-4"
                        >
                          <v-layout row align-center class="ml-2">
                            <h4 class>{{$translate('EVENT_AVERAGE_SPEED')}}</h4>
                            <h5 class="requiredField"> - {{$translate('REQUIRED')}}</h5>
                          </v-layout>
                          <v-text-field
                            rows="1"
                            auto-grow
                            class="mb-2"
                            :label="$translate('EVENT_AVERAGE_SPEED')"
                            v-model="eventCreationForm.averageSpeed"
                            @change="tourInputCheck(true)"
                            outline
                            required
                            type="number"
                            item-text="label"
                            item-value="value"
                          />
                          <v-layout row v-if="generateRouteButton">
                            <v-tooltip bottom>
                              <v-btn
                                round
                                slot="activator"
                                color="secondary"
                                class="v-btn-5 dialogButton text-capitalize"
                                @click="generateRoute(startLocationId,
                                                      endLocationId,
                                                      eventCreationForm.travelMode,
                                                      eventCreationForm.averageSpeed)"
                              >
                                <v-icon class="mr-2">timeline</v-icon>
                                {{ $translate('GENERATE_ROUTE') }}
                              </v-btn>
                              <span>{{ $translate('GENERATE_ROUTE') }}</span>
                            </v-tooltip>
                            <p>{{ $translate('TOURCREATION_GENERATE') }}</p>
                          </v-layout>
                        </v-flex>
                        <v-layout row class="pl-2">
                          <v-flex
                            x12
                            sm5
                            v-if="eventCreationForm.type === 'Relay' ||
                                  eventCreationForm.type === 'Tour'"
                          >
                            <h4 class="ml-2">{{$translate('ROUTE_MAP_TITLE')}}</h4>
                            <p class="ml-2">{{$translate('ROUTE_MAP_DESC')}}</p>
                            <p class="ml-2">{{$translate('ROUTE_MAP_DESC_WARNING')}}</p>
                            <Map
                              style="cursor: pointer"
                              :settings="smallMapSettings"
                              ref="smallMap"
                              @click.native="mapDialogTrigger"
                              outline>
                            </Map>
                          </v-flex>
                          <v-flex
                            xs12
                            sm5
                            v-show="eventCreationForm.type === 'Relay' ||
                                    eventCreationForm.type === 'Tour'"
                            class="ml-4"
                            style="margin-top: calc(8vh);"
                          >
                            <v-card>
                              <v-toolbar dense color="secondary" dark>
                                <v-toolbar-title>Stops</v-toolbar-title>
                                <v-spacer></v-spacer>
                              </v-toolbar>
                              <v-card class="elevation-0 transparent scrollingPossible">
                                <v-list>
                                  <v-list-tile
                                    v-for="(stop, index) in polylineTableItems"
                                    v-if="stop.Type === 'Stop'"
                                    :key="index"
                                    avatar
                                    @click="">
                                    <v-list-tile-avatar>
                                      <v-chip :style="`color: primary`"
                                              style="width: 3em !important;"
                                              @click.native.stop="focusOnCoordinate(
                                                [stop.Longitude, stop.Latitude],
                                                'smallMap')">{{stop.StopNr}}
                                      </v-chip>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                      <v-layout row align-center justify-space-around fill-height>
                                        <v-flex xs12 sm5>
                                          <v-text-field
                                            v-if="stop.Type === 'Stop'"
                                            single-line
                                            :label="$translate('EVENT_STOP_NAME')"
                                            v-model="stop.StopName"
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm5>
                                          <v-select
                                            v-if="stop.Type === 'Stop'"
                                            single-line
                                            :label="$translate('EVENT')"
                                            return-object
                                            item-text="EventName"
                                            item-value="EventId"
                                            :items="allEvents"
                                            v-model="stop.EventInfo"
                                            style="margin-bottom: 0 !important">
                                          </v-select>
                                        </v-flex>
                                      </v-layout>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                </v-list>
                              </v-card>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-layout>
                      <v-flex
                        xs12
                        sm5
                        class="pa-0 mb-4"
                        v-if="eventCreationForm.type !== 'Webshop' &&
                              eventCreationForm.type !== 'Delivery' &&
                              eventCreationForm.type !== 'PickUp'"
                      >
                        <v-layout row align-center>
                          <h4
                            class="ml-4"
                          >Assign extra locations</h4>
                        </v-layout>
                        <v-card
                          class="elevation-0 discountCard"
                        >
                          <v-toolbar flat color="white">
                            <v-spacer></v-spacer>
                            <v-dialog v-model="extraLocationsDialog" max-width="570px">
                              <template v-slot:activator="{ on }">
                                <h4
                                  v-if="newEventId == null"
                                >{{$translate('EVENT_ASSIGN_MORE_LOCATIONS_EXPLANATION')}}</h4>
                                <v-btn
                                  class="text-capitalize"
                                  color="secondary"
                                  v-else
                                  round
                                  @click="addExtraLocationToEvent"
                                  v-on="on"
                                >{{$translate('EVENT_ASSIGN_MORE_LOCATIONS')}}</v-btn>
                              </template>
                              <v-card>
                                <v-card-title>
                                  <span class="headline">{{ extraLocationsFormTitle }}</span>
                                </v-card-title>

                                <v-card-text>
                                  <v-container grid-list-md>
                                    <v-layout wrap>
                                      <v-flex xs12 sm6 md7>
                                        <v-select
                                          v-if="extraLocationToEvent"
                                          :disabled="!extraLocationToEvent"
                                          v-model="editedExtraLocationItem"
                                          return-object
                                          :items="potentialExtraLocations"
                                          item-text="Name"
                                          :label="$translate('NAME')"
                                          outline
                                        ></v-select>
                                        <v-text-field
                                          v-else
                                          disabled
                                          v-model="editedExtraLocationItem.Name"
                                          :label="$translate('NAME')"
                                        ></v-text-field>
                                      </v-flex>
                                      <v-flex xs12 sm6 md5>
                                        <v-text-field
                                          input="number"
                                          min="0"
                                          max="100"
                                          v-model="editedExtraLocationItem.Capacity"
                                          label="Location capacity"
                                        ></v-text-field>
                                      </v-flex>
                                    </v-layout>
                                  </v-container>
                                </v-card-text>

                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    color="secondary"
                                    round
                                    @click="closeExtraLocationsDialog"
                                  >{{$translate('CANCEL')}}</v-btn>
                                  <v-btn
                                    color="primary"
                                    :disabled="potentialExtraLocations.length === 0"
                                    round
                                    @click="saveExtraLocation"
                                  >{{$translate('SELECT')}}</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                          </v-toolbar>
                          <v-data-table
                            :headers="extraLocationsHeader"
                            :items="eventExtraLocationsSelected"
                            class="elevation-1"
                          >
                            <template v-slot:items="props">
                              <td>{{props.item.hasOwnProperty('Name') ? props.item.Name : props.item.name}}</td>
                              <td class="text-xs-center">
                                {{props.item.hasOwnProperty('Capacity') ? props.item.Capacity : props.item.capacity}}
                              </td>
                              <td class="justify-center layout px-0">
                                <v-icon small class="mr-2" @click="editExtraLocationItem(props.item)">
                                  edit
                                </v-icon>
                                <v-icon
                                  small
                                  @click="deleteExtraLocationItem(props.item)"
                                >delete</v-icon>
                              </td>
                            </template>
                          </v-data-table>
                        </v-card>
                      </v-flex>
                      <v-layout align-start justify-start row wrap class="mb-4">
                        <v-icon class="ml-3" :style="`color: ${$vuetify.theme.secondary}`" large>
                          build
                        </v-icon>
                        <h2
                          :style="`color: ${$vuetify.theme.secondary}`"
                          class="ml-4"
                        >{{$translate('EVENT_EXTRA')}}</h2>
                      </v-layout>
                      <v-layout align-start justify-start row wrap class="mb-4">
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type !== 'Standard'
                                && eventCreationForm.type !== 'Webshop'
                                && eventCreationForm.type !== 'Delivery'
                                && eventCreationForm.type !== 'PickUp'
                                && eventCreationForm.type !== 'Promotion'
                                && eventCreationForm.type !== 'PartnerPromotion'"
                        >
                          <v-layout row align-center class="ml-2">
                          <h4>{{$translate('EVENT_MANAGED_EC')}}</h4>
                          </v-layout>
                          <v-checkbox
                            label="Managed by planboard"
                            color="primary"
                            hide-details
                            v-model="eventCreationForm.planboardManaged"
                          />
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type !== 'Standard'
                                && eventCreationForm.type !== 'Webshop'
                                && eventCreationForm.type !== 'Promotion'
                                && eventCreationForm.type !== 'PartnerPromotion'"
                        >
                          <v-layout row align-center class="ml-2">
                          <h4>{{$translate('EVENT_TICKET_TYPES_EC')}}</h4>
                          </v-layout>
                          <v-tooltip bottom>
                            <v-btn
                              :disabled="eventCreationForm.type === 'Theme'"
                              round
                              slot="activator"
                              color="secondary"
                              class="v-btn-5 dialogButton text-capitalize"
                              @click="showPriceCategories"
                            >
                              <v-icon class="mr-2">ti-ticket</v-icon>
                              {{$translate('EVENT_TICKET_TYPES')}}
                            </v-btn>
                            <span>{{$translate('EVENT_TICKET_TYPES')}}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type !== 'Standard'
                                && eventCreationForm.type !== 'Webshop'
                                && eventCreationForm.type !== 'PickUp'
                                && eventCreationForm.type !== 'Promotion'
                                && eventCreationForm.type !== 'PartnerPromotion'"
                        >
                          <v-layout row align-center class="ml-2">
                            <h4>{{$translate('EVENT_DELIVERY_FEE_BUTTON')}}</h4>
                          </v-layout>
                          <v-tooltip bottom>
                            <v-btn
                              :disabled="eventCreationForm.type === 'Theme'"
                              round
                              slot="activator"
                              color="secondary"
                              class="v-btn-5 dialogButton text-capitalize"
                              @click="showDeliveryFees"
                            >
                              <v-icon class="mr-2">local_shipping</v-icon>
                              {{$translate('EVENT_DELIVERY_FEE')}}
                            </v-btn>
                            <span>{{$translate('EVENT_DELIVERY_FEE')}}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type !== 'Webshop' &&
                                eventCreationForm.type !== 'Delivery' &&
                                eventCreationForm.type !== 'PickUp'"
                        >
                          <v-layout row align-center class="ml-2">
                          <h4>{{$translate('EVENT_SUG_EC')}}</h4>
                          </v-layout>
                          <v-tooltip bottom>
                            <v-btn
                              round
                              slot="activator"
                              color="secondary"
                              class="v-btn-5 dialogButton text-capitalize"
                              @click="showSuggestionsList"
                            >
                              <v-icon class="mr-2">list</v-icon>
                              {{$translate('SUGGESTIONS')}}
                            </v-btn>
                            <span>{{$translate('SUGGESTIONS')}}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type !== 'Webshop' &&
                                eventCreationForm.type !== 'Delivery' &&
                                eventCreationForm.type !== 'PickUp'"
                        >
                          <v-layout row align-center class="ml-2">
                          <h4>{{$translate('EVENT_ALTER_EC')}}</h4>
                          </v-layout>
                          <v-tooltip bottom>
                            <v-btn
                              round
                              slot="activator"
                              color="secondary"
                              class="v-btn-5 dialogButton text-capitalize"
                              @click="showAlternativesList"
                            >
                              <v-icon class="mr-2">list</v-icon>
                              {{$translate('EVENT_ALTERNATIVES')}}
                            </v-btn>
                            <span>{{$translate('EVENT_ALTERNATIVES')}}</span>
                          </v-tooltip>
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          v-if="!(eventCreationForm.type === 'Tour'
                                  || eventCreationForm.type === 'Relay'
                                  || eventCreationForm.type === 'Standard'
                                  || eventCreationForm.type === 'Webshop'
                                  || eventCreationForm.type === 'Delivery'
                                  || eventCreationForm.type === 'PickUp'
                                  || eventCreationForm.type === 'Promotion'
                                  || eventCreationForm.type === 'PartnerPromotion'
                                  )"
                        >
                          <v-layout row align-center class="ml-2">
                          <h4>{{$translate('EVENT_SUB_ACT_EC')}}</h4>
                          </v-layout>
                          <v-tooltip bottom>
                            <v-btn
                              round
                              slot="activator"
                              color="secondary"
                              class="v-btn-5 dialogButton text-capitalize"
                              @click="showActivitiesList"
                            >
                              <v-icon class="mr-2">list</v-icon>
                              {{$translate('EVENT_SUBACTIVITIES')}}
                            </v-btn>
                            <span>{{$translate('SELECT_SUBACTIVITIES')}}</span>
                          </v-tooltip>
                        </v-flex>

                        <!-- Configure pickup/delivery events for Webshop event by opening RelatedEventsDialog -->
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type === 'Webshop'"
                        >
                          <v-layout row align-center class="ml-2">
                          <h4>{{$translate('EVENT_PICKUP_DELIVERY_EC')}}</h4>
                          </v-layout>
                          <v-tooltip bottom>
                            <v-btn
                              round
                              slot="activator"
                              color="secondary"
                              class="v-btn-5 dialogButton text-capitalize"
                              @click="showRelatedEventsList"
                            >
                              <v-icon class="mr-2">list</v-icon>
                              {{$translate('PICKUP_DELIVERY_EVENTS')}}
                            </v-btn>
                            <span>{{$translate('SELECT_PICKUP_DELIVERY_EVENTS')}}</span>
                          </v-tooltip>
                        </v-flex>

                      </v-layout>
                      <v-layout
                        align-start
                        justify-start
                        row wrap
                        class="mb-4"
                        v-if="eventCreationForm.type !== 'Standard'
                              && eventCreationForm.type !== 'Webshop'
                              && eventCreationForm.type !== 'Delivery'
                              && eventCreationForm.type !== 'PickUp'
                              && eventCreationForm.type !== 'Promotion'
                              && eventCreationForm.type !== 'PartnerPromotion'"
                      >
                        <v-flex xs12 sm5>
                          <v-layout row align-center class="ml-2">
                            <h4 text-xs-left>{{$translate('EVENT_DISCOUNT_CARDS')}}</h4>
                          </v-layout>
                          <v-card class="elevation-0 discountCard">
                            <v-toolbar flat color="white">
                              <v-spacer></v-spacer>
                              <v-dialog v-model="discountCardDialog" max-width="570px">
                                <template v-slot:activator="{ on }">
                                  <h4
                                    v-if="newEventId == null"
                                  >{{$translate('EVENT_DISCOUNT_CARDS_EXPLANATION')}}</h4>
                                  <v-btn
                                    class="text-capitalize"
                                    color="secondary"
                                    v-else
                                    round
                                    @click="addNewCard"
                                    v-on="on"
                                  >{{$translate('ADD')}}</v-btn>
                                </template>
                                <v-card>
                                  <v-card-title>
                                    <span class="headline">{{ formTitle }}</span>
                                  </v-card-title>
                                  <v-card-text>
                                    <v-container grid-list-md>
                                      <v-layout wrap>
                                        <v-flex xs12 sm6 md7>
                                          <v-select
                                            v-if="newCard"
                                            :disabled="!newCard"
                                            v-model="editedItem.Name"
                                            :items="discountCards"
                                            item-text="Name"
                                            :label="$translate('NAME')"
                                            outline
                                          ></v-select>
                                          <v-text-field
                                            v-else
                                            disabled
                                            v-model="editedItem.Name"
                                            :label="$translate('NAME')"
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6 md5>
                                          <v-text-field
                                            input="number"
                                            append-icon="%"
                                            min="0"
                                            max="100"
                                            v-model="editedItem.DiscountPercentage"
                                            :label="$translate('DISCOUNT')"
                                          ></v-text-field>
                                        </v-flex>
                                      </v-layout>
                                    </v-container>
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="secondary"
                                      round
                                      @click="close"
                                    >{{$translate('CANCEL')}}</v-btn>
                                    <v-btn
                                      color="primary"
                                      :disabled="discountCards.length === 0"
                                      round
                                      @click="save"
                                    >{{$translate('SAVE')}}</v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-toolbar>
                            <v-data-table
                              :headers="headers"
                              :items="userDiscountCards"
                              class="elevation-1"
                            >
                              <template v-slot:items="props">
                                <td>{{ props.item.Name }}</td>
                                <td class="text-xs-center">{{ props.item.DiscountPercentage }}</td>
                                <td class="justify-center layout px-0">
                                  <v-icon
                                    small
                                    class="mr-2"
                                    @click="editItem(props.item)"
                                  >edit</v-icon>
                                  <v-icon
                                    small
                                    @click="deleteItem(props.item)"
                                  >delete</v-icon>
                                </td>
                              </template>
                            </v-data-table>
                          </v-card>
                        </v-flex>
                        <v-flex xs12 sm5>
                          <v-layout row align-center class="ml-2">
                            <h4
                              v-if="(eventCreationForm.type === 'Theme' ||
                                    eventCreationForm.type === 'Main')"
                              text-xs-left
                            >{{$translate('EVENT_REWARD_MANAGEMENT')}}</h4>
                            <h4
                              v-if="!(eventCreationForm.type === 'Theme' ||
                                      eventCreationForm.type === 'Main') &&
                                      partnerIsActive === false"
                              text-xs-left
                            >{{$translate('EVENT_ASSIGN_REWARDS')}}</h4>
                          </v-layout>
                          <v-card
                            v-if="eventCreationForm.type === 'Theme' ||
                                  eventCreationForm.type === 'Main'"
                            class="elevation-0 discountCard"
                          >
                            <v-toolbar flat color="white">
                              <v-spacer></v-spacer>
                              <v-dialog v-model="eventRewardsDialog" max-width="570px">
                                <template v-slot:activator="{ on }">
                                  <h4
                                    v-if="newEventId == null"
                                  >{{$translate('EVENT_REWARD_EXPLANATION')}}</h4>
                                  <v-btn
                                    class="text-capitalize"
                                    color="secondary"
                                    v-else
                                    round
                                    @click="addRewardLevel"
                                    v-on="on"
                                  >{{$translate('EVENT_ADD_REWARD_LEVEL')}}</v-btn>
                                </template>
                                <v-card>
                                  <v-card-title>
                                    <span class="headline">{{ formRewardTitle }}</span>
                                  </v-card-title>
                                  <v-card-text>
                                    <v-container grid-list-md>
                                      <v-layout wrap>
                                        <v-flex xs12 sm6 md7>
                                          <v-text-field
                                            v-model="editedRewardItem.Name"
                                            label="Reward name"
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6 md5>
                                          <v-text-field
                                            input="number"
                                            min="0"
                                            max="100"
                                            v-model="editedRewardItem.RewardLevel"
                                            label="Reward level"
                                          ></v-text-field>
                                        </v-flex>
                                      </v-layout>
                                    </v-container>
                                  </v-card-text>

                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="secondary"
                                      round
                                      @click="closeRewardsDialog"
                                    >{{$translate('CANCEL')}}</v-btn>
                                    <v-btn
                                      color="primary"
                                      round
                                      @click="saveEventReward"
                                    >{{$translate('SELECT')}}</v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-toolbar>
                            <v-data-table
                              :headers="rewardsHeaders"
                              :items="rewardsSelected"
                              class="elevation-1"
                            >
                              <template v-slot:items="props">
                                <td>{{ props.item.Name }}</td>
                                <td class="text-xs-center">{{ props.item.RewardLevel }}</td>
                                <td class="justify-center layout px-0">
                                  <v-icon
                                    small
                                    class="mr-2"
                                    @click="editReward(props.item)"
                                  >edit</v-icon>
                                  <v-icon
                                    small
                                    @click="deleteReward(props.item)"
                                  >delete</v-icon>
                                </td>
                              </template>
                            </v-data-table>
                          </v-card>
                          <v-card
                            v-if="eventCreationForm.type !== 'Theme' &&
                                  eventCreationForm.type !== 'Main' &&
                                  partnerIsActive === false"
                            class="elevation-0 discountCard"
                          >
                            <v-toolbar flat color="white">
                              <v-spacer></v-spacer>
                              <v-dialog v-model="themesDialog" max-width="570px">
                                <template v-slot:activator="{ on }">
                                  <h4
                                    v-if="newEventId == null"
                                  >{{$translate('EVENT_ASSIGN_REWARD_EXPLANATION')}}</h4>
                                  <v-btn
                                    class="text-capitalize"
                                    color="secondary"
                                    v-else
                                    round
                                    @click="addExtraLocationToEvent"
                                    v-on="on"
                                  >{{$translate('EVENT_ASSIGN_REWARDS')}}</v-btn>
                                </template>
                                <v-card>
                                  <v-card-title>
                                    <span class="headline">{{ formThemeTitle }}</span>
                                  </v-card-title>

                                  <v-card-text>
                                    <v-container grid-list-md>
                                      <v-layout wrap>
                                        <v-flex xs12 sm6 md7>
                                          <v-select
                                            v-if="themeToEvent"
                                            :disabled="!themeToEvent"
                                            v-model="editedThemeItem.Name"
                                            :items="potentialThemes"
                                            item-text="Name"
                                            :label="$translate('NAME')"
                                            outline
                                          ></v-select>
                                          <v-text-field
                                            v-else
                                            disabled
                                            v-model="editedThemeItem.Name"
                                            :label="$translate('NAME')"
                                          ></v-text-field>
                                        </v-flex>
                                        <v-flex xs12 sm6 md5>
                                          <v-text-field
                                            input="number"
                                            min="0"
                                            max="100"
                                            v-model="editedThemeItem.Reward"
                                            :label="$translate('EVENT_REWARD_POINTS')"
                                          ></v-text-field>
                                        </v-flex>
                                      </v-layout>
                                    </v-container>
                                  </v-card-text>

                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn
                                      color="secondary"
                                      round
                                      @click="closeThemesDialog"
                                    >{{$translate('CANCEL')}}</v-btn>
                                    <v-btn
                                      color="primary"
                                      :disabled="potentialThemes.length === 0"
                                      round
                                      @click="saveReward"
                                    >{{$translate('SELECT')}}</v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-toolbar>
                            <v-data-table
                              :headers="themeHeaders"
                              :items="eventRewardsSelected"
                              class="elevation-1"
                            >
                              <template v-slot:items="props">
                                <td>{{ props.item.Name }}</td>
                                <td class="text-xs-center">{{ props.item.Reward }}</td>
                                <td class="justify-center layout px-0">
                                  <v-icon small class="mr-2" @click="editEventRewardItem(props.item)">
                                    edit
                                  </v-icon>
                                  <v-icon
                                    small
                                    @click="deleteEventRewardItem(props.item)"
                                  >delete</v-icon>
                                </td>
                              </template>
                            </v-data-table>
                          </v-card>
                        </v-flex>
                      </v-layout>
                      <v-layout
                        align-start
                        justify-start
                        row
                        wrap
                        class="mb-4"
                        v-if="eventCreationForm.type !== 'Standard'
                              && eventCreationForm.type !== 'Promotion'
                              && eventCreationForm.type !== 'PartnerPromotion'"
                      >
                        <v-flex
                          xs12
                          sm5
                          v-if="eventCreationForm.type === 'Rental' ||
                                eventCreationForm.type === 'OrderEvent' ||
                                eventCreationForm.type === 'Webshop'"
                        >
                          <v-layout row class="ml-2">
                            <h4 class="mt-2" text-xs-left>{{$translate('PRODUCT_CATEGORIES')}}</h4>
                          </v-layout>

                          <v-tooltip bottom>
                            <v-btn
                              round
                              slot="activator"
                              color="secondary"
                              class="v-btn-5 dialogButton text-capitalize"
                              @click="showProductCategories"
                            >
                              <v-icon class="mr-2">list</v-icon>
                              {{$translate('PRODUCT_CATEGORIES')}}
                            </v-btn>
                            <span>{{$translate('PRODUCT_CATEGORIES')}}</span>
                          </v-tooltip>

                          <!-- <v-card class="elevation-0 discountCard">
                            <v-toolbar flat color="white">
                              <v-btn
                                fab
                                small
                                icon
                                :disabled="newEventId == null && userProductCategories.length < 1"
                                class="text-capitalize"
                                color="primary"
                                round
                                @click="getProductCategoriesTranslations"
                                v-on="on"
                              ><v-icon dark>language</v-icon></v-btn>
                              <v-spacer></v-spacer>
                              <v-dialog v-model="productCategoriesDialog" max-width="370px">
                                <template v-slot:activator="{ on }">
                                  <h4
                                    v-if="newEventId == null"
                                  >{{$translate('PRODUCT_CATEGORY_EXPLANATION')}}</h4>
                                  <v-btn
                                    class="text-capitalize"
                                    color="secondary"
                                    v-else
                                    round
                                    @click="addNewProductCategory"
                                    v-on="on"
                                  >{{$translate('PRODUCT_ADD_CATEGORY')}}</v-btn>
                                </template>
                                <v-card>
                                  <v-card-title>
                                    <span class="headline">{{ formProductCategoryTitle }}</span>
                                  </v-card-title>
                                  <v-card-text>
                                    <v-container grid-list-md>
                                      <v-layout wrap>
                                        <v-flex xs12>
                                          <v-text-field
                                            input="text"
                                            v-model="editedProductCategoryItem.Description"
                                            label="Product category name"
                                          ></v-text-field>
                                        </v-flex>
                                      </v-layout>
                                    </v-container>
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                    <v-btn color="secondary" round @click="closeProductCategories">
                                      {{$translate('CANCEL')}}
                                    </v-btn>
                                    <v-btn
                                      color="primary"
                                      round
                                      @click="saveProductCategory"
                                    >{{$translate('SAVE')}}</v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-toolbar>
                            <v-data-table
                              :headers="productCategoryHeaders"
                              :items="userProductCategories"
                              class="elevation-1"
                            >
                              <template v-slot:items="props">
                                <td>{{ props.item.Description }}</td>
                                <td class="justify-center layout px-0">
                                  <v-icon
                                    small
                                    class="mr-2"
                                    @click="editProductCategoryItem(props.item)"
                                  >
                                    edit
                                  </v-icon>
                                  <v-icon
                                    small
                                    @click="deleteProductCategory(props.item)"
                                  >delete</v-icon>
                                </td>
                              </template>
                            </v-data-table>
                          </v-card> -->
                        </v-flex>
                      </v-layout>
                      <v-layout class="mt-4 mb-2 mr-4" justify-end row wrap>
                        <v-btn
                          round
                          slot="activator"
                          color="secondary"
                          class="v-btn-5 dialogButton text-capitalize"
                          @click="returnFromEventCreation"
                        >{{$translate('CANCEL')}}</v-btn>
                        <v-btn
                          round
                          slot="activator"
                          color="primary"
                          :disabled="endTimeIncorrect && eventCreationForm.type === 'Promotion'"
                          class="v-btn-5 dialogButton text-capitalize"
                          @click="saveEventCreation"
                        >{{$translate('SAVE')}}</v-btn>
                        <v-btn
                          :disabled="!nextButton"
                          round
                          slot="activator"
                          color="primary"
                          class="v-btn-5 dialogButton text-capitalize"
                          @click="continueToLanguages"
                        >{{$translate('NEXT')}}</v-btn>
                      </v-layout>
                    </v-card>
                    <v-dialog v-model="addDefaultDeliveryFeeDialog" max-width="500">
                      <v-card>
                        <v-card-title>
                          <span class="headline">Standard delivery fee</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container fluid grid-list-xl>
                            <v-layout row wrap>
                              <v-flex xs1>
                                <v-checkbox
                                  color="primary"
                                  v-model="defaultDeliveryFee.Fallback"
                                  class="checkboxWholeCountry"
                                />
                              </v-flex>
                              <v-flex xs11>
                                <p>Select this option if the delivery is not for specific postal codes, but for the whole country.</p>
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs6>
                                <v-text-field
                                  v-model="defaultDeliveryFee.Price"
                                  label="Price"/>
                              </v-flex>
                              <v-flex xs6>
                                <v-select
                                  v-model="defaultDeliveryFee.VatId"
                                  :items="vat"
                                  item-text="Name"
                                  required
                                  label="VAT"
                                  item-value="Name"
                                />
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="secondary" round>{{$translate('CANCEL')}}</v-btn>
                          <v-btn
                            color="primary"
                            round
                            @click="saveDefaultDeliveryFee()"
                          >{{$translate('SAVE')}}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-dialog v-model="addDeliveryFeeDialog" max-width="500">
                      <v-card>
                        <v-card-title>
                          <span class="headline">{{ formDeliveryFeeTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                          <v-container fluid grid-list-xl>
                            <v-layout row wrap>
                              <v-flex xs6>
                                <v-text-field
                                  v-model="editedDeliveryFeeItem.Name"
                                  label="Delivery fee name"
                                />
                              </v-flex>
                              <v-flex xs6>
                                <v-select
                                  v-model="editedDeliveryFeeItem.VatId"
                                  :items="vat"
                                  item-text="Name"
                                  required
                                  label="VAT"
                                  item-value="Name"
                                />
                              </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                              <v-flex xs10>
                                <v-card
                                  v-for="(innerItem, innerIndex) in editedDeliveryFeeItem.PostalCodes"
                                  :key="innerIndex"
                                >{{innerItem.MinPostalCode}} - {{innerItem.MaxPostalCode}}</v-card>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="secondary" round>{{$translate('CANCEL')}}</v-btn>
                          <v-btn
                            color="primary"
                            round
                            @click="saveDeliveryFees(editedDeliveryFeeItem)"
                          >{{$translate('SAVE')}}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>

                    <v-dialog persistent v-model="priceCategoriesDialog" max-width="750">
                      <v-layout column wrap>
                        <v-card class="ticketCard elevation-2">
                          <v-card xs12 class="elevation-0 pa-2">
                            <h2>{{$translate('TICKET_SOME_EXPLANATION')}}</h2>
                            <v-checkbox
                              label="Pricing is externally managed"
                              color="primary"
                              hide-details
                              v-model="externallyPriced"
                            />
                            <h3 v-if="externallyPriced">
                              {{$translate('TICKETS_PRICING_EXPLANATION')}}
                            </h3>
                            <v-btn
                              v-if="externallyPriced"
                              round
                              color="secondary"
                              class="text-capitalize"
                              @click="priceCategoriesDialog = false"
                            >{{$translate('CLOSE')}}</v-btn>
                          </v-card>
                          <v-card xs12 class="pa-2 typeTicketCard elevation-0">
                            <v-card
                              v-if="!externallyPriced"
                              class="elevation-0 discountCard"
                            >
                              <v-toolbar flat color="white">
                                <v-spacer></v-spacer>
                                <v-btn
                                  class="text-capitalize"
                                  color="secondary"
                                  round
                                  @click="addNewPriceCategory()"
                                >{{$translate('TICKET_NEW')}}</v-btn>
                              </v-toolbar>
                              <v-data-table
                                :headers="priceCategoriesHeaders"
                                :items="eventPriceCategories"
                                class="elevation-1"
                              >
                                <template v-slot:items="props">
                                  <td>{{ props.item.Name }}</td>
                                  <td class="text-xs-center">
                                    <v-checkbox
                                      class="ml-4 mt-2"
                                      disabled
                                      v-model="props.item.CapacityManaged"
                                    ></v-checkbox>
                                  </td>
                                  <td class="text-xs-center">{{ props.item.MinimumQuantity }}</td>
                                  <td class="text-xs-center">{{ props.item.MaximumQuantity }}</td>
                                  <td v-if="props.item.Id !== 0" class="justify-center layout px-0">
                                    <v-icon
                                      small
                                      class="mr-2"
                                      @click="editPriceCategoriesItem(props.item)"
                                    >edit</v-icon>
                                    <v-icon
                                      small
                                      class="mr-2"
                                      @click="getPriceCategoryTranslations(props.item)"
                                    >language</v-icon>
                                    <v-icon
                                      small
                                      @click="savePriceCategories(props.item, false, true, true)"
                                    >delete</v-icon>
                                  </td>
                                </template>
                              </v-data-table>
                              <v-layout class="mb-4 mr-4 mt-4" align-end justify-end row>
                                <v-btn
                                  round
                                  color="secondary"
                                  class="text-capitalize"
                                  @click="cancelPriceCategoriesDialog"
                                >{{$translate('CLOSE')}}</v-btn>
                              </v-layout>
                            </v-card>
                          </v-card>
                        </v-card>
                      </v-layout>
                    </v-dialog>
                    <v-dialog v-model="addPriceCategoriesDialog" max-width="500">
                      <v-card>
                        <v-card-title>
                          <span class="headline">{{ formTicketTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                          <v-container grid-list-md>
                            <v-layout wrap>
                              <v-flex xs12 sm6 md4>
                                <v-text-field v-model="editedPriceCategoriesItem.Name" label="Ticket name">
                                </v-text-field>
                                <v-select
                                  v-model="editedPriceCategoriesItem.VatId"
                                  :items="vat"
                                  item-text="Name"
                                  required
                                  label="VAT"
                                  item-value="Name"
                                ></v-select>
                              </v-flex>
                              <v-layout justify-end>
                                <v-flex xs8>
                                  <v-checkbox
                                    label="Capacity managed"
                                    color="primary"
                                    hide-details
                                    v-model="editedPriceCategoriesItem.CapacityManaged"
                                  />
                                </v-flex>
                              </v-layout>
                              <v-flex xs12>
                                <v-layout row justify-space-between>
                                  <v-flex xs5>
                                    <v-text-field v-model="editedPriceCategoriesItem.MinimumQuantity"
                                                  type="number"
                                                  :label="$translate('PRICECATEGORY_MIN_QUANTITY')"/>
                                  </v-flex>
                                  <v-flex xs5>
                                    <v-text-field v-model="editedPriceCategoriesItem.MaximumQuantity"
                                                  type="number"
                                                  :label="$translate('PRICECATEGORY_MAX_QUANTITY')"/>
                                  </v-flex>
                                </v-layout>
                                <v-textarea
                                  solo
                                  v-model="editedPriceCategoriesItem.Description"
                                  label="Ticket description"
                                ></v-textarea>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="secondary" round @click="closeAddPriceCategoriesDialog">{{$translate('CANCEL')}}</v-btn>
                          <v-btn
                            v-if="!editPriceCategorie"
                            color="primary"
                            round
                            @click="savePriceCategories(editedPriceCategoriesItem, true, false, false)"
                          >{{$translate('SAVE')}}</v-btn>
                          <v-btn
                            v-else
                            color="primary"
                            round
                            @click="savePriceCategories(editedPriceCategoriesItem, false, true, false)"
                          >{{$translate('SAVE')}}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-dialog persistent v-model="policiesDialog" max-width="750">
                      <v-layout column wrap>
                        <v-card class="ticketCard elevation-2">
                          <v-card xs12 class="elevation-0 pa-2">
                            <h2>{{$translate('POLICIES_EXPLANATION')}}</h2>
                          </v-card>
                          <v-card xs12 class="pa-2 typeTicketCard elevation-0">
                            <v-card v-if="!partnerIsActive" class="elevation-0 discountCard">
                              <v-toolbar flat color="white">
                                <v-spacer></v-spacer>
                                <v-btn
                                  class="text-capitalize"
                                  color="secondary"
                                  round
                                  @click="addPoliciesDialog = true"
                                >{{$translate('POLICIES_NEW')}}</v-btn>
                              </v-toolbar>
                              <v-data-table
                                :headers="policiesHeaders"
                                :items="eventPolicies"
                                class="elevation-1"
                              >
                                <template v-slot:items="props">
                                  <td>{{ props.item.Name }}</td>
                                  <td class="text-xs-left">{{ props.item.Description }}</td>
                                  <td class="text-xs-center">{{ props.item.Timeout }}</td>
                                  <td v-if="props.item.Id !== 0" class="justify-center layout px-0">
                                    <v-icon small class="mr-2" @click="editPoliciesItem(props.item)">
                                      edit
                                    </v-icon>
                                    <v-icon
                                      small
                                      @click="savePolicies(props.item, false, true, true)"
                                    >delete</v-icon>
                                  </td>
                                </template>
                              </v-data-table>
                              <v-layout class="mb-4 mr-4 mt-4" align-end justify-end row>
                                <v-btn
                                  round
                                  color="secondary"
                                  class="text-capitalize"
                                  @click="cancelPoliciesDialog"
                                >{{$translate('CLOSE')}}</v-btn>
                                <!-- <v-btn
                              round
                              color="primary"
                              class="text-capitalize"
                              @click="savePriceCategories"
                                >{{$translate('SAVE')}}</v-btn>-->
                              </v-layout>
                            </v-card>
                          </v-card>
                        </v-card>
                      </v-layout>
                    </v-dialog>
                    <v-dialog v-model="addPoliciesDialog" max-width="500">
                      <v-card>
                        <v-card-title>
                          <span class="headline">{{ formPoliciesTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                          <v-container grid-list-md>
                            <v-layout wrap>
                              <v-flex xs12 sm6 md4>
                                <v-text-field v-model="editedPoliciesItem.Name" label="Policy name">
                                </v-text-field>
                              </v-flex>
                              <v-layout justify-end>
                                <v-flex xs8>
                                  <v-text-field
                                    label="Policy timeout (in sec)"
                                    input="number"
                                    min="0"
                                    max="2592000"
                                    v-model="editedPoliciesItem.Timeout"
                                  />
                                </v-flex>
                              </v-layout>
                              <v-flex xs12>
                                <v-textarea
                                  solo
                                  v-model="editedPoliciesItem.Description"
                                  label="Policy description"
                                ></v-textarea>
                              </v-flex>
                            </v-layout>
                          </v-container>
                        </v-card-text>

                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn color="secondary" round @click="closeAddPoliciesDialog">{{$translate('CANCEL')}}</v-btn>
                          <v-btn
                            v-if="!editPolicies"
                            color="primary"
                            round
                            @click="savePolicies(editedPoliciesItem, true, false, false)"
                          >{{$translate('SAVE')}}</v-btn>
                          <v-btn
                            v-else
                            color="primary"
                            round
                            @click="savePolicies(editedPoliciesItem, false, true, false)"
                          >{{$translate('SAVE')}}</v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                    <v-dialog v-model="subActivitiesDialog" max-width="1000">
                      <v-layout>
                        <v-flex class="dialogActivitiesSelecter">
                          <v-layout row class="ml-2 pt-4">
                            <v-icon
                              class="ml-4"
                              :style="`color: ${$vuetify.theme.primary}`"
                              large
                            >format_list_bulleted</v-icon>
                            <h1
                              :style="`color: ${$vuetify.theme.primary}`"
                              class="ml-3"
                            >{{$translate('SELECT_SUBACTIVITIES')}}</h1>
                          </v-layout>
                          <v-layout class="listOutline" align-center justify-end row>
                            <v-flex>
                              <h2 color="secondary">{{$translate('ALL_EVENTS')}}</h2>
                              <v-layout column>
                                <v-flex xs2>
                                  <v-btn
                                    round
                                    color="primary"
                                    class="ma-2 text-capitalize"
                                    @click="openCategoriesDialogForSubActivities()"
                                  >
                                    {{$translate('FILTER_SELECT')}}
                                    <v-icon right>edit</v-icon>
                                  </v-btn>
                                </v-flex>
                                <v-dialog v-model="categoriesDialogForSubActivities" max-width="800">
                                  <v-card class="pt-4 mt-2">
                                    <v-layout row justify-center>
                                      <v-flex xs8>
                                        <v-card v-if="categoryFiltersSelected.length == 0">
                                          <v-card class="mt-4 pt-2 pl-2 pb-2" elevation-0>
                                            <h3>{{$translate('FILTER_NO_SELECTED')}}</h3>
                                          </v-card>
                                        </v-card>
                                        <v-card v-else>
                                          <div class="autoScrollabe">
                                            <v-item-group round class="mt-4" multiple>
                                              <v-subheader>{{$translate('FILTER_SELECTED')}}</v-subheader>
                                              <v-divider></v-divider>
                                              <v-item
                                                v-for="item in categoryFiltersSelected"
                                                :key="item.InterestId"
                                              >
                                                <v-chip>{{ item.Name }}</v-chip>
                                              </v-item>
                                            </v-item-group>
                                          </div>
                                        </v-card>
                                        <CategoriesTree
                                          v-if="categoryFiltersAll.length > 0"
                                          id="categoryForFilterSubActivities"
                                          key="categoryForFilterSubActivities"
                                          :expandByDefault="0"
                                          :categoriesAll="categoryFiltersAll"
                                          v-on:categoriesSelected="setSelectedCategoryFilters"
                                          class="mt-4 mb-4"
                                          :style="`border: 1px solid black; max-width: 40em; border-radius: 5px`"
                                        ></CategoriesTree>
                                      </v-flex>
                                    </v-layout>
                                    <v-layout justify-end>
                                      <v-btn
                                        round
                                        color="secondary"
                                        class="v-btn5 mt-4 text-capitalize"
                                        @click="closeFiltersForSubActivities()"
                                      >{{$translate('CLOSE')}}</v-btn>
                                      <v-btn
                                        round
                                        color="primary"
                                        class="v-btn5 mb-2 mt-4 text-capitalize"
                                        @click="saveFiltersForSubActivities()"
                                      >{{$translate('SAVE')}}</v-btn>
                                    </v-layout>
                                  </v-card>
                                </v-dialog>
                                <v-flex class="elevation-1 cardEvents">
                                  <template v-for="(item, index) in subActivitiesList">
                                    <v-list-tile :key="index">
                                      <v-list-tile-content class="listOutlineSub" @click="item = !item">
                                        <v-checkbox
                                          :style="getFontProperty()"
                                          class="ml-2 mt-4"
                                          :key="item.eventId"
                                          :label="item.name"
                                          :value="item"
                                          v-model="selectedSubActivities"
                                        ></v-checkbox>
                                      </v-list-tile-content>
                                    </v-list-tile>
                                  </template>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-layout align-center justify-center column>
                              <v-flex xs10>
                                <v-btn
                                  round
                                  color="primary"
                                  class="mb-4 mr-5 text-capitalize"
                                  @click="addToSelected(sub)"
                                >
                                  <v-icon large>arrow_forward</v-icon>
                                </v-btn>
                              </v-flex>
                              <v-flex xs10>
                                <v-btn
                                  round
                                  color="secondary"
                                  class="mr-5 text-capitalize"
                                  @click="removeFromSelected(sub)"
                                >
                                  <v-icon large>arrow_back</v-icon>
                                </v-btn>
                              </v-flex>
                            </v-layout>
                            <v-flex>
                              <v-layout class="layoutForRightCard" justify-center column>
                                <h2 color="secondary">{{$translate('SELECTED_SUBACTIVITIES')}}</h2>
                                <v-flex class="elevation-1 cardEvents">
                                  <template v-for="(item, index) in userSubActivitiesList">
                                    <v-list-tile :key="index">
                                      <v-list-tile-content class="listOutlineSub" @click="item = !item">
                                        <v-checkbox
                                          :style="getFontProperty()"
                                          class="ml-2 mt-4"
                                          :key="item.eventId"
                                          :label="item.name"
                                          :value="item"
                                          v-model="userSelectionForSubActivities"
                                        ></v-checkbox>
                                      </v-list-tile-content>
                                    </v-list-tile>
                                  </template>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-layout class="mb-4 mr-4" align-end justify-end row>
                            <v-btn
                              round
                              color="secondary"
                              class="text-capitalize"
                              @click="cancelSubActivitiesDialog"
                            >{{$translate('CANCEL')}}</v-btn>
                            <v-btn
                              round
                              color="primary"
                              class="text-capitalize"
                              @click="saveChildren"
                            >{{$translate('SAVE')}}</v-btn>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-dialog>
                    <v-dialog v-model="eventTourDialog" max-width="1000">
                      <v-layout>
                        <v-flex class="dialogActivitiesSelecter">
                          <v-layout row class="ml-2 pt-4">
                            <v-icon
                              class="ml-4"
                              :style="`color: ${$vuetify.theme.primary}`"
                              large
                            >format_list_bulleted</v-icon>
                            <h1
                              :style="`color: ${$vuetify.theme.primary}`"
                              class="ml-3"
                            >{{$translate('MAP_TOUR_CONFIGURATION')}}</h1>
                          </v-layout>
                          <v-layout class="listOutline" align-center justify-end row>
                            <v-flex>
                              <h2 color="secondary">{{$translate('ALL_EVENTS')}}</h2>
                              <v-layout column>
                                <v-flex xs2>
                                  <v-btn
                                    round
                                    color="primary"
                                    class="ma-2 text-capitalize"
                                    @click="openCategoriesDialogForTour()"
                                  >
                                    {{$translate('FILTER_SELECT')}}
                                    <v-icon right>edit</v-icon>
                                  </v-btn>
                                </v-flex>
                                <v-dialog v-model="categoriesDialogForTour" max-width="850">
                                  <v-card class="pt-4 mt-2">
                                    <v-layout row justify-center>
                                      <v-flex xs8>
                                        <v-card v-if="selectedTagsInArrayForTourActivities.length == 0">
                                          <v-card class="mt-4 pt-2 pl-2 pb-2" elevation-0>
                                            <h3>{{$translate('FILTER_NO_SELECTED')}}</h3>
                                          </v-card>
                                        </v-card>
                                        <v-card v-else>
                                          <div class="autoScrollabe">
                                            <v-item-group round class="mt-4" multiple>
                                              <v-subheader>{{$translate('FILTER_SELECTED')}}</v-subheader>
                                              <v-divider></v-divider>
                                              <v-item
                                                v-for="item in selectedTagsInArrayForTourActivities"
                                                :key="item"
                                              >
                                                <v-chip>{{ item}}</v-chip>
                                              </v-item>
                                            </v-item-group>
                                          </div>
                                        </v-card>
                                        <expendable-tags
                                          class="mt-4"
                                          :expandByDefault="0"
                                          :disable="true"
                                          :showOnlySelected="showSelectedUserGroups"
                                          :properties="expTagProp"
                                          :cleanFilters="cleanTheFilters"
                                          :preselection="tourPreselection"
                                          v-on:selectedTags="setSelectedTourTags"
                                          @returnedTagsData="handleTourTagsDataAfterRecieved"
                                          :style="`border: 1px solid black; max-width: 40em;`"
                                        ></expendable-tags>
                                      </v-flex>
                                    </v-layout>
                                    <v-layout justify-end>
                                      <v-btn
                                        round
                                        color="secondary"
                                        class="v-btn5 mt-4 text-capitalize"
                                        @click="closeFiltersForTourActivities()"
                                      >{{$translate('CLOSE')}}</v-btn>
                                      <v-btn
                                        round
                                        color="primary"
                                        class="v-btn5 mb-2 mt-4 text-capitalize"
                                        @click="saveFiltersForTourActivities()"
                                      >{{$translate('SAVE')}}</v-btn>
                                    </v-layout>
                                  </v-card>
                                </v-dialog>
                                <v-flex class="elevation-1 cardEvents">
                                  <template v-for="(item, index) in tourList">
                                    <v-list-tile :key="index">
                                      <v-list-tile-content class="listOutlineSub" @click="item = !item">
                                        <v-checkbox
                                          :style="getFontProperty()"
                                          class="ml-2 mt-4"
                                          :key="item.eventId"
                                          :label="item.name"
                                          :value="item"
                                          v-model="selectedTourActivities"
                                        ></v-checkbox>
                                      </v-list-tile-content>
                                    </v-list-tile>
                                  </template>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-layout align-center justify-center column>
                              <v-flex xs10>
                                <v-btn
                                  round
                                  color="primary"
                                  class="mb-4 mr-5 text-capitalize"
                                  @click="addToSelected(tour)"
                                >
                                  <v-icon large>arrow_forward</v-icon>
                                </v-btn>
                              </v-flex>
                              <v-flex xs10>
                                <v-btn
                                  round
                                  color="secondary"
                                  class="mr-5 text-capitalize"
                                  @click="removeFromSelected(tour)"
                                >
                                  <v-icon large>arrow_back</v-icon>
                                </v-btn>
                              </v-flex>
                            </v-layout>
                            <v-flex>
                              <v-layout class="layoutForRightCard" justify-center column>
                                <h2 color="secondary">{{$translate('MAP_SELECTED_TOUR_ACTIVITIES')}}</h2>
                                <v-flex class="elevation-1 tourCard">
                                  <draggable v-model="userTourList">
                                    <v-list-tile
                                      v-for="item in userTourList"
                                      class="thisOne"
                                      :key="item.seqNr"
                                    >
                                      <v-list-tile-content active-class="grey" class="tourListOutlineSub">
                                        <v-layout row>
                                          <v-checkbox
                                            class="tourCheckbox"
                                            :value="item"
                                            v-model="userSelectionForTour"
                                          ></v-checkbox>
                                          <span class="dot">
                                      <p class="pStyle">{{item.seqNr}}</p>
                                    </span>
                                          <p class="tourText" :style="getFontProperty()">{{item.name}}</p>
                                        </v-layout>
                                        <v-layout row>
                                          <v-icon class="dragIcon" @click="dragInfo(item)">
                                            swap_vert
                                          </v-icon>
                                        </v-layout>
                                      </v-list-tile-content>
                                    </v-list-tile>
                                  </draggable>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-layout class="mb-4 mr-4" align-end justify-end row>
                            <v-btn
                              round
                              color="secondary"
                              class="text-capitalize"
                              @click="cancelTourDialog"
                            >{{$translate('CANCEL')}}</v-btn>
                            <v-btn
                              round
                              color="primary"
                              class="text-capitalize"
                              @click="saveTourActivities"
                            >{{$translate('SAVE')}}</v-btn>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-dialog>
                    <v-dialog v-model="eventAlternativesDialog" max-width="1000">
                      <v-layout>
                        <v-flex class="dialogActivitiesSelecter">
                          <v-layout row class="ml-2 pt-4">
                            <v-icon
                              class="ml-4"
                              :style="`color: ${$vuetify.theme.primary}`"
                              large
                            >format_list_bulleted</v-icon>
                            <h1 :style="`color: ${$vuetify.theme.primary}`" class="ml-3">{{$translate('ALTERNATIVE_SELECT')}}</h1>
                          </v-layout>
                          <v-layout class="listOutline" align-center justify-end row>
                            <v-flex>
                              <h2 color="secondary">{{$translate('ALL_EVENTS')}}</h2>
                              <v-layout column>
                                <v-flex xs2>
                                  <v-btn
                                    round
                                    color="primary"
                                    class="ma-2 text-capitalize"
                                    @click="categoriesDialogForAlternatives = true"
                                  >
                                    {{$translate('FILTER_SELECTED')}}
                                    <v-icon right>edit</v-icon>
                                  </v-btn>
                                </v-flex>
                                <v-dialog v-model="categoriesDialogForAlternatives" max-width="800">
                                  <v-card class="pt-4 mt-2">
                                    <v-layout row justify-center>
                                      <v-flex xs8>
                                        <v-card v-if="categoryFiltersSelected.length == 0">
                                          <v-card class="mt-4 pt-2 pl-2 pb-2" elevation-0>
                                            <h3>{{$translate('FILTER_NO_SELECTED')}}</h3>
                                          </v-card>
                                        </v-card>
                                        <v-card v-else>
                                          <div class="autoScrollabe">
                                            <v-item-group round class="mt-4" multiple>
                                              <v-subheader>{{$translate('FILTER_SELECTED')}}</v-subheader>
                                              <v-divider></v-divider>
                                              <v-item
                                                v-for="item in categoryFiltersSelected"
                                                :key="item.InterestId"
                                              >
                                                <v-chip>{{ item.Name }}</v-chip>
                                              </v-item>
                                            </v-item-group>
                                          </div>
                                        </v-card>
                                        <CategoriesTree
                                          v-if="categoryFiltersAll.length > 0"
                                          id="categoryForFilterAlternatives"
                                          key="categoryForFilterAlternatives"
                                          :expandByDefault="0"
                                          :categoriesAll="categoryFiltersAll"
                                          v-on:categoriesSelected="setSelectedCategoryFilters"
                                          class="mt-4 mb-4"
                                          :style="`border: 1px solid black; max-width: 40em; border-radius: 5px`"
                                        ></CategoriesTree>
                                      </v-flex>
                                    </v-layout>
                                    <v-layout justify-end>
                                      <v-btn
                                        round
                                        color="secondary"
                                        class="v-btn5 mt-4 text-capitalize"
                                        @click="closeFiltersForAlternatives()"
                                      >{{$translate('CLOSE')}}</v-btn>
                                      <v-btn
                                        round
                                        color="primary"
                                        class="v-btn5 mb-2 mt-4 text-capitalize"
                                        @click="saveFiltersForAlternatives()"
                                      >{{$translate('SAVE')}}</v-btn>
                                    </v-layout>
                                  </v-card>
                                </v-dialog>
                                <v-flex class="elevation-1 cardEvents">
                                  <template v-for="(item, index) in alternativesList">
                                    <v-list-tile :key="index">
                                      <v-list-tile-content class="listOutlineSub" @click="item = !item">
                                        <v-checkbox
                                          :style="getFontProperty()"
                                          class="ml-2 mt-4"
                                          :key="item.eventId"
                                          :label="item.name"
                                          :value="item"
                                          v-model="selectedAlternatives"
                                        ></v-checkbox>
                                      </v-list-tile-content>
                                    </v-list-tile>
                                  </template>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-layout align-center justify-center column>
                              <v-flex xs10>
                                <v-btn
                                  round
                                  color="primary"
                                  class="mb-4 mr-5 text-capitalize"
                                  @click="addToSelected(alt)"
                                >
                                  <v-icon large>arrow_forward</v-icon>
                                </v-btn>
                              </v-flex>
                              <v-flex xs10>
                                <v-btn
                                  round
                                  color="secondary"
                                  class="mr-5 text-capitalize"
                                  @click="removeFromSelected(alt)"
                                >
                                  <v-icon large>arrow_back</v-icon>
                                </v-btn>
                              </v-flex>
                            </v-layout>
                            <v-flex>
                              <v-layout class="layoutForRightCard" justify-center column>
                                <h2 color="secondary">{{$translate('ALTERNATIVE_SELECT')}}</h2>
                                <v-flex class="elevation-1 cardEvents">
                                  <template v-for="(item, index) in userAlternativesList">
                                    <v-list-tile :key="index">
                                      <v-list-tile-content class="listOutlineSub" @click="item = !item">
                                        <v-checkbox
                                          :style="getFontProperty()"
                                          class="ml-2 mt-4"
                                          :key="item.eventId"
                                          :label="item.name"
                                          :value="item"
                                          v-model="userSelectionForAlternatives"
                                        ></v-checkbox>
                                      </v-list-tile-content>
                                    </v-list-tile>
                                  </template>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-layout class="mb-4 mr-4" align-end justify-end row>
                            <v-btn
                              round
                              color="secondary"
                              class="text-capitalize"
                              @click="cancelAlternativesDialog"
                            >{{$translate('CANCEL')}}</v-btn>
                            <v-btn
                              round
                              color="primary"
                              class="text-capitalize"
                              @click="saveAlternatives"
                            >{{$translate('SAVE')}}</v-btn>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-dialog>
                    <v-dialog v-model="eventSuggestionsDialog" max-width="1000">
                      <v-layout>
                        <v-flex class="dialogActivitiesSelecter">
                          <v-layout row class="ml-2 pt-4">
                            <v-icon
                              class="ml-4"
                              :style="`color: ${$vuetify.theme.primary}`"
                              large
                            >format_list_bulleted</v-icon>
                            <h1 :style="`color: ${$vuetify.theme.primary}`" class="ml-3">{{$translate('SUGGESTIONS_SELECT')}}</h1>
                          </v-layout>
                          <v-layout class="listOutline" align-center justify-end row>
                            <v-flex>
                              <h2 color="secondary">{{$translate('ALL_EVENTS')}}</h2>
                              <v-layout column>
                                <v-flex xs2>
                                  <v-btn
                                    round
                                    color="primary"
                                    class="ma-2 text-capitalize"
                                    @click="categoriesDialogForSuggestions = true"
                                  >
                                    {{$translate('FILTER_SELECT')}}
                                    <v-icon right>edit</v-icon>
                                  </v-btn>
                                </v-flex>
                                <v-dialog v-model="categoriesDialogForSuggestions" max-width="800">
                                  <v-card class="pt-4 mt-2">
                                    <v-layout row justify-center>
                                      <v-flex xs8>
                                        <v-card v-if="categoryFiltersSelected.length == 0">
                                          <v-card class="mt-4 pt-2 pl-2 pb-2" elevation-0>
                                            <h3>{{$translate('FILTER_NO_SELECTED')}}</h3>
                                          </v-card>
                                        </v-card>
                                        <v-card v-else>
                                          <div class="autoScrollabe">
                                            <v-item-group round class="mt-4" multiple>
                                              <v-subheader>{{$translate('FILTER_SELECTED')}}</v-subheader>
                                              <v-divider></v-divider>
                                              <v-item
                                                v-for="item in categoryFiltersSelected"
                                                :key="item.InterestId"
                                              >
                                                <v-chip>{{ item.Name }}</v-chip>
                                              </v-item>
                                            </v-item-group>
                                          </div>
                                        </v-card>
                                        <CategoriesTree
                                          v-if="categoryFiltersAll.length > 0"
                                          id="categoryForFilterSuggestions"
                                          key="categoryForFilterSuggestions"
                                          :expandByDefault="0"
                                          :categoriesAll="categoryFiltersAll"
                                          @categoriesSelected="setSelectedCategoryFilters"
                                          class="mt-4 mb-4"
                                          :style="`border: 1px solid black; max-width: 40em; border-radius: 5px`"
                                        ></CategoriesTree>
                                      </v-flex>
                                    </v-layout>
                                    <v-layout justify-end>
                                      <v-btn
                                        round
                                        color="secondary"
                                        class="v-btn5 mt-4 text-capitalize"
                                        @click="closeFiltersForSuggestions()"
                                      >{{$translate('CLOSE')}}</v-btn>
                                      <v-btn
                                        round
                                        color="primary"
                                        class="v-btn5 mb-2 mt-4 text-capitalize"
                                        @click="saveFiltersForSuggestions()"
                                      >{{$translate('SAVE')}}</v-btn>
                                    </v-layout>
                                  </v-card>
                                </v-dialog>
                                <v-flex class="elevation-1 cardEvents">
                                  <template v-for="(item, index) in suggestionsList">
                                    <v-list-tile :key="index">
                                      <v-list-tile-content class="listOutlineSub" @click="item = !item">
                                        <v-checkbox
                                          :style="getFontProperty()"
                                          class="ml-2 mt-4"
                                          :key="item.eventId"
                                          :label="item.name"
                                          :value="item"
                                          v-model="selectedSuggestions"
                                        ></v-checkbox>
                                      </v-list-tile-content>
                                    </v-list-tile>
                                  </template>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                            <v-layout align-center justify-center column>
                              <v-flex xs10>
                                <v-btn
                                  round
                                  color="primary"
                                  class="mb-4 mr-5 text-capitalize"
                                  @click="addToSelected(sug)"
                                >
                                  <v-icon large>arrow_forward</v-icon>
                                </v-btn>
                              </v-flex>
                              <v-flex xs10>
                                <v-btn
                                  round
                                  color="secondary"
                                  class="mr-5 text-capitalize"
                                  @click="removeFromSelected(sug)"
                                >
                                  <v-icon large>arrow_back</v-icon>
                                </v-btn>
                              </v-flex>
                            </v-layout>
                            <v-flex>
                              <v-layout class="layoutForRightCard" justify-center column>
                                <h2 color="secondary">{{$translate('SUGGESTIONS_SELECTED')}}</h2>
                                <v-flex class="elevation-1 cardEvents">
                                  <template v-for="(item, index) in userSuggestionsList">
                                    <v-list-tile :key="index">
                                      <v-list-tile-content class="listOutlineSub" @click="item = !item">
                                        <v-checkbox
                                          :style="getFontProperty()"
                                          class="ml-2 mt-4"
                                          :key="item.eventId"
                                          :label="item.name"
                                          :value="item"
                                          v-model="userSelectionForSuggestions"
                                        ></v-checkbox>
                                      </v-list-tile-content>
                                    </v-list-tile>
                                  </template>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                          <v-layout class="mb-4 mr-4" align-end justify-end row>
                            <v-btn
                              round
                              color="secondary"
                              class="text-capitalize"
                              @click="cancelSuggestionsDialog"
                            >{{$translate('CANCEL')}}</v-btn>
                            <v-btn
                              round
                              color="primary"
                              class="text-capitalize"
                              @click="saveSuggestions"
                            >{{$translate('SAVE')}}</v-btn>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-dialog>

                    <!-- Dialog to configure related (pickup/delivery) events -->
                    <RelatedEventsDialog
                      v-if="showRelatedEventsDialog"
                      :showDialog="showRelatedEventsDialog"
                      :possibleRelatedEvents="possibleRelatedEvents"
                      :relatedEventsToBeSaved="relatedEventsToBeSaved"
                      @save-changes="saveRelatedEventsChanges"
                      @cancel-changes="cancelRelatedEventsChanges"
                    />
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-container>
    </v-form>
    <v-dialog v-model="saveEventFirstDialog" persistent max-width="300">
      <v-card>
        <v-card-title
          class="headline"
          :style="`color: ${$vuetify.theme.primary}`"
        >{{$translate('WARNING')}}</v-card-title>
        <v-card-text>
          <h3>In order to enter this page, please fill in the required data for the event and save it.</h3>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            round
            class="text-capitalize"
            @click.native="saveEventFirstDialog = false"
          >{{$translate('CANCEL')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mapDialog" max-width="90%" persistent>
      <v-card>
        <v-layout row class="ml-2 pt-4">
          <v-icon
            class="ml-4"
            :style="`color: ${$vuetify.theme.primary}`"
            large
          >format_list_bulleted</v-icon>
          <h1
            :style="`color: ${$vuetify.theme.primary}`"
            class="ml-3"
          >{{$translate('CONFIGURE_ROUTE')}}</h1>
          <v-layout justify-end mr-4>
            <p style="margin: 1em !important;">{{package.name}}</p>
            <v-tabs v-model="toggleTabsMap">
              <v-tab>
                <v-icon>info</v-icon>
              </v-tab>
              <v-tab>{{ $translate('SHOW_ROUTE') }}</v-tab>
              <v-tab>{{ $translate('SHOW_WAYPOINTS') }}</v-tab>
            </v-tabs>
            <v-divider vertical></v-divider>
            <v-btn round color="primary">
              <label for="files"
                     class="btn"
              >Import GPX</label>
            </v-btn>
            <input
              id="files"
              class="inputfile"
              type="file"
              :ref="gpxInput"
              accept="gpx/*"
              cancelable="true"
              style="padding-top: 1em;"
              multiple="true"
              cancelBubble="true"
              @change="importGpx"
            />
          </v-layout>
        </v-layout>
        <v-layout justify-center row ml-4 mr-4 h-6>
          <v-flex xs12 md7>
            <Map
              :settings="bigMapSettings"
              v-on:setWaypoints="setWaypoints"
              v-if="mapDialog"
              outline
              ref="bigMap"
            ></Map>
          </v-flex>
          <v-flex xs12 md5 mt-2>
            <v-flex>
              <v-layout row style="height: 70vh" class="elevation-1">
                <v-flex md12 style="overflow: auto">
                  <v-layout row>
                    <v-flex md12 xs10 column class="inlineBlock ml-2 mr-2">
                      <v-card
                        v-show="toggleTabsMap === 0"
                        flat
                        style="height: 60vh"
                        class="pa-4"
                      >
                        <v-layout align-center column fill-height class="pa-4">
                          <h2><i>{{$translate('SHOW_ROUTE')}} -tab-</i></h2>
                          <p>
                            {{$translate('TOURCREATION_MANUAL_DESC')}}
                          </p>
                          <h4>Stops</h4>
                          <p>
                            {{$translate('TOURCREATION_STOPS_DESC')}}

                          </p>
                          <v-layout row>
                            <v-icon color="#3CAEA3">fiber_manual_record</v-icon>
                            <h4>Pathpoints</h4>
                          </v-layout>
                          <p>
                            {{$translate('TOURCREATION_PATHPOINTS_DESC')}}
                          </p>
                          <h4>How-to</h4>
                          <p>
                            {{$translate('TOURCREATION_MANUAL_HOWTO')}}
                          </p>
                        <br/>
                          <h2><i>{{$translate('SHOW_WAYPOINTS')}} -tab-</i></h2>
                          <p>
                            {{$translate('TOURCREATION_AUTO_DESC')}}
                          </p>
                          <v-layout row>
                            <v-icon color="#ff8400">fiber_manual_record</v-icon>
                            <h4>Waypoints</h4>
                          </v-layout>
                          <p>
                            {{$translate('TOURCREATION_WAYPOINTS_DESC')}}
                          </p>
                          <h4>How-to</h4>
                          <p>
                            {{$translate('TOURCREATION_WAYPOINTS_HOWTO')}}
                          </p>
                        </v-layout>
                      </v-card>
                      <v-expansion-panel popout v-show="toggleTabsMap === 1">
                        <v-expansion-panel-content
                          lazy
                          v-for="(item,index) in polylineTableItems"
                          :key="index"
                          :id="'itemRow'+ index" class="itemRows">
<!--                          v-if="index !== 0 && index !== (polylineTableItems.length - 1)"-->
<!--                        >-->
                          <template  v-slot:header>
                            <v-flex md1>
                              <v-btn fab
                                     dark
                                     small
                                     :color="item.StopNr === -1 ? '#0c0c0c' : '#3CAEA3'"
                                     @click.native.stop="focusOnCoordinate([item.Longitude, item.Latitude], 'bigMap')">
                                <p v-if="item.StopNr !== -1">{{item.StopNr}}</p>
                              </v-btn>
                            </v-flex>
                            <v-flex md11>
                              <v-layout row justify-start>
                                <p
                                  v-if="item.Latitude !== null && item.Longitude !== null"
                                  class="ml-2"
                                  style="margin-bottom: 0 !important;">
                                  {{ item.Latitude.toFixed(5) + ', ' + item.Longitude.toFixed(5) }}
                                </p>
                                <v-layout  v-else row>
                                  <v-chip>Click on map.</v-chip>
                                  <v-btn color="error" v-if="stopAddingPathpointsButton" round
                                         @click.native.stop="stopAddingPathpoints()">Stop adding pathpoints
                                  </v-btn>
                                </v-layout>
                                <v-chip v-if="item.StopName !== ''">{{ item.StopName }}</v-chip>
                              </v-layout>
                            </v-flex>
                            <v-chip v-if="item.EventInfo.EventName !== ''">{{ item.EventInfo.EventName }}</v-chip>
                          </template>
                          <v-card>
                            <v-layout row ml-2>
                              <v-select
                                :items="['Point', 'Stop']"
                                v-model="item.Type"
                                style="margin-bottom: 0 !important; max-width: 200px;"
                                :disabled="item.Disabled"
                                @change="refreshPolyline(item)">
                              </v-select>
                              <v-btn :disabled="item.Disabled || disableTableItemsInteraction" fab dark small color="red" @click="deletePathPoint(index)">
                                <v-icon>delete</v-icon>
                              </v-btn>
                              <v-btn :disabled="item.Disabled && polylineTableItems[0] !== item || disableTableItemsInteraction" fab dark small color="green" @click="addWaypoint(index)">
                                <v-icon>add</v-icon>
                              </v-btn>
                            </v-layout>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                      <!--    end of polyline table   -->

                      <!--    waypoints table   -->
                      <v-card
                        v-if="waypointsTableItems.length === 0" v-show="toggleTabsMap === 2"
                        flat
                        style="height: 60vh"
                        class="pa-4"
                      >
                        <v-layout align-center justify-center column fill-height class="pa-4">
                          <h2>There are no waypoints</h2>
                          <p class="text-xs-center">
                            Click the button below to create waypoints.
                            When you are finished, Click the button 'stop adding waypoints'.
                            A new route will be generated with the waypoints as spots where the route has to pass or go
                            through.
                          </p>
                          <v-btn fab dark small color="green" @click="addWaypoint(0)">
                            <v-icon>add</v-icon>
                          </v-btn>
                        </v-layout>
                      </v-card>
                      <v-expansion-panel v-else popout v-show="toggleTabsMap === 2">
                        <v-expansion-panel-content
                          lazy
                          v-for="(item,index) in waypointsTableItems"
                          :key="index"
                          :id="'itemRow'+ index" class="itemRows">
                          <!--                          v-if="index !== 0 && index !== (polylineTableItems.length - 1)"-->
                          <!--                        >-->
                          <template  v-slot:header>
                            <v-flex md1>
                              <v-btn fab
                                     dark
                                     small
                                     color="#ff8400"
                                     @click.native.stop="focusOnCoordinate([item.Name.split(',')[0], item.Name.split(',')[1]], 'bigMap')">
                                <p>{{index + 1}}</p>
                              </v-btn>
                            </v-flex>
                            <v-flex md11>
                              <v-layout row justify-start>
                                <p
                                  v-if="item.Name !== 'Click on map.'"
                                  class="ml-2"
                                  style="margin-bottom: 0 !important;">
                                  {{ item.Name }}
                                </p>
                                <v-layout  v-else row>
                                  <v-chip>Click on map.</v-chip>
                                  <v-btn color="error" v-if="stopAddingPathpointsButton" round
                                         @click.native.stop="stopAddingWaypoints()">Stop adding waypoints
                                  </v-btn>
                                </v-layout>
                              </v-layout>
                            </v-flex>
                          </template>
                          <v-card>
                            <v-layout row>
                              <!--                              <v-select v-if="item.Type === 'Stop'"-->
                              <!--                                        item-text="EventName"-->
                              <!--                                        item-value="EventId"-->
                              <!--                                        return-object-->
                              <!--                                        :items="allEvents"-->
                              <!--                                        v-model="item.EventInfo"-->
                              <!--                                        style="margin-bottom: 0 !important"></v-select>-->
                              <v-btn :disabled="disableTableItemsInteraction" fab dark small color="red" @click="deleteWaypoint(item)">
                                <v-icon>delete</v-icon>
                              </v-btn>
                              <v-btn :disabled="disableTableItemsInteraction" fab dark small color="green" @click="addWaypoint(index)">
                                <v-icon>add</v-icon>
                              </v-btn>
                            </v-layout>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>

<!--                      <v-data-table-->
<!--                        v-show="!togglePolylineOrWaypoints"-->
<!--                        style="height: 70vh;"-->
<!--                        :headers="waypointsHeader"-->
<!--                        :items="waypointsTableItems"-->
<!--                        item-key="Id"-->
<!--                        hide-actions-->
<!--                        v-sortable-table-->
<!--                        class="elevation-1"-->
<!--                        @sorted="dragOrder"-->
<!--                      >-->
<!--                        <template slot="headers" slot-scope="props" width="100%">-->
<!--                          <tr width="100%">-->
<!--                            <th class="text-xs-center" colspan="4">Waypoints</th>-->
<!--                          </tr>-->
<!--                          <tr class="grey lighten-3">-->
<!--                            <th class="text-xs-left startEndLocationTextTable" colspan="3">-->
<!--                              {{-->
<!--                              tableStartLocation}}-->
<!--                            </th>-->
<!--                          </tr>-->
<!--                        </template>-->
<!--                        <template slot="items" slot-scope="props" style="overflow: auto">-->
<!--                          <tr :id="'itemRow'+ props.item.StopId" class="itemRows">-->
<!--                            <td-->
<!--                            @mouseover="showByIndex = props.index"-->
<!--                              @mouseout="showByIndex = null"-->
<!--                            >-->
<!--                              <v-layout align-center fill-height>-->
<!--                                <v-icon-->
<!--                                  style="margin-left: -10px"-->
<!--                                  v-show="showByIndex === props.index &&-->
<!--                                          disableTableItemsInteraction === false"-->
<!--                                  medium-->
<!--                                  color="secondary"-->
<!--                                  @click="addWaypoint(props.item.Id)"-->
<!--                                >add_box</v-icon>-->
<!--                                <p style="margin-bottom: 0 !important;">{{ props.item.Name }}-->
<!--                                  <v-icon v-if="props.item.name !== ''" style="cursor: pointer" @click.native.stop="focusOnCoordinate([props.item.Name.split(',')[0], props.item.Name.split(',')[1]], 'bigMap')">-->
<!--                                    place-->
<!--                                  </v-icon>-->
<!--                                </p>-->
<!--                                <v-btn  v-if="props.item.Name === 'Click on map.'" color="error" round-->
<!--                                       @click.native.stop="stopAddingWaypoints()">Stop adding waypoints-->
<!--                                </v-btn>-->
<!--                              </v-layout>-->
<!--                            </td>-->
<!--                            <td width="4%" class="tableIcons">-->
<!--                              <v-icon medium @click="deleteWaypoint(props)">delete</v-icon>-->
<!--                            </td>-->
<!--                            <td width="4%" class="tableIcons">-->
<!--                              <v-icon class="dragIcon">drag_indicator</v-icon>-->
<!--                            </td>-->
<!--                          </tr>-->
<!--                        </template>-->
<!--                        <template slot="footer" width="100%">-->
<!--                          <tr class="grey lighten-3">-->
<!--                            <th class="text-xs-left startEndLocationTextTable">{{ tableEndLocation}}</th>-->
<!--                            <th></th>-->
<!--                            <th></th>-->
<!--                          </tr>-->
<!--                        </template>-->
<!--                        <template v-slot:no-data>-->
<!--                          <tr v-if="!changingRoute">-->
<!--                            <td colspan="4">-->
<!--                              <v-alert :value="true" color="primary" icon="warning">-->
<!--                                <v-layout justify-center column align-center>-->
<!--                                  <p-->
<!--                                    class="text-xs-center"-->
<!--                                  >Click the "plus" button to create a waypoint.</p>-->
<!--                                  <v-btn-->
<!--                                    fab-->
<!--                                    dark-->
<!--                                    color="secondary"-->
<!--                                    small-->
<!--                                    @click="addWaypoint()"-->
<!--                                    :disabled="disableTableItemsInteraction"-->
<!--                                  >-->
<!--                                    <v-icon dark>add</v-icon>-->
<!--                                  </v-btn>-->
<!--                                </v-layout>-->
<!--                              </v-alert>-->
<!--                            </td>-->
<!--                          </tr>-->
<!--                          <tr v-else>-->
<!--                            <td colspan="4">-->
<!--                              <v-alert :value="true" color="lightGray" icon="warning">-->
<!--                                <v-layout justify-center column align-center>-->
<!--                                  <p-->
<!--                                    class="text-xs-center"-->
<!--                                  >Loading new order..</p>-->
<!--                                </v-layout>-->
<!--                              </v-alert>-->
<!--                            </td>-->
<!--                          </tr>-->
<!--                        </template>-->
<!--                      </v-data-table>-->
                      <!--    end of waypoints table   -->
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-flex>
            <!-- <v-flex>
            <v-card
              class="elevation-1 ml-4"
              id="myposition"
            >
            <v-card-title><h2>Route map</h2></v-card-title>
            <v-divider></v-divider>
            <v-divider></v-divider>
            <v-divider class="mb-4"></v-divider>
            <v-card class="routeMapCard elevation-0 ml-4 mr-4">
            <v-card v-for="item in finalRoute" :key="item">
            <v-card-title>{{item}}</v-card-title>-->

            <!-- <v-layout align-center justify-end row>
              <v-card-actions><v-btn  v-if="(item !== 'Waypoint A' && item !== 'Waypoint B')" @click="toDeleteMarker = item" class="deleteMarkerBtn" flat round :disabled="disablePlusMarkerBtn"><v-icon>remove</v-icon></v-btn></v-card-actions>
            </v-layout>-->

            <!-- </v-card>
            </v-card>
            <v-btn round flat :disabled="disablePlusMarkerBtn" @click="addMarkerToRoute()"><v-icon>add</v-icon></v-btn>
            </v-card>
            </v-flex>-->
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" round @click="cancelRelayEditor()">Cancel</v-btn>
          <v-btn
            color="primary"
            round
            @click="saveRelayEditor()"
            :disabled="disableTableItemsInteraction"
          >Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="mapDialogWarning" persistent max-width="300">
      <v-card>
        <v-card-title class="headline" :style="`color: ${$vuetify.theme.primary}`">Warning</v-card-title>
        <v-card-text>
          <h3>In order to configure the waypoint, please fill in the start location, end location and travel mode.</h3>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            round
            class="text-capitalize"
            @click.native="mapDialogWarning = false"
          >{{$translate('CANCEL')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="relayEditorDialogWarning" max-width="300">
      <v-card>
        <v-card-title class="headline" :style="`color: ${$vuetify.theme.primary}`">Warning</v-card-title>
        <v-card-text>
          <h3>You have unsaved changes. If you cancel your unsaved changes will be deleted. Are you sure that you want to cancel?</h3>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="secondary"
            round
            class="text-capitalize"
            @click.native="relayEditorDialogWarning = false"
          >{{$translate('NO')}}</v-btn>
          <v-btn
            color="secondary"
            round
            class="text-capitalize"
            @click="cancelRelayEditor()"
          >{{$translate('YES')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Dialog to configure product categories -->
    <ProductCategoriesDialog
      v-if="showProductCategoriesDialog"
      :productCategoriesProp="productCategoryList"
      :eventId="eventCreationForm.eventId"
      @product-categories-dialog-closed="productCategoriesDialogClosedHandler"
      @product-categories-updated="productCategoriesUpdatedHandler"
    />
  </div>
</template>

<script>
import EventImageLoader from "@/components/media/EventImageLoader";
import MultipleImageLoader from "@/components/media/MultipleImageLoader";
import LocationObject from "@/objects/LocationObject";
import _ from "lodash";
import ExpendableTags from "@/components/ExpendableTags";
import Events_Languages from "@/components/Events/Events_Languages";
import Events_Editing from "@/components/Events/Events_Editing";
import draggable from "vuedraggable";
import Sortable from "sortablejs";
import { mapGetters } from "vuex";
import * as ol from "openlayers";
import BaseComponent from "./base/BaseComponent.vue";
import BaseObject from "../objects/BaseObject";
import EventAudioLoader from "./media/EventAudioLoader";
import { ui_helpers } from "../shared/ui_helpers.js";
import * as dssRequest from "../api/dssRequest";
import appConfig from "../../config/app_config";
import CreateEventCreationObject from "../objects/CreateEventCreationObject.js";
import OperationalScreen_BaseQuadrant from "./OperationalScreen/OperationalScreen_BaseQuadrant";
import OperationalScreen_MapQuadrant from "./OperationalScreen/OperationalScreen_MapQuadrant";
import Map from "../Maps/Map.vue";
import MapObject from "../Maps/MapObject";
import Generic_Translations from "./Generic_Translations";
import DeliveryFeesDialogComponent from "./EventCreationDialogues/DeliveryFeesDialog.vue";
import CategoriesTree from "@/components/CategoriesTree";
import RelatedEventsDialog from "@/components/RelatedEventsDialog";
import ProductCategoriesDialog from "@/components/ProductCategoriesDialog";

export default {
  extends: BaseComponent,
  OperationalScreen_BaseQuadrant,
  mixins: [ui_helpers],
  name: "EventCreation",

  props: {
    properties: Object,
  },
  watch: {
    polylineTableItems: {
      handler(data) {
        let nr = 0;
        data.forEach((item) => {
          if (item.Type === "Stop") {
            nr += 1;
            item.StopNr = nr;
          } else if (item.Type === "Point" && item.StopNr !== -1) {
            item.StopNr = -1;
            item.StopName = "";
            item.EventInfo.EventName = -1;
            item.EventInfo.EventName = "";
            item.EventInfo.ThumbnailPicture = "";
          }
        });
      },
      deep: true,
    },
    'endTime': function(newV, oldV) {
      if(this.chosenStartDate === this.chosenEndDate) {
        if(this.startTime.split(':') >= this.endTime.split(':')) {
          console.log("Lorenzo ze zijn gelijk aan elkaar", );
          this.endTimeIncorrect = true;
        } else {
          this.endTimeIncorrect = false;
        }
      }
    },
    // Now you don't have to click on the booking policy button and the ticket types button
    newEventId(newV, oldV) {
      if (newV != oldV) {
        this.getPolicies();
        this.getPriceCategories();
      }
    },
    // waypointRoute(newV, oldV) {
    //   if (oldV.length !== 0 && this.disablePlusMarkerBtn) {
    //   window.EventBus.fire("enableWaypointInteraction", false);
    //   this.createCardsOfWaypoints(newV);
    //   }
    // },
    // relayData: {
    //   handler(data) {
    //     setTimeout(() => {
    //       this.disablePlusMarkerBtn = false;
    //     }, 10);
    //   },
    //   deep: true
    // },
    externallyPriced(newV, oldV) {
      if ((newV = true)) {
        this.savePriceCategories();
      }
    },
    discountCardDialog(val) {
      val || this.close();
    },
    productCategoriesDialog(val) {
      val || this.closeProductCategories;
    },
    eventRewardsDialog(val) {
      val || this.closeRewardsDialog();
    },
    addPriceCategoriesDialog(val) {
      val || this.closeAddPriceCategoriesDialog();
    },
    themesDialog(val) {
      val || this.closeThemesDialog();
    },
    userTourList: {
      handler(data) {
        this.userSelectionForTour = [];
        this.userTourList.forEach((item, index, array) => {
          item.seqNr = index + 1;
        });
      },
      deep: true,
    },
    // polylineTableItems: {
    //   handler(data) {
    // TODO selection dor multiple waypoint to delete should be emptied here
    //     this.polylineTableItems.forEach(function(item, index, array) {
    //       item.seqNr = index + 1;
    //     });
    //     this.waypoint .forEach(function(item, index, array) {
    //       item.seqNr = index + 1;
    //     });
    //   },
    //   deep: true
    // }
  },
  computed: {
    computedDateFormattedEndDate() {
      return this.formatDate(this.chosenEndDate);
    },
    computedDateFormattedStartDate() {
      return this.formatDate(this.chosenStartDate);
    },
    formTitle() {
      return this.editedIndex === -1 ? "Add card" : "Edit card";
    },
    formProductCategoryTitle() {
      return this.editedProductCategoryIndex === -1
        ? "Add product category"
        : "Edit product category";
    },
    formThemeTitle() {
      return this.editedThemeIndex === -1 ? "Assign reward" : "Edit reward";
    },
    extraLocationsFormTitle() {
      return this.editedExtraLocationIndex === -1
        ? "Assign extra location"
        : "Edit extra location";
    },
    formTicketTitle() {
      return this.editedPriceCategoriesIndex === -1
        ? "New ticket type"
        : "Edit ticket type";
    },
    formDeliveryFeeTitle() {
      return this.editedDeliveryFeeIndex === -1
        ? "New delivery fee"
        : "Edit delivery fee";
    },
    formPoliciesTitle() {
      return this.editedPoliciesIndex === -1 ? "New policy" : "Edit policy";
    },
    formRewardTitle() {
      return this.editedRewardIndex === -1
        ? "Add reward level"
        : "Edit reward level";
    },
  },
  components: {
    EventAudioLoader,
    EventImageLoader,
    MultipleImageLoader,
    ExpendableTags,
    "Events-Languages": Events_Languages,
    Events_Editing,
    draggable,
    OperationalScreen_MapQuadrant,
    Map,
    Generic_Translations,
    DeliveryFeesDialogComponent,
    CategoriesTree,
    RelatedEventsDialog,
    ProductCategoriesDialog
  },
  data() {
    return {
      endTimeIncorrect: false,
      endTime: '',
      startTime: '',
      menu2: '',
      menu1: '',
      today: '',
      chosenEndDate: '',
      chosenStartDate: '',
      //Extra locations
      extraLocationsDialog: false,
      extraLocationToEvent: false,
      potentialExtraLocations: [],
      eventExtraLocationsSelected: [],
      extraLocations: [],
      editedExtraLocationIndex: -1,
      editedExtraLocationItem: {
        LocationId: "",
        Key: "",
        Name: "",
        Capacity: 0,
      },
      defaultExtraLocationItem: {
        Key: "",
        Name: "",
        Capacity: 0,
      },
      extraLocationsHeader: [
        {
          text: "Location",
          align: "left",
          sortable: false,
          value: "Name",
        },
        { text: "Capacity", value: "Capacity", sortable: false },

        { text: "Actions", value: "Name", sortable: false },
      ],
      // End of extra locations
      productCategoriesTranslations: {},
      productCategoriesColumns: [],
      openProductCategoriesTranslations: false,

      selectedPriceCategory: {},
      priceCategoryTranslations: {},
      priceCategoryColumns: [],
      openPriceCategoryTranslations: false,

      // external events
      externalEvents: [],
      externalPlatforms: ["Formitable", "LeisureKing", "TicketCounter"],

      oneStopAvailable: true,
      package: "",
      gpxInput: "",
      showImport: false,

      changingRoute: false,
      allEvents: [],
      vat: [
        {
          Name: "None",
        },
        {
          Name: "Low",
        },
        {
          Name: "High",
        },
      ],
      toDeleteMarker: "",
      waypointRoute: [],
      finalRoute: [],
      users: [],
      showSelectedUserGroups: ["UserGroup"],
      nextButton: false,
      partnerIsActive: false,
      sub: "sub",
      tour: "tour",
      alt: "alt",
      sug: "sug",
      // Relay map dialog
      mapDialog: false,
      mapDialogWarning: false,
      relayEditorDialogWarning: false,
      toggleTabsMap: 0,

      // Properties for configuring map
      smallMap: {},
      smallMapSettings: {
        name: "smallMap",
        view: {
          zoom: 9,
        },
        interactions: {
          doubleClickZoom: false,
          dragAndDrop: false,
          dragPan: false,
          keyboardPan: false,
          keyboardZoom: false,
          mouseWheelZoom: false,
          pointer: false,
          select: false,
        },
        controls: {
          zoomControls: false,
          filterOption: false,
        },
        style: "width: 100%; height: calc(35vh); margin-bottom: 3em;",
      },
      bigMapSettings: {
        name: "bigMap",
        view: {
          zoom: 9,
        },
        interactions: {
          doubleClickZoom: false,
          dragAndDrop: true,
          dragPan: true,
          keyboardPan: true,
          keyboardZoom: true,
          mouseWheelZoom: true,
          pointer: true,
          select: true,
        },
        controls: {
          zoomControls: true,
          filterOption: false,
        },
        style: "width: 100%; height: calc(71vh); margin-top: 5px;",
      },
      locationProps: {
        component: "OperationalScreen_MapQuadrant",
        componentId: "OperationalScreen_MapQuadrant_MAPOFINCIDENT",
        fullSize: true,
        hidden: false,
        location: {},
        mainMap: false,
        name: "OperationalScreen_MapQuadrant_NPSTNJ",
        params: {
          route: {},
          location: {
            latitude: "53.080380",
            longitude: "4.800127",
            polyline: "",
            waypoints: "",
            stops: "",
          },
        },
        pinned: true,
        position: {
          x: 0,
          y: 0,
        },
        profile: {
          connect: false,
          default: false,
          landing: true,
          relink: true,
          style: {
            height: "big",
          },
        },
        showBackButton: true,
        showToolbar: false,
        signalObjectMap: [],
        tag: "",
        interaction: false,
        tooltip: false,
        rightClick: false,
        includeCenterPoint: false,
        zoomControls: false,
      },

      locationProps2: {
        component: "OperationalScreen_MapQuadrant",
        componentId: "OperationalScreen_MapQuadrant_MAPOFINCIDENT",
        fullSize: true,
        hidden: false,
        location: {},
        mainMap: false,
        name: "OperationalScreen_MapQuadrant_NPSTNJ",
        params: {
          route: {
            BoundingBox: {
              LatBottomLeft: "",
              LatTopRight: "",
              LonBottomLeft: "",
              LonTopRight: "",
            },
            Duration: "",
            EndLatitude: "",
            EndLocationId: "",
            EndLongitude: "",
            PathPoints: [],
            TravelMode: "",
            Distance: "",
          },
          location: {
            latitude: "53.080380",
            longitude: "4.800127",
            polyline: "",
            waypoints: "",
            stops: "",
          },
        },
        pinned: true,
        position: {
          x: 0,
          y: 0,
        },
        profile: {
          connect: false,
          default: false,
          landing: true,
          relink: true,
          style: {
            height: "big",
          },
        },
        height: "height: 70vh",
        showBackButton: true,
        showToolbar: false,
        signalObjectMap: [],
        tag: "",
        interaction: true,
        tooltip: false,
        rightClick: false,
        includeCenterPoint: false,
        clickEvent: true,
      },

      // Relay Save Variables
      relayData: { waypoints: "", stops: "" },
      polylineOrderResult: [],
      waypointsOrderResult: [],
      EndLocationCoordinate: "",
      StartLocationCoordinate: "",
      disableTableItemsInteraction: false,
      publicTransportStops: [],

      showByIndex: null,

      // Travelmode types
      transportationTypes: [],

      // Event types
      types: [
        "Standard",
        "Promotion",
        "PartnerPromotion",
        "FlexEvent",
        "Fixed",
        "Repetitive",
        "Theme",
        "Tour",
        "Rental",
        "External",
        "Webshop",
        "Delivery",
        "PickUp",
      ],
      // timeWindowType: ["Fixed", "Repetitive"],
      // durationTypes: ["Fixed", "Flexible"],
      disableDurationType: false,

      // Tour variables
      eventTourDialog: false,
      categoriesDialogForTour: false,
      userTourList: [],
      selectedTagsInArrayForTourActivities: [],
      tourPreselection: [],
      selectedTourTags: [],
      selectedTourActivities: [],
      tourList: [],
      userSelectionForTour: [],

      // Subactivities variables
      categoriesDialogForSubActivities: false,
      subActivitiesPreselection: [],
      selectedSubActivities: [],
      subActivitiesList: [],
      subActivitiesDialog: false,
      selectedSubActivitiesTags: [],
      selectedTagsInArrayForSubActivities: [],
      userSubActivitiesList: [],
      userSelectionForSubActivities: [],

      allSelectedEvents: [],
      allSelectedUserEvents: [],

      // Alternatives variables
      selectedAlternativesTags: [],
      categoriesDialogForAlternatives: false,
      eventAlternativesDialog: false,
      selectedTagsInArrayForAlternatives: [],
      alternativesPreselection: [],
      selectedAlternatives: [],
      userAlternativesList: [],
      alternativesList: [],
      userSelectionForAlternatives: [],

      // Suggestions variables
      selectedSuggestionsTags: [],
      categoriesDialogForSuggestions: false,
      eventSuggestionsDialog: false,
      selectedTagsInArrayForSuggestions: [],
      suggestionsPreselection: [],
      selectedSuggestions: [],
      userSuggestionsList: [],
      suggestionsList: [],
      userSelectionForSuggestions: [],

      // Delivery fees
      eventDeliveryFees: [],
      deliveryFeesDialog: false,
      addDefaultDeliveryFeeDialog: false,
      defaultDeliveryFee: {},
      addDeliveryFeeDialog: false,
      editDeliveryFee: false,
      editedDeliveryFeeIndex: -1,
      editedDeliveryFeeItem: {},
      deliveryFeeHeaders: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "Name",
        },
        { text: "Price", value: "Price", sortable: false },
        { text: "Actions", value: "Name", sortable: false },
      ],

      // Price categories
      priceCategoriesDialog: false,
      externallyPriced: false,
      addPriceCategoriesDialog: false,
      editPriceCategorie: false,
      eventPriceCategories: [],
      editedPriceCategoriesIndex: -1,
      editedPriceCategoriesItem: {},
      priceCategoriesHeaders: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "Name",
        },
        { text: "Capacity managed", value: "CapacityManaged", sortable: false },
        {
          text: this.$translate("PRICECATEGORY_MIN_QUANTITY"),
          value: "MinimumQuantity",
          sortable: false,
        },
        {
          text: this.$translate("PRICECATEGORY_MAX_QUANTITY"),
          value: "MaximumQuantity",
          sortable: false,
        },
        { text: "Actions", value: "Name", sortable: false },
      ],

      // Policies
      policiesDialog: false,
      addPoliciesDialog: false,
      editPolicies: false,
      eventPolicies: [],
      editedPoliciesIndex: -1,
      editedPoliciesItem: {},
      policiesHeaders: [
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "Name",
        },
        { text: "Description", value: "Description", sortable: false },
        { text: "Time out", value: "Timeout", sortable: false },
        { text: "Actions", value: "Name", sortable: false },
      ],
      allRoutes: [],
      cleanFilters: false,
      cleanTheFilters: false,
      saveEventFirstDialog: false,
      // checkboxSelected: false,
      showEventLanguages: false,
      newEventId: null,
      setEventName: "",
      preselection: [],
      largeSize: false,
      expTagProp: {
        disable: false,
      },
      accounts: [],
      potentialThemes: [],
      accountsSelected: [],
      rewardsSelected: [],
      themesSelected: [],
      selectedTags: [],
      userDiscountCards: [],
      userProductCategories: [],
      eventRewards: [],
      chosenCard: {},
      eventCreationForm: CreateEventCreationObject._objectDefinition(),
      form: {
        accountDescription: "",
        logo: null,
        image: null,
        preferences: {},
      },
      eventDescription: [],
      imageName: "",
      backupData: {},
      imageUrl: "",
      locations: [],
      valid: true,
      errorDialog: false,
      departureAudioName: "",
      arrivalAudioName: "",
      discountCards: [],
      productCategories: [],
      themes: [],
      rewards: [],
      eventRewardsSelected: [],
      newCard: false,
      newProductCategory: false,
      themeToEvent: false,
      newRewardLevel: false,
      properties2: {
        title: "Background",
        signalName: "load_image",
        deletable: false,
        pictureUrl: "",
        maxWidth: appConfig.maxSize.home.w,
        maxHeight: appConfig.maxSize.home.h,
        scale: "w",
      },
      multiPicturesProperties: {
        title: "Background",
        signalName: "load_image",
        deletable: false,
        pictureUrl: [],
        maxWidth: appConfig.maxSize.home.w,
        maxHeight: appConfig.maxSize.home.h,
        scale: "w",
      },
      audioProp2: {
        title: "Departure audio message",
        signalName: "selectAudio2Element",
        audioName: "",
        audioUrl: "",
      },
      audioProp1: {
        title: "Arrival audio message",
        signalName: "selectAudio1Element",
        audioName: "",
        audioUrl: "",
      },
      // Rules
      eventNameRule: [(v) => !!v || "A name for the event is required"],
      eventTypeRule: [(v) => !!v || "A type for the event is required"],
      eventTimeWindowTypeRule: [
        (v) => !!v || "A time-window type for the event is required",
      ],
      eventDurationTypeRule: [
        (v) => !!v || "A duration type for the event is required",
      ],
      eventLocationRule: [(v) => !!v || "A location for the event is required"],
      eventCapacityRule: [(v) => !!v || "A capacity for the event is required"],
      eventPartnerRule: [(v) => !!v || "A partner for the event is required"],
      eventLeadTimeRule: [
        (v) => !!v || "A lead time for the event is required",
      ],
      eventCoolTimeRule: [
        (v) => !!v || "A cool down time for the event is required",
      ],
      eventTravelModeRule: [
        (v) => v > -1 || "A Travelmode for the event is required",
      ],

      discountCardDialog: false,
      productCategoriesDialog: false,
      eventRewardsDialog: false,
      themesDialog: false,
      headers: [
        {
          text: "Discount card",
          align: "left",
          sortable: false,
          value: "Name",
        },
        { text: "Discount %", value: "DiscountPercentage", sortable: false },

        { text: "Actions", value: "Name", sortable: false },
      ],
      productCategoryHeaders: [
        {
          text: "Description",
          align: "left",
          sortable: false,
          value: "Description",
        },
        {
          text: "Actions",
          align: "right",
          value: "Description",
          sortable: false,
        },
      ],
      waypointsHeader: [
        {
          text: "Waypoints",
          align: "center",
          sortable: false,
          value: "name",
        },
      ],
      rewardsHeaders: [
        {
          text: "Event",
          align: "left",
          sortable: false,
          value: "Name",
        },
        { text: "Reward level", value: "RewardLevel", sortable: false },

        { text: "Actions", value: "Name", sortable: false },
      ],
      themeHeaders: [
        {
          text: "Theme",
          align: "left",
          sortable: false,
          value: "Name",
        },
        { text: "Reward points", value: "Reward", sortable: false },

        { text: "Actions", value: "Name", sortable: false },
      ],
      editedIndex: -1,
      editedRewardIndex: -1,
      editedThemeIndex: -1,
      editedProductCategoryIndex: -1,
      editedProductCategoryItem: {
        Id: 0,
        Description: "",
      },
      editedRewardItem: {
        Id: 0,
        Name: "",
        Points: 0,
      },
      tableStartLocation: "",
      tableEndLocation: "",
      expand: false,
      polylineTableItems: [],
      waypointsTableItems: [],
      defaultRewardItem: {
        Id: 0,
        Name: "",
        Reward: 0,
      },
      editedThemeItem: {
        Key: "",
        Name: "",
        RewardLevel: 0,
      },
      defaultThemeItem: {
        key: "",
        Name: "",
        RewardLevel: 0,
      },
      editedItem: {
        Key: 0,
        Name: "",
        DiscountPercentage: 0,
      },
      defaultItem: {
        Key: 0,
        Name: "",
        DiscountPercentage: 0,
      },
      defaultProductCategoryItem: {
        Id: 0,
        Description: "",
      },
      fab: false,
      stopAddingPathpointsButton: false,
      startLocationId: "",
      endLocationId: "",
      generateRouteButton: false,
      eventCategoriesAll: [],
      eventCategoriesSelected: [],
      categoryFiltersAll: [],
      categoryFiltersSelected: [],
      possibleRelatedEvents: [], // Possible related events to be selected
      relatedEventsToBeSaved: [], // Related events selected by user
      showRelatedEventsDialog: false,
      showProductCategoriesDialog: false,
      productCategoryList: []
    };
  },
  created() {
    window.EventBus.listen("dataForComponent", this.manageDataForComponent);
    window.EventBus.listen("disableDrawPolyline", this.disableDrawPolyline);
    window.EventBus.listen("selectWaypoint", this.selectWaypoint);
  },
  beforeDestroy() {
    this.$store.commit("setUserIsCreatingEvent", false);
    window.EventBus.removeListener(
      "dataForComponent",
      this.manageDataForComponent
    );
    window.EventBus.removeListener(
      "disableDrawPolyline",
      this.disableDrawPolyline
    );
    window.EventBus.removeListener("selectWaypoint", this.selectWaypoint);
  },
  mounted() {
    const toTwoDigits = (num) => (num < 10 ? `0${num}` : num);
    const today = new Date();
    const year = today.getFullYear();
    const month = toTwoDigits(today.getMonth() + 1);
    const day = toTwoDigits(today.getDate());
    this.today = `${year}-${month}-${day}`;
    console.log("Lorenzo this.today", this.today);
    // this.getRouteAspectData();
    this.$store.getters.getRouteEvents.forEach((e) => {
      this.allEvents.push({ EventId: Number(e.eventId), EventName: e.name });
    });

    this.$store.commit("setUserIsCreatingEvent", true);
    // this.VatId = this.$store.getters.getAccountVat;
    this.tourInputCheck();
    this.SettingFormEventPartner();
    this.getAllLocations();
    this.checkEditCondition();
    this.getAccounts();
    this.getTransportationTypesForRelays();
    // this.setInputForCheckbox();
    this.getPartners();
    this.getEvents();
    this.getExtraLocations();
    console.log("Lorenzo this.eventCreationForm", this.eventCreationForm);
    this.eventExtraLocationsSelected = Object.values(
      this.eventCreationForm.locations
    );
    if(this.eventCreationForm.hasOwnProperty("externalEventInfo") && this.eventCreationForm.externalEventInfo !== undefined) {
      this.eventCreationForm.externalPlatform = this.eventCreationForm.externalEventInfo.eventBridge;
      this.eventCreationForm.externalEvent = {
        externalId: this.eventCreationForm.externalEventInfo.externalId,
        externalName: this.eventCreationForm.externalEventInfo.externalName,
      };
    }
    if (this.eventCreationForm.type === "External")
      this.getExternalEventsForPartner();
  },
  directives: {
    sortableTable: {
      bind(el, binding, vnode) {
        const sortableElement = el.getElementsByTagName("tbody")[0];
        const options = {
          animation: 150,
          disabled: false,
          onUpdate(event) {
            vnode.child.$emit("sorted", event);
          },
        };
        Sortable.create(sortableElement, options);
      },
    },
  },
  methods: {
    getExternalEventsForPartner() {
      console.log("Brian this.eventCreationForm", this.eventCreationForm);

      if (this.eventCreationForm.type !== "External") return;
      if (
        this.eventCreationForm.externalPlatform === "" ||
        this.eventCreationForm.eventPartner === "" ||
        this.eventCreationForm.externalPlatform === undefined ||
        this.eventCreationForm.eventPartner === undefined
      ) {
        return;
      }
      let request = "";
      if (
        this.properties.params !== null &&
        this.eventCreationForm.eventPartner.hasOwnProperty("id")
      )
        request = this.eventCreationForm.eventPartner.id;
      else request = this.eventCreationForm.eventPartner;
      const payload = {
        EventBridge: this.eventCreationForm.externalPlatform,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call getExternalEventsForPartner on EventCreation.vue was successful",
            response
          );
          if (!_.isEmpty(response.data.ExternalEvents)) {
            this.externalEvents = Object.values(response.data.ExternalEvents);
            this.externalEvents.forEach((externalEvent) => {
              externalEvent.externalId = externalEvent.ExternalId;
              externalEvent.externalName = externalEvent.ExternalName;
              delete externalEvent.ExternalId;
              delete externalEvent.ExternalName;
            });
          }
          console.log("Lorenzo this.externalEvents", this.externalEvents);
        },
        (error) => {
          console.log(
            "The generic call getExternalEventsForPartner on EventCreation.vue was not successful",
            error
          );
        },
        "getExternalEventsForPartner",
        `${this.$store.getters.getCurrentAccountId}_UG_${request}`,
        payload
      );
    },
    getTransportationTypesForRelays() {
      const payload = {};
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call getTransportationTypesForRelays was successful",
            response
          );
          this.transportationTypes = [];
          for (const key in response.data.TransportModes) {
            this.transportationTypes.push({
              name: key,
              travelModeVal: response.data.TransportModes[key],
            });
          }
        },
        (error) => {
          console.log(
            "The generic call getTransportationTypesForRelays was not successful",
            error
          );
        },
        "getTransportationTypesForRelays",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    getExtraLocations() {
      // Method to get all the locations

      const payload = {};
      dssRequest.doRequest(
        (response) => {
          console.log("The generic call getLocations was successful", response);
          if (response.data.Locations.length > 0) {
            response.data.Locations.forEach((e) => {
              this.extraLocations.push(e);
            });
          } else {
            this.extraLocations = [];
          }
        },
        (error) => {
          console.log(
            "The generic call getLocations was not successful",
            error
          );
        },
        "getLocations",
        this.$store.getters.getCurrentAccountId + "_LSE",
        payload
      );
    },
    formatDate(date) {
      // Formatting the date to right output
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    getEvents() {
      // Method to get all the themes for current account
      let userLanguage = 0;
      if (this.$store.getters.getUserLanguage !== "") {
        userLanguage = this.$store.getters.getUserLanguage;
      }
      const payload = {
        LanguageTagId: Number(userLanguage),
      };
      dssRequest.doRequest(
        (response) => {
          console.log("The generic call getEvents was successful", response);

          this.themes = [];
          if (!_.isEmpty(response.data.Events)) {
            delete response.data.Events.Children;
            for (const [key, value] of Object.entries(response.data.Events)) {
              this.rewards.push({ key, ...value });
              this.themes.push({ key, ...value });
            }
          } else {
            this.themes = [];
            console.log("  Received data is empty ");
          }
        },
        (error) => {
          console.log("The generic call getEvents was not successful", error);
        },
        "getEvents",
        "LocationsNode_ESE",
        payload
      );
    },
    addNewCard() {
      if (this.newEventId == null) {
        this.saveEventFirstDialog = true;
      } else {
        this.getDiscountCards();
        this.newCard = true;
      }
    },
    addNewProductCategory() {
      if (this.newEventId == null) {
        this.saveEventFirstDialog = true;
      } else {
        this.newProductCategory = true;
      }
    },
    addExtraLocationToEvent() {
      if (this.newEventId == null) {
        this.saveEventFirstDialog = true;
      } else {
        this.getLocationsForExtraLocations();
        this.extraLocationToEvent = true;
      }
    },
    addRewardToEvent() {
      if (this.newEventId == null) {
        this.saveEventFirstDialog = true;
      } else {
        this.getPotentialEvents();
        this.themeToEvent = true;
      }
    },
    addRewardLevel() {
      if (this.newEventId == null) {
        this.saveEventFirstDialog = true;
      } else {
        this.getEventRewards();
        this.newRewardLevel = true;
      }
    },
    getLocationsForExtraLocations() {
      this.potentialExtraLocations = [];
      if (this.eventExtraLocationsSelected.length !== 0) {
        this.extraLocations.forEach((e) => {
          if (
            this.eventExtraLocationsSelected.find(
              (chosen) => chosen.Name === e.Name
            ) == null
          ) {
            this.potentialExtraLocations.push(e);
          } else {
          }
        });
      } else {
        this.potentialExtraLocations = this.extraLocations;
      }
    },
    getPotentialEvents() {
      this.potentialThemes = [];
      if (this.eventRewardsSelected.length !== 0) {
        this.rewards.forEach((e) => {
          if (
            this.eventRewardsSelected.find(
              (chosen) => chosen.Name === e.Name
            ) == null
          ) {
            this.potentialThemes.push(e);
          } else {
          }
        });
      } else {
        this.potentialThemes = this.rewards;
      }
    },
    relayEditorDialogUnsavedChanges() {
      // let result = this.locationProps2.params.location.polyline.localeCompare(
      //   this.relayData.path
      // );
      // if (result !== 0) {
      //   this.relayEditorDialogWarning = true;
      // } else {
      this.mapDialog = false;
      // }
    },
    cancelRelayEditor() {
      this.package = "";
      console.log("test", this.backupData);
      this.disableTableItemsInteraction = false; // unable to change data in the relay editor.
      this.mapDialog = false;
      this.relayEditorDialogWarning = false;
      if (this.backupData.hasOwnProperty("DataFieldTable")) {
        this.locationProps.params.route = _.cloneDeep(this.backupData);
        const waypointsArray = this.backupData.DataFieldTable.Waypoints.split(
          " "
        );
        this.polylineTableItems = [];
        this.polylineOrderResult = [];
        this.waypointsTableItems = [];
        this.waypointsOrderResult = [];
        this.polylineTableItems = _.cloneDeep(
          this.backupData.DataFieldTable.PathPoints
        );
        this.polylineOrderResult = _.cloneDeep(
          this.backupData.DataFieldTable.PathPoints
        );

        if (this.backupData.DataFieldTable.Waypoints !== "") {
          for (let index = 0; index < waypointsArray.length; ++index) {
            this.waypointsTableItems.push({
              Name: waypointsArray[index],
              Id: index + 1,
            });
            this.waypointsOrderResult.push({
              Name: waypointsArray[index],
              Id: index + 1,
            });
          }
        }
      }
      setTimeout(() => {
        // window.EventBus.fire('generateTourPoints', { routeAspects: [this.backupData], disableChangeView: false });
        this.showTourOnMap(
          "smallMap",
          this.backupData.DataFieldTable,
          false,
          true
        );
      }, 500);
    },
    saveRelayEditor() {
      this.package = "";
      this.allEvents = [];
      this.$store.getters.getRouteEvents.forEach((e) => {
        this.allEvents.push({ EventId: Number(e.eventId), EventName: e.name });
      });
      this.backupData = _.cloneDeep(this.locationProps.params.route);
      this.mapDialog = false;

      // window.EventBus.fire('generateTourPoints', { routeAspects: [this.locationProps.params.route], disableChangeView: false });
      this.showTourOnMap(
        "smallMap",
        this.locationProps.params.route.DataFieldTable,
        false,
        true
      );
    },
    getDiscountCards() {
      const payload = {};
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call getDiscountCards was successful",
            response
          );
          this.discountCards = [];
          if (!_.isEmpty(response.data.DiscountCards)) {
            for (const [key, value] of Object.entries(
              response.data.DiscountCards
            )) {
              if (this.userDiscountCards.length == 0) {
                this.discountCards.push({ key, ...value });
              } else {
                this.userDiscountCards.forEach((element) => {
                  if (element.Name !== value.Name) {
                    this.discountCards.push({ key, ...value });
                  } else {
                    this.discountCards = [];
                  }
                });
              }
            }
          } else {
            console.log(" recieved data is empty");
          }
        },
        (error) => {
          console.log(
            "The generic call getDiscountCards was not successful",
            error
          );
        },
        "getDiscountCards",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    createCardsOfWaypoints(data) {
      const recievedWaypoints = [];
      data.forEach((element, key) => {
        recievedWaypoints.indexOf(element) === -1
          ? recievedWaypoints.push(element)
          : console.log("This element already exists");
      });
      recievedWaypoints.unshift("Waypoint A");
      recievedWaypoints.push("Waypoint B");
      this.finalRoute = recievedWaypoints.slice();
      this.tourInputCheck();
    },
    mapDialogTrigger() {
      this.toggleTabsMap = 0;
      const startLocation = this.eventCreationForm.locationId;
      const endLocation = this.eventCreationForm.endLocationId;
      const transportationTypes = this.eventCreationForm.travelMode;
      const { averageSpeed } = this.eventCreationForm;

      if (endLocation !== undefined && endLocation !== "") {
        if (
          startLocation !== undefined &&
          startLocation !== "" &&
          transportationTypes !== undefined &&
          transportationTypes !== "" &&
          averageSpeed !== null &&
          averageSpeed !== undefined
        ) {
          if (
            this.tableStartLocation === "" ||
            this.tableStartLocation === ""
          ) {
            const startLocationName = this.locations.filter(
              (el) => el.locationId == startLocation
            );
            const endLocationName = this.locations.filter(
              (el) => el.locationId == endLocation
            );

            this.tableStartLocation = startLocationName[0].name;
            this.tableEndLocation = endLocationName[0].name;
          }
          this.mapDialog = true;
          this.polylineTableItems = this.locationProps.params.route.DataFieldTable.PathPoints;

          this.backupData = _.cloneDeep(this.locationProps.params.route);

          setTimeout(() => {
            // window.EventBus.fire('generateTourPoints', { routeAspects: [this.backupData], disableChangeView: false });
            // window.EventBus.fire('selectTourFeature');
            this.showTourOnMap(
              "bigMap",
              this.backupData.DataFieldTable,
              true,
              true
            );
          }, 10);
        }
        // setTimeout(() => {
        //   window.EventBus.fire("addMarkers", {});
        // }, 10);
        // setTimeout(() => {
        //   window.EventBus.fire("addBulletMarkers", this.polylineOrderResult);
        //   window.EventBus.fire("addWaypointMarkers", this.waypointsOrderResult);
        //   window.EventBus.fire("addStopMarkers", this.publicTransportStops);
        //   setTimeout(()=> {
        //     let coordinate = this.relayData.path.split(" ");
        //     coordinate = coordinate[0].split(",");
        //     let lon = coordinate[0];
        //     let lat = coordinate[1];
        //     let focusCoordinates = [Number(lon), Number(lat)];
        //     window.EventBus.fire("focusOnMarker", focusCoordinates);
        //   }, 400)
        // }, 300);
      } else if (endLocation === undefined || endLocation === "") {
        if (
          startLocation !== undefined &&
          startLocation !== "" &&
          transportationTypes !== undefined &&
          transportationTypes !== "" &&
          averageSpeed !== null &&
          averageSpeed !== undefined
        ) {
          if (
            this.tableStartLocation === "" ||
            this.tableStartLocation === ""
          ) {
            const startLocationName = this.locations.filter(
              (el) => el.locationId == startLocation
            );
            this.tableStartLocation = startLocationName[0].name;
          }
          this.mapDialog = true;
          this.polylineTableItems = this.locationProps.params.route.DataFieldTable.PathPoints;

          this.backupData = _.cloneDeep(this.locationProps.params.route);

          setTimeout(() => {
            this.showTourOnMap(
              "bigMap",
              this.backupData.DataFieldTable,
              true,
              true
            );
          }, 10);
        }
      } else {
        this.mapDialogWarning = true;
      }
    },
    importGpx(a) {
      console.log("Lorenzo a", a);
      const { files } = a.target;
      this.package = files[0];
      this.getBase64(this.package);
    },
    enableDrawPolyline() {
      this.locationProps2.params.location.polyline = "";
      window.EventBus.fire("generatePolyline", true);
      window.EventBus.fire("enableDrawPolyline");
      window.EventBus.fire("addBulletMarkers", []);
    },
    disableDrawPolyline(coordinates) {
      this.locationProps2.params.location.polyline = coordinates.join(" ");
      window.EventBus.fire("generatePolyline", true);
      this.StartLocationCoordinate = coordinates.shift();
      this.EndLocationCoordinate = coordinates.pop();
      this.polylineTableItems = [];
      this.polylineOrderResult = [];
      for (let index = 0; index < coordinates.length; ++index) {
        this.polylineTableItems.push({
          Name: coordinates[index].join(","),
          Id: index + 1,
        });
        this.polylineOrderResult.push({
          Name: coordinates[index].join(","),
          Id: index + 1,
        });
        window.EventBus.fire("addBulletMarkers", this.polylineOrderResult);
      }
    },
    selectWaypoint(id) {
      let timeOut = 0;
      if (this.toggleTabsMap === 2) {
        timeOut = 500;
        this.toggleTabsMap = 1;
      }
      const element = document.getElementsByClassName("itemRows");
      for (let index = 0; index < element.length; ++index) {
        element[index].classList.remove("teal");
        element[index].classList.remove("accent-2");
      }
      const selectedRow = document.getElementById(`itemRow${id}`);
      selectedRow.classList.add("teal");
      selectedRow.classList.add("accent-2");
      setTimeout(() => {
        selectedRow.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }, timeOut);
    },
    focusOnCoordinate(coordinates, reference) {
      const lon = coordinates[0];
      const lat = coordinates[1];
      const focusCoordinates = [Number(lon), Number(lat)];
      this.$refs[reference].map.focusOnCoordinate(focusCoordinates, 18);
    },
    deletePathPoint(index) {
      this.polylineOrderResult.splice(index, 1);
      this.polylineTableItems.splice(index, 1);

      const toSendData = this.locationProps.params.route;
      toSendData.DataFieldTable.PathPoints = this.polylineTableItems;
      // window.EventBus.fire('generateTourPoints', { routeAspects: [toSendData], disableChangeView: true });
      this.showTourOnMap("bigMap", toSendData.DataFieldTable, true, false);
    },
    deleteWaypoint(item) {
      console.log("Benjamin item", item);
      const id = item.Id;
      if (this.toggleTabsMap === 2) {
        for (let i = this.waypointsOrderResult.length - 1; i >= 0; --i) {
          if (this.waypointsOrderResult[i].Id === id) {
            this.waypointsOrderResult.splice(i, 1);
            break;
          }
        }
        for (let i = this.waypointsTableItems.length - 1; i >= 0; --i) {
          if (this.waypointsTableItems[i].Id === id) {
            this.waypointsTableItems.splice(i, 1);
            break;
          }
        }
        this.locationProps.params.route.DataFieldTable.Waypoints = this.waypointsTableItems
          .map((e) => e.Name)
          .join(" ");
        this.tourInputCheck();
        // window.EventBus.fire("addWaypointMarkers", this.waypointsOrderResult);
      }

      // setTimeout(() => {
      //   window.EventBus.fire("addBulletMarkers", this.polylineOrderResult);
      // }, 200);
    },
    addNewPriceCategory() {
      this.addPriceCategoriesDialog = true;
      this.editPriceCategorie = false;
    },
    addDefaultDeliveryFee() {
      this.addDefaultDeliveryFeeDialog = true;
    },
    addNewDeliveryFee() {
      this.addDeliveryFeeDialog = true;
      this.editDeliveryFee = false;
    },
    dragOrder({ oldIndex, newIndex }) {
      if (this.toggleTabsMap === 1) {
        // const movedId = this.polylineOrderResult.splice(oldIndex, 1)[0];
        // this.polylineOrderResult.splice(newIndex, 0, movedId);
        //
        // let waypointsOrderResultString = this.polylineOrderResult
        //   .map(e => e.Name)
        //   .join(" ");
        // if (waypointsOrderResultString !== "") {
        //   this.locationProps2.params.location.polyline =
        //     this.StartLocationCoordinate +
        //     " " +
        //     waypointsOrderResultString +
        //     " " +
        //     this.EndLocationCoordinate;
        // } else {
        //   this.locationProps2.params.location.polyline =
        //     this.StartLocationCoordinate + " " + this.EndLocationCoordinate;
        // }
        // window.EventBus.fire("generatePolyline", true);
      } else {
        const movedId = this.waypointsOrderResult.splice(oldIndex, 1)[0];

        this.changingRoute = true;
        this.waypointsOrderResult.splice(newIndex, 0, movedId);
        this.locationProps.params.route.DataFieldTable.Waypoints = this.waypointsOrderResult
          .map((e) => e.Name)
          .join(" ");
        this.waypointsTableItems = [];
        setTimeout(() => {
          const waypointsArray = this.locationProps.params.route.DataFieldTable.Waypoints.split(
            " "
          );
          if (this.locationProps.params.route.DataFieldTable.Waypoints !== "") {
            for (let index = 0; index < waypointsArray.length; ++index) {
              this.waypointsTableItems.push({
                Name: waypointsArray[index],
                Id: index + 1,
              });
            }
          }
          this.changingRoute = false;
        }, 10);

        this.tourInputCheck();
      }

      // setTimeout(() => {
      //   window.EventBus.fire("addBulletMarkers", this.polylineOrderResult);
      // }, 500);
    },
    getPriceCategoryTranslations(priceCategory) {
      console.log("Brian is not getting here or ...");

      const payload = {
        Pricecategory: Number(priceCategory.Id),
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call getPriceCategoryTranslations was successful",
            response
          );
          this.priceCategoryTranslations = {};
          this.priceCategoryColumns = [];
          this.priceCategoryTranslations = response.data.Translations;
          this.priceCategoryColumns = response.data.ColumnNames;
          this.openPriceCategoryTranslations = true;
          this.selectedPriceCategory = priceCategory;
        },
        (error) => {
          console.log(
            "The generic call getPriceCategoryTranslations was not successful",
            error
          );
        },
        "getPriceCategoryTranslations",
        Number(this.eventCreationForm.eventId),
        payload
      );
    },
    getProductCategoriesTranslations() {
      const payload = {};
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call getProductCategoriesTranslations was successful",
            response
          );
          this.productCategoriesTranslations = {};
          this.productCategoriesColumns = [];
          this.productCategoriesTranslations = response.data.Translations;
          this.productCategoriesColumns = response.data.ColumnNames;
          this.openProductCategoriesTranslations = true;
        },
        (error) => {
          console.log(
            "The generic call getProductCategoriesTranslations was not successful",
            error
          );
        },
        "getProductCategoriesTranslations",
        Number(this.eventCreationForm.eventId),
        payload
      );
    },
    addWaypoint(id) {
      this.selectTourFeature("disable");
      this.stopAddingPathpointsButton = true;
      this.disableTableItemsInteraction = true;
      if (this.toggleTabsMap === 1) {
        const newPathPoint = {
          DistanceFromStart: 0,
          EventInfo: {
            EventId: -1,
            EventName: "",
            ThumbnailPicture: "",
          },
          Latitude: null,
          Longitude: null,
          StopName: "",
          StopNr: -1,
          TravelTimeFromStart: 0,
          Type: "Point",
        };
        this.polylineTableItems.splice(id + 1, 0, newPathPoint);
        setTimeout(() => {
          this.selectWaypoint(id + 1);
        }, 100);
      } else {
        const newWaypoint = {
          Name: "Click on map.",
          Id: this.waypointsTableItems.length + 1,
        };
        const index = 0;
        if (this.waypointsTableItems.length > 0) {
          this.waypointsTableItems.splice(id + 1, 0, newWaypoint);
        } else {
          this.waypointsTableItems.push(newWaypoint);
        }
      }
      // window.EventBus.fire('enableWaypointInteraction');
      const mousePosition = this.$refs.bigMap.map.enableClick();
      console.log("Brian mousePosition", mousePosition);
      const self = this;
      this.disableWaypointInteraction = false;
      this.$refs.bigMap.map.map.on("click", (evt) => {
        // Get the pointer coordinate
        const mousePositionCoordinate = ol.proj.transform(
          evt.coordinate,
          "EPSG:3857",
          "EPSG:4326"
        );
        mousePositionCoordinate[0] = mousePositionCoordinate[0].toFixed(6);
        mousePositionCoordinate[1] = mousePositionCoordinate[1].toFixed(6);
        self.setWaypoints(mousePositionCoordinate.join());
        self.$refs.bigMap.map.map.removeEventListener("click");
      });
    },
    setWaypoints(value) {
      let index = 0;
      if (this.toggleTabsMap === 1) {
        const coordinates = value.split(",");
        console.log("coordinates coordinates", coordinates);

        for (let i = 0; i < this.polylineOrderResult.length; i++) {
          if (this.polylineOrderResult[i].Latitude === null) {
            this.polylineOrderResult[i].Longitude = Number(coordinates[0]);
            this.polylineOrderResult[i].Latitude = Number(coordinates[1]);
            console.log("Benjamin index 2", i);
            break;
          }
        }

        for (
          let counter = 0;
          counter < this.polylineTableItems.length;
          counter++
        ) {
          if (this.polylineTableItems[counter].Latitude === null) {
            this.polylineTableItems[counter].Longitude = Number(coordinates[0]);
            this.polylineTableItems[counter].Latitude = Number(coordinates[1]);
            index = counter;

            break;
          }
        }
        const polylineOrderResultString = this.polylineOrderResult
          .map((e) => e.Name)
          .join(" ");
        if (polylineOrderResultString !== "") {
          this.locationProps2.params.location.polyline = `${this.StartLocationCoordinate} ${polylineOrderResultString} ${this.EndLocationCoordinate}`;
        } else {
          this.locationProps2.params.location.polyline = `${this.StartLocationCoordinate} ${this.EndLocationCoordinate}`;
        }
        const toSendData = this.locationProps.params.route;
        toSendData.DataFieldTable.PathPoints = this.polylineTableItems;
        console.log("Benjamin im getting here 2");

        // window.EventBus.fire('generateTourPoints', { routeAspects: [toSendData], disableChangeView: true });
        this.showTourOnMap("bigMap", toSendData.DataFieldTable, true, false);
        // window.EventBus.fire("addBulletMarkers", this.polylineOrderResult);
        // this.focusOnCoordinate(index);
        console.log("Benjamin index", index);

        setTimeout(() => {
          this.addWaypoint(index);
        }, 100);
      } else {
        for (let i = 0; i < this.waypointsTableItems.length; i++) {
          if (this.waypointsTableItems[i].Name === "Click on map.") {
            this.waypointsTableItems[i].Name = value;
            index = i;
            break;
          }
        }
        this.locationProps.params.route.DataFieldTable.Waypoints = this.waypointsTableItems
          .map((e) => e.Name)
          .join(" ");
        // this.addWaypoint(index);
        // const waypointFeature = MapObject.createDotMarker({
        //   longitude: Number(value.split(',')[0]),
        //   latitude: Number(value.split(',')[0]),
        //   data: {},
        // }, '#ff8400', 7, (index + 1).toString(), 'white', 2);
        // const vectorSource = MapObject.createVectorSource([waypointFeature]);
        // const vectorLayer = MapObject.createVectorLayer('waypoints', vectorSource);
        // vectorLayer.setZIndex(100);
        // this.$refs.bigMap.map.addLayerOnMap(vectorLayer);
        this.showTourOnMap(
          "bigMap",
          this.locationProps.params.route.DataFieldTable,
          true,
          false
        );
        setTimeout(() => {
          console.log("Benjamin index 1", index + 1);

          this.addWaypoint(index);
        }, 100);
        // this.tourInputCheck();
      }
    },
    stopAddingWaypoints() {
      this.$refs.bigMap.map.deleteLayer("waypoints");
      this.$refs.bigMap.map.removeClickEvent();
      this.selectTourFeature("enable");
      for (let i = 0; i < this.waypointsOrderResult.length; i++) {
        if (this.waypointsOrderResult[i].Name === "Click on map.") {
          this.waypointsOrderResult.splice(i, 1);
          break;
        }
      }
      for (let i = 0; i < this.waypointsTableItems.length; i++) {
        if (this.waypointsTableItems[i].Name === "Click on map.") {
          this.waypointsTableItems.splice(i, 1);
          break;
        }
      }
      this.tourInputCheck();
      this.disableTableItemsInteraction = false;
    },
    stopAddingPathpoints() {
      this.$refs.bigMap.map.removeClickEvent();
      for (let i = 0; i < this.polylineOrderResult.length; i++) {
        if (this.polylineOrderResult[i].Latitude === null) {
          this.polylineOrderResult.splice(i, 1);
        }
      }

      for (let i = 0; i < this.polylineTableItems.length; i++) {
        if (this.polylineTableItems[i].Latitude === null) {
          this.polylineTableItems.splice(i, 1);
        }
      }
      // window.EventBus.fire('removeClickEvent');
      this.disableTableItemsInteraction = false;
      this.stopAddingPathpointsButton = false;
    },
    tourInputCheck(inputform = false) {
      const startLocation = this.eventCreationForm.locationId;
      let endLocation = this.eventCreationForm.endLocationId;
      const transportationTypes = this.eventCreationForm.travelMode;
      const { averageSpeed } = this.eventCreationForm;
      if (endLocation !== undefined && endLocation !== "") {
        if (
          startLocation !== undefined &&
          startLocation !== "" &&
          endLocation !== "" &&
          transportationTypes !== undefined &&
          transportationTypes !== "" &&
          averageSpeed !== null &&
          averageSpeed !== undefined
        ) {
          const startLocationName = this.locations.filter(
            (el) => el.locationId == startLocation
          );
          const endLocationName = this.locations.filter(
            (el) => el.locationId == endLocation
          );

          this.tableStartLocation = startLocationName[0].name;
          this.tableEndLocation = endLocationName[0].name;
          this.startLocationId = startLocation;
          this.endLocationId = endLocation;
          if (inputform === false) {
            this.generateRoute(
              startLocation,
              endLocation,
              transportationTypes,
              averageSpeed
            );
          } else {
            this.generateRouteButton = true;
          }
        }
      } else if (
        startLocation !== undefined &&
        startLocation !== "" &&
        transportationTypes !== undefined &&
        transportationTypes !== "" &&
        averageSpeed !== null &&
        averageSpeed !== undefined
      ) {
        const startLocationName = this.locations.filter(
          (el) => el.locationId == startLocation
        );
        endLocation = "";
        this.tableStartLocation = startLocationName[0].name;
        this.startLocationId = startLocation;
        this.endLocationId = "";
        if (inputform === false) {
          this.generateRoute(
            startLocation,
            endLocation,
            transportationTypes,
            averageSpeed
          );
        } else {
          this.generateRouteButton = true;
        }
      } else if (inputform === true) {
        this.generateRouteButton = false;
      }
    },
    // Function to get routes with and without waypoint
    generateRoute(
      startLocation,
      endLocation,
      transportationTypes,
      averageSpeed
    ) {
      // New generateRoute function (date: 24-06-2020)
      if (this.toDeleteMarker !== "") {
        const x = this.locationProps.params.route.DataFieldTable.Waypoints.split(
          " "
        );
        for (let i = 0; i < x; i++) {
          if (x[i] === this.toDeleteMarker) {
            x.splice(i, 1);
          }
        }
      }

      const payload = {
        StartLocationId: startLocation,
        EndLocationId: endLocation,
        TravelMode: transportationTypes,
        Waypoints: this.locationProps.params.route.hasOwnProperty(
          "DataFieldTable"
        )
          ? this.locationProps.params.route.DataFieldTable.Waypoints
          : "",
        AverageSpeed: averageSpeed,
      };
      dssRequest.doRequest(
        (response) => {
          console.log("the call for generateRoute was successful", response);
          /*
            New way for the generation of tours and relays
            Introduced in the code since 24-06-2020
            */
          this.locationProps.params.route = response.data;

          this.locationProps2.params.route.PathPoints =
            response.data.DataFieldTable.PathPoints;

          this.locationProps.location.latitude =
            (response.data.DataFieldTable.BoundingBox.LatBottomLeft +
              response.data.DataFieldTable.BoundingBox.LatTopRight) /
            2;
          this.locationProps.location.longitude =
            (response.data.DataFieldTable.BoundingBox.LonBottomLeft +
              response.data.DataFieldTable.BoundingBox.LonTopRight) /
            2;

          this.locationProps2.location.latitude =
            (response.data.DataFieldTable.BoundingBox.LatBottomLeft +
              response.data.DataFieldTable.BoundingBox.LatTopRight) /
            2;
          this.locationProps2.location.longitude =
            (response.data.DataFieldTable.BoundingBox.LonBottomLeft +
              response.data.DataFieldTable.BoundingBox.LonTopRight) /
            2;

          this.polylineTableItems = response.data.DataFieldTable.PathPoints;
          this.polylineTableItems[0].Disabled = true;
          const focusCoordinates = [
            this.locationProps2.location.longitude,
            this.locationProps2.location.latitude,
          ];
          this.waypointsTableItems = [];
          this.waypointsOrderResult = [];
          const waypointsArray = response.data.DataFieldTable.Waypoints.split(
            " "
          );
          if (response.data.DataFieldTable.Waypoints !== "") {
            for (let index = 0; index < waypointsArray.length; ++index) {
              this.waypointsTableItems.push({
                Name: waypointsArray[index],
                Id: index + 1,
              });
            }
            for (let index = 0; index < waypointsArray.length; ++index) {
              this.waypointsOrderResult.push({
                Name: waypointsArray[index],
                Id: index + 1,
              });
            }
          }

          if (!this.mapDialog) {
            this.showTourOnMap(
              "smallMap",
              response.data.DataFieldTable,
              false,
              true
            );
          } else {
            this.showTourOnMap(
              "bigMap",
              response.data.DataFieldTable,
              true,
              true
            );
            this.disableTableItemsInteraction = false;
          }
          // window.EventBus.fire('focusOnMarker', focusCoordinates);
          // let polylineResult = [];
          // const polyline = response.data.DataFieldTable.Path.split(' ');
          // const startingPoint = polyline[0].split(',');
          // const startingPointFeature = MapObject.createDotMarker({longitude: Number(startingPoint[0]), latitude: Number(startingPoint[1]), data: {} }, '#3CAEA3', 9, '1', 'white');
          // polyline.forEach((coordinates) => {
          //   const coordinatesArray = coordinates.split(',');
          //   coordinatesArray[0] = Number(coordinatesArray[0]);
          //   coordinatesArray[1] = Number(coordinatesArray[1]);
          //   polylineResult.push(coordinatesArray);
          // });
          // const smallMap = this.$refs.smallMap.map;
          // const polylineFeature = MapObject.createPolyline(polylineResult, "#0000FF", 3);
          // smallMap.deleteLayer('route');
          // const features = [startingPointFeature];
          // if (polyline.length !== 1) {
          //   const endPoint = polyline[polyline.length - 1].split(',');
          //   const endPointFeature = MapObject.createDotMarker({
          //     longitude: Number(endPoint[0]),
          //     latitude: Number(endPoint[1]),
          //     data: {},
          //   }, '#3CAEA3', 9, '2', 'white');
          //   features.push(endPointFeature);
          // }
          //
          // const vectorSource = MapObject.createVectorSource(features);
          // const vectorLayer = MapObject.createVectorLayer('route', vectorSource);
          // vectorLayer.setZIndex(100);
          // smallMap.addLayerOnMap(vectorLayer);
          // window.EventBus.fire('generateTourPoints', { routeAspects: [response.data], disableChangeView: false });
        },
        (error) => {
          console.log("the call for generateRoute was not successful", error);
          // window.EventBus.fire('triggerGenericErrorDialog', this.$translate('E_ROUTE_006'));
        },
        "generateRoute",
        appConfig.dss.eventAdminMng,
        payload,
        600000,
        false
      );
    },
    showTourOnMap(reference, dataFieldTable, showDotMarker, focusOnPolyline) {
      const { map } = this.$refs[reference];
      const features = [];
      const polylineArray = [];
      const waypointsResult = [];
      if (dataFieldTable.hasOwnProperty("Waypoints")) {
        if (dataFieldTable.Waypoints !== "") {
          const waypointsResult = [];
          const waypoints = dataFieldTable.Waypoints.split(" ");
          waypoints.forEach((waypoint, index) => {
            waypointsResult.push([
              Number(waypoint.split(",")[0]),
              Number(waypoint.split(",")[1]),
            ]);
          });
          waypointsResult.forEach((coordinate, index) => {
            console.log("Benjamin waypoint", coordinate);
            let waypointFeature = {};
            waypointFeature = MapObject.createDotMarker(
              {
                longitude: coordinate[0],
                latitude: coordinate[1],
                data: {},
              },
              "#ff8400",
              7,
              (index + 1).toString(),
              "white",
              2
            );
            features.push(waypointFeature);
          });
        }
      }
      console.log("Benjamin waypointsResult", waypointsResult, features);
      dataFieldTable.PathPoints.forEach((pathPoint, index) => {
        polylineArray.push([pathPoint.Longitude, pathPoint.Latitude]);
        let feature = {};

        if (pathPoint.StopNr === -1) {
          if (showDotMarker) {
            feature = MapObject.createDotMarker(
              {
                longitude: pathPoint.Longitude,
                latitude: pathPoint.Latitude,
                data: {
                  id: index,
                },
              },
              "black",
              6,
              "",
              "",
              1
            );
            features.push(feature);
          }
        } else {
          feature = MapObject.createDotMarker(
            {
              longitude: pathPoint.Longitude,
              latitude: pathPoint.Latitude,
              data: {
                id: index,
              },
            },
            "#3CAEA3",
            9,
            pathPoint.StopNr.toString(),
            "white",
            3
          );
          features.push(feature);
        }
      });
      const polylineFeature = MapObject.createPolyline(
        polylineArray,
        "#0000FF",
        3
      );
      features.push(polylineFeature);
      const vectorSource = MapObject.createVectorSource(
        features.concat(waypointsResult)
      );
      const vectorLayer = MapObject.createVectorLayer("route", vectorSource);
      vectorLayer.setZIndex(100);
      map.deleteLayer("route");
      map.addLayerOnMap(vectorLayer);
      if (focusOnPolyline) {
        map.focusOnPolyline(polylineArray);
      }
      if (showDotMarker) {
        this.selectTourFeature("add");
      }
    },
    selectTourFeature(action) {
      const bigMap = this.$refs.bigMap.map;
      const select = new ol.interaction.Select({});
      if (action === "add") {
        bigMap.map.addInteraction(select);
        // on click function
        const self = this;
        select.on("select", (evt) => {
          if (evt.target.getFeatures().a.length > 0) {
            const { id } = evt.target.getFeatures().a[0].N.data;
            select.getFeatures().clear();
            self.selectWaypoint(id);
          }
        });
      } else if ("disable") {
        bigMap.map.getInteractions().forEach((interaction, index) => {
          console.log("Benjamin interaction", interaction, index);
          if (interaction instanceof ol.interaction.Select) {
            interaction.setActive(false);
          }
        });
      } else {
        bigMap.map.getInteractions().forEach((interaction, index) => {
          console.log("Benjamin interaction", interaction, index);
          if (interaction instanceof ol.interaction.Select) {
            interaction.setActive(true);
          }
        });
      }

      console.log(
        "Benjamin  bigMap.map.getInteractions",
        bigMap.map.getInteractions()
      );
    },
    openCategoriesDialogForSubActivities() {
      this.categoriesDialogForSubActivities = true;
      if (this.cleanFilters == true) {
        this.cleanTheFilters = true;
      }
    },
    openCategoriesDialogForTour() {
      this.openCategoriesDialogForTour = true;
      if (this.cleanFilters == true) {
        this.cleanTheFilters = true;
      }
    },
    saveFiltersForSubActivities() {
      this.categoriesDialogForSubActivities = false;

      this.getPotentialChildrenEvents();
    },
    saveFiltersForTourActivities() {
      this.categoriesDialogForTour = false;
      this.getPotentialTourEvents();
    },
    saveFiltersForAlternatives() {
      this.categoriesDialogForAlternatives = false;
      this.getPotentialAlternativesEvents();
    },
    saveFiltersForSuggestions() {
      this.categoriesDialogForSuggestions = false;
      this.getPotentialSuggestionsEvents();
    },
    closeFiltersForSubActivities() {
      this.categoriesDialogForSubActivities = false;
      this.cleanFilters = true;
      this.selectedTagsInArrayForSubActivities = [];
      this.selectedSubActivitiesTags = {};

      this.categoryFiltersSelected = [];
      this.unselectAllCategories(this.categoryFiltersAll);
    },
    closeFiltersForTourActivities() {
      this.categoriesDialogForTour = false;
      this.cleanFilters = true;
      this.selectedTagsInArrayForTourActivities = [];
      this.selectedTourTags = {};

      this.categoryFiltersSelected = [];
      this.unselectAllCategories(this.categoryFiltersAll);
    },
    closeFiltersForAlternatives() {
      this.categoriesDialogForAlternatives = false;
      this.cleanFilters = true;
      this.selectedTagsInArrayForAlternatives = [];
      this.selectedAlternativesTags = {};

      this.categoryFiltersSelected = [];
      this.unselectAllCategories(this.categoryFiltersAll);
    },
    closeFiltersForSuggestions() {
      this.categoriesDialogForSuggestions = false;
      this.cleanFilters = true;
      this.selectedTagsInArrayForSuggestions = [];
      this.selectedSuggestionsTags = {};

      this.categoryFiltersSelected = [];
      this.unselectAllCategories(this.categoryFiltersAll);
    },
    SettingFormEventPartner() {
      if (this.$store.getters["auth/userLevel"] == 6) {
        this.eventCreationForm.partnerId = this.$store.getters[
          "auth/partnerId"
        ];
        this.partnerIsActive = true;
      }
    },
    // setInputForCheckbox() {
    //   if (
    //     this.eventCreationForm.tour == true ||
    //     this.eventCreationForm.relay == true
    //   ) {
    //     this.checkboxSelected = true;
    //   } else {
    //     this.checkboxSelected = false;
    //   }
    // },
    manageDataForComponent(data) {
      if (!_.isEmpty(this.$store.getters.getFiltersForEvent)) {
        window.EventBus.fire(
          "getEventsBasedOnUserLevel",
          this.$store.getters.getFiltersForEvent
        );
      }
      this.showEventLanguages = false;
      if (_.isEmpty(data)) {
        this.properties.params = null;
      }
      else {
        this.properties.params = data;
      }
      this.checkEditCondition();
    },
    // getRouteAspectData() {
    //
    //   // websocket connection to get relay aspects
    //   let sigObjMap = new Map();
    //   sigObjMap.set(appConfig.dss.eventAdminMng, []);
    //   sigObjMap
    //     .get(appConfig.dss.eventAdminMng)
    //     .push(["routeAspectUpdate", ["RouteAspectData"]]);
    //   window.EventBus.fire("linkingToRecieveRoutes", sigObjMap);
    // },
    checkEditCondition() {
      this.allRoutes = this.$store.getters.getRoutes;

      console.log(
        "proeprties params in checkEditCondition",
        this.properties.params
      );
      if (this.properties.params !== null) {
        if (this.properties.params.planboardManaged === "0")
          this.properties.params.planboardManaged = false;
        else this.properties.params.planboardManaged = true;

        if (this.properties.params.preEvent === "0")
          this.properties.params.preEvent = false;
        else this.properties.params.preEvent = true;

        if (this.properties.params.partnerName !== undefined) {
          this.properties.params.eventPartner = {
            id: this.properties.params.partnerId,
            Name: this.properties.params.partnerName,
          };
          delete this.properties.params.partnerId;
          delete this.properties.params.partnerName;
        }
        console.log("Brian this.eventCreationForm", this.properties.params);

        if (this.properties.params.type === 'Promotion') {
          this.chosenStartDate = this.formatDate(this.properties.params.releaseDate);
          this.startTime = this.properties.params.releaseTime;
          this.chosenEndDate = this.formatDate(this.properties.params.expirationDate);
          this.endTime = this.properties.params.expirationTime;
        }

        if (this.properties.params.timeWindowType == "Fixed")
          this.disableDurationType = true;
        else this.disableDurationType = false;

        this.nextButton = true;
        this.newEventId = this.properties.params.eventId;
        this.eventCreationForm = this.properties.params;
        if (
          this.properties.params.hasOwnProperty("type") &&
          (this.properties.params.type === "Relay" ||
            this.properties.params.type === "Tour")
        ) {
          this.eventCreationForm.relay = _.transform(
            this.eventCreationForm.relay,
            (result, val, key) => {
              result[key.toLowerCase()] = val;
            }
          );

          this.eventCreationForm.endLocationId = this.eventCreationForm.relay.endlocationid;

          if (this.eventCreationForm.type !== "OrderEvent")
            this.eventCreationForm.deliveryPartner = "";

          // this.locationProps.signalObjectMap = new Map();
          // this.locationProps.signalObjectMap.set(appConfig.dss.eventAdminMng, []);
          // this.locationProps.signalObjectMap.get(appConfig.dss.eventAdminMng)
          // .push(["routeAspectUpdate", ["RouteAspectData"]]);
          this.handleTourOrRelay();
        }
        // this.properties2.pictureUrl = this.eventCreationForm.picture;
        this.multiPicturesProperties.pictureUrl = [];

        if (this.eventCreationForm.picture !== "") {
          this.multiPicturesProperties.pictureUrl.push(
            this.eventCreationForm.picture
          );
        }

        Object.entries(this.eventCreationForm.extraPictures).forEach(
          ([k, v]) => {
            if (!v.isEmpty) {
              this.multiPicturesProperties.pictureUrl.push(v);
            }
          }
        );

        console.log(
          "multiPicturesProperties 2: ",
          this.multiPicturesProperties
        );

        this.preselection = [];
        this.subActivitiesPreselection = [];
        this.eventCreationForm.durationMin = Math.round(
          this.eventCreationForm.duration / 60
        );
        this.eventCreationForm.leadTimeMin =
          this.eventCreationForm.leadTime / 60;
        this.eventCreationForm.cooldownTimeMin =
          this.eventCreationForm.cooldownTime / 60;
        this.eventCreationForm.tags = Object.values(
          this.eventCreationForm.tags
        );
        if (this.eventCreationForm.tags.length > 0) {
          this.eventCreationForm.tags.forEach((e) => {
            if (e.Selected == "yes") {
              this.preselection.push(e);
            }
          });
        }
        const recievedData = {};
        if (!_.isEmpty(this.eventCreationForm.discountCards)) {
          for (const [key, value] of Object.entries(
            this.eventCreationForm.discountCards
          )) {
            this.userDiscountCards.push({
              Key: key,
              Name: value.name,
              DiscountPercentage: value.percentage,
            });
          }
        }
        if (!_.isEmpty(this.eventCreationForm.productCategories)) {
          for (const [key, value] of Object.entries(
            this.eventCreationForm.productCategories
          )) {
            this.userProductCategories.push({
              key,
              Id: value.id,
              Description: value.description,
            });
          }
        }
        this.accountsSelected = this.eventCreationForm.memberOf;
        console.log(
          "Benjamin this.eventCreationForm.parentEvents",
          this.eventCreationForm.parentEvents
        );
        if (!_.isEmpty(this.eventCreationForm.parentEvents)) {
          for (const [key, value] of Object.entries(
            this.eventCreationForm.parentEvents
          )) {
            this.themesSelected.push({
              EventId: key,
              Name: value.name,
            });
          }
        }
        if (!_.isEmpty(this.eventCreationForm.rewardLevels)) {
          for (const [key, value] of Object.entries(
            this.eventCreationForm.rewardLevels
          )) {
            this.rewardsSelected.push({
              Key: key,
              Name: value.name,
              RewardLevel: value.rewardLevel,
            });
          }
        }
        if (!_.isEmpty(this.eventCreationForm.extraLocations)) {
          for (const [key, value] of Object.entries(
            this.eventCreationForm.extraLocations
          )) {
            console.log("Lorenzo value", value);
            this.eventExtraLocationsSelected.push({
              Key: key,
              Name: value.name,
              Capacity: value.capacity,
            });
          }
        }
        if (!_.isEmpty(this.eventCreationForm.parentEventRewards)) {
          for (const [key, value] of Object.entries(
            this.eventCreationForm.parentEventRewards
          )) {
            this.eventRewardsSelected.push({
              Key: key,
              Name: value.name,
              Reward: value.reward,
            });
          }
        }

        this.eventCreationForm.categories.forEach((category) => {
          let categoryTmp1 = {};
          categoryTmp1 = Object.assign({}, category);
          this.eventCategoriesAll.push(categoryTmp1);

          let categoryTmp2 = {};
          categoryTmp2 = Object.assign({}, category);
          this.categoryFiltersAll.push(categoryTmp2);
        });

        this.unselectAllCategories(this.categoryFiltersAll);

        // Get related events
        if (this.eventCreationForm.relatedEvents !== undefined) {
          this.eventCreationForm.relatedEvents.forEach((relatedEvent) => {
            let relatedEventTmp = {};
            relatedEventTmp = Object.assign({}, relatedEvent);
            this.relatedEventsToBeSaved.push(relatedEventTmp);
          });
        }

        // this.themesSelected = this.eventCreationForm.parentEvents;
      } else {
        // if(!this.eventCreationForm.durationType.isEmpty)
        //   this.disableDurationType = true;
        this.backupData = {};
        this.waypointsTableItems = [];
        this.waypointsOrderResult = [];
        this.polylineOrderResult = [];
        this.polylineTableItems = [];
        this.locationProps.params.route = {};
        this.locationProps2.params.route = {
          BoundingBox: {
            LatBottomLeft: "",
            LatTopRight: "",
            LonBottomLeft: "",
            LonTopRight: "",
          },
          Duration: "",
          EndLatitude: "",
          EndLocationId: "",
          EndLongitude: "",
          PathPoints: [],
          TravelMode: "",
          Distance: "",
        };
        this.locationProps.params.location.waypoints = "";
        this.locationProps2.params.location.waypoints = "";
        this.waypointRoute = [];

        this.newEventId = null;
        this.arrayFromWaypoints = [];
        this.nextButton = false;
        this.getDiscountCards();
        this.userDiscountCards = [];
        this.userProductCategories = [];
        if (this.$refs.eventCreationForm !== undefined)
          this.$refs.eventCreationForm.reset();
        this.eventCreationForm = {};
        // this.eventCreationForm["leadTimeMin"] = 0;
        // this.eventCreationForm["cooldownTimeMin"] = 0;
        // this.properties2.pictureUrl = "";
        this.multiPicturesProperties.pictureUrl = [];
        this.preselection = [];
        this.subActivitiesPreselection = [];
        this.getAllEventCategories();
      }
    },
    handleTourOrRelay() {
      const payload = {
        FullPicture: true,
        LanguageTagId: this.$store.getters.getUserLanguage,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            " - Called on EventCreation.vue - The call getEventDetailsV2 on the event was successful",
            response
          );

          /*
            -- First we check if all the data is provided and correct
             */

          if (!response.data.hasOwnProperty("RouteAspect")) {
            // Make sure the data has the RouteAspect data
            // window.EventBus.fire(
            //   'triggerGenericErrorDialog',
            //   'E_RA_002',
            // );
            return;
          }
          if (!response.data.RouteAspect.hasOwnProperty("DataFieldTable")) {
            // Make sure the data has the dataFieldTable
            // window.EventBus.fire(
            //   'triggerGenericErrorDialog',
            //   'E_RA_002',
            // );
            return;
          }
          if (
            this.eventCreationForm.relay.aspectid !==
            response.data.RouteAspect.Id
          ) {
            // Make sure that the aspectId is equal to the received one
            // window.EventBus.fire(
            //   'triggerGenericErrorDialog',
            //   'E_RA_003',
            // );
            return;
          }
          if (
            !response.data.RouteAspect.DataFieldTable.hasOwnProperty(
              "PathPoints"
            )
          ) {
            // Make sure that dataFieldTable has the property PathPoints
            // window.EventBus.fire(
            //   'triggerGenericErrorDialog',
            //   'E_RA_004',
            // );
            return;
          }

          /*
            -- Now we handle the data to visualise the route-aspect data
             */
          response.data.RouteAspect.DataFieldTable.PathPoints[0].Disabled = true;
          this.eventCreationForm.travelMode =
            response.data.RouteAspect.DataFieldTable.TravelMode;
          this.eventCreationForm.averageSpeed =
            response.data.RouteAspect.DataFieldTable.AverageSpeed;
          this.locationProps.params.route = response.data.RouteAspect;
          // this.locationProps.params.location.waypoints = response.data.RouteAspect.DataFieldTable.Waypoints;
          const pathPointArray =
            response.data.RouteAspect.DataFieldTable.PathPoints;

          const objectStartLocationCoordinate = pathPointArray[0];
          this.StartLocationCoordinate = `${objectStartLocationCoordinate.Latitude},${objectStartLocationCoordinate.Longitude}`;
          const objectEndLocationCoordinate =
            pathPointArray[pathPointArray.length - 1];
          this.EndLocationCoordinate = `${objectEndLocationCoordinate.Latitude},${objectEndLocationCoordinate.Longitude}`;
          this.polylineTableItems = [];
          this.polylineOrderResult = [];
          this.waypointsTableItems = [];
          this.waypointsOrderResult = [];
          response.data.RouteAspect.DataFieldTable.PathPoints.forEach(
            (item) => {
              this.polylineTableItems.push(item);
              this.polylineOrderResult.push(item);
            }
          );

          const waypointsArray = response.data.RouteAspect.DataFieldTable.Waypoints.split(
            " "
          );

          if (response.data.RouteAspect.DataFieldTable.Waypoints !== "") {
            for (let index = 0; index < waypointsArray.length; ++index) {
              this.waypointsTableItems.push({
                Name: waypointsArray[index],
                Id: index + 1,
              });
              this.waypointsOrderResult.push({
                Name: waypointsArray[index],
                Id: index + 1,
              });
            }
          }
          this.backupData = _.cloneDeep(response.data.RouteAspect);
          const latitude =
            (response.data.RouteAspect.DataFieldTable.BoundingBox
              .LatBottomLeft +
              response.data.RouteAspect.DataFieldTable.BoundingBox
                .LatTopRight) /
            2;
          const longitude =
            (response.data.RouteAspect.DataFieldTable.BoundingBox
              .LonBottomLeft +
              response.data.RouteAspect.DataFieldTable.BoundingBox
                .LonTopRight) /
            2;
          const focusCoordinates = [longitude, latitude];

          setTimeout(() => {
            window.EventBus.fire("generateTourPoints", {
              routeAspects: [response.data.RouteAspect],
              disableChangeView: false,
            });
            this.showTourOnMap(
              "smallMap",
              response.data.RouteAspect.DataFieldTable,
              false,
              true
            );
          }, 10);
        },
        (error) => {
          console.log(
            " - Called on EventCreation.vue - The call getEventDetailsV2 on the event was not successful",
            error
          );

          // window.EventBus.fire(
          //   'triggerGenericErrorDialog',
          //   'E_RA_001',
          // );
        },
        "getEventDetailsV2",
        Number(this.eventCreationForm.eventId),
        payload
      );
    },
    refreshPolyline(item) {
      if (item.Type === "Point" && item.StopNr !== -1) {
        item.StopNr = -1;
        item.StopName = "";
        item.EventInfo.EventId = -1;
        item.EventInfo.EventName = "";
        item.EventInfo.ThumbnailPicture = "";
      }
      for (const [index, item] of Object.entries(this.polylineTableItems)) {
        if (item.Type === "Stop") this.oneStopAvailable = true;
      }
      setTimeout(() => {
        const toSendData = this.locationProps.params.route;
        toSendData.DataFieldTable.PathPoints = this.polylineTableItems;
        window.EventBus.fire("generateTourPoints", {
          routeAspects: [toSendData],
          disableChangeView: false,
        });
        this.showTourOnMap("bigMap", toSendData.DataFieldTable, true, false);
      }, 500);
    },
    returnFromEventCreation() {
      // * Going back from event editing(creation) to the overview page of the event *
      // By calling the showComponents function and setting the main/side component

      const nav = {
        main: "Events_main",
        side: "EventView_Overview",
      };
      nav.sideParam = { select: this.eventCreationForm.eventId };
      // nav.mainParam = this.eventCreationForm;
      this.showComponents(nav);

      // By setting a time out, we give the system time to handle the dataForComponent
      // setTimeout(() => {
      //   window.EventBus.fi re("dataForComponent", this.eventCreationForm);
      // }, 200);
    },
    saveChildren() {
      const chosenChildren = {};
      if (this.userSubActivitiesList.length > 0) {
        this.userSubActivitiesList.forEach((element) => {
          chosenChildren[element.eventId] = element.eventId;
        });
      }

      const payload = {
        EventId: Number(this.newEventId),
        FunctionId: "EventFunctionLibrary::saveChildren",
        Children: chosenChildren,
      };
      dssRequest.doRequest(
        (response) => {
          console.log("The generic call saveChildren was successful", response);

          // Clear category filters
          this.categoryFiltersSelected = [];
          this.unselectAllCategories(this.categoryFiltersAll);

          this.subActivitiesDialog = false;
        },
        (error) => {
          console.log(
            "The generic call saveChildren was not successful",
            error
          );
        },
        "communicateWithDBLibrary",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    getChildren() {
      const payload = {
        EventId: Number(this.newEventId),
        FunctionId: "EventFunctionLibrary::getChildren",
      };
      dssRequest.doRequest(
        (response) => {
          console.log("The generic call getChildren was successful", response);
          if (response.data.Events !== undefined) {
            const tmpChosenChildren = BaseObject._toLowerCaseInitialProperty(
              BaseObject._createArrayWithObjects(response.data.Events)
            );
            tmpChosenChildren.forEach((item, index) => {
              this.userSubActivitiesList[index] = item;
            });
            this.userSubActivitiesList.sort((a, b) =>
              a.name.localeCompare(b.name, "en", {
                sensitivity: "base",
              })
            );
            this.userSelectionForSubActivities = [];
          }
        },
        (error) => {
          console.log("The generic call getChildren was not successful", error);
        },
        "communicateWithDBLibrary",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    getAlternatives() {
      const payload = {
        EventId: Number(this.newEventId),
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call getAlternatives was successful",
            response
          );
          if (response.data.Alternative !== undefined) {
            const tmpChosenAlternatives = BaseObject._toLowerCaseInitialProperty(
              BaseObject._createArrayWithObjects(response.data.Alternative)
            );
            tmpChosenAlternatives.forEach((item, index) => {
              this.userAlternativesList[index] = item;
            });
            this.userAlternativesList.sort((a, b) =>
              a.name.localeCompare(b.name, "en", {
                sensitivity: "base",
              })
            );
            this.userSelectionForAlternatives = [];
          }
        },
        (error) => {
          console.log(
            "The generic call getAlternatives was not successful",
            error
          );
        },
        "getAlternatives",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    getSuggestions() {
      const payload = {
        EventId: Number(this.newEventId),
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call getSuggestions was successful",
            response
          );
          if (response.data.Suggestions !== undefined) {
            const tmpChosenSuggestions = BaseObject._toLowerCaseInitialProperty(
              BaseObject._createArrayWithObjects(response.data.Suggestions)
            );
            tmpChosenSuggestions.forEach((item, index) => {
              this.userSuggestionsList[index] = item;
            });
            this.userSuggestionsList.sort((a, b) =>
              a.name.localeCompare(b.name, "en", {
                sensitivity: "base",
              })
            );
            this.userSelectionForSuggestions = [];
          }
        },
        (error) => {
          console.log(
            "The generic call getSuggestions was not successful",
            error
          );
        },
        "getSuggestions",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    getTourActivities() {
      const payload = {
        EventId: Number(this.newEventId),
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call getTourActivities was successful",
            response
          );
          if (response.data.TourActivities !== undefined) {
            let recievedTourActivities = response.data.TourActivities;
            for (const [key, value] of Object.entries(recievedTourActivities)) {
              value.SeqNr = key;
            }
            recievedTourActivities = Object.values(recievedTourActivities);
            const tmpChosenTourActivities = BaseObject._toLowerCaseInitialProperty(
              recievedTourActivities
            );
            tmpChosenTourActivities.forEach((item, index) => {
              this.userTourList[index] = item;
            });
            this.userTourList.sort((a, b) => a.seqNr - b.seqNr);
            this.userSelectionForTour = [];
          }
        },
        (error) => {
          console.log(
            "The generic call getAlternatives was not successful",
            error
          );
        },
        "getTourActivities",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    saveTourActivities() {
      const chosenTourActivities = {};
      if (this.userTourList.length > 0) {
        this.userTourList.forEach((element) => {
          chosenTourActivities[element.seqNr] = element.eventId;
        });
      }

      const payload = {
        EventId: Number(this.newEventId),
        FunctionId: "EventFunctionLibrary::saveTourActivities",
        TourActivities: chosenTourActivities,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call saveTourActivities was successful",
            response
          );
          this.eventTourDialog = false;
        },
        (error) => {
          console.log(
            "The generic call saveTourActivities was not successful",
            error
          );
        },
        "communicateWithDBLibrary",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    saveAlternatives() {
      const chosenAlternatives = {};
      if (this.userAlternativesList.length > 0) {
        this.userAlternativesList.forEach((element) => {
          chosenAlternatives[element.eventId] = element.eventId;
        });
      }

      const payload = {
        EventId: Number(this.newEventId),
        Alternatives: chosenAlternatives,
      };

      // Add PartnerId to the request
      if (Number(this.$store.getters["auth/partnerId"]) <= 0) {
        payload.PartnerId = -1;
      } else {
        payload.PartnerId = Number(this.$store.getters["auth/partnerId"]);
      }

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call saveAlternatives was successful",
            response
          );

          // Clear category filters
          this.categoryFiltersSelected = [];
          this.unselectAllCategories(this.categoryFiltersAll);

          this.eventAlternativesDialog = false;
        },
        (error) => {
          console.log(
            "The generic call saveAlternatives was not successful",
            error
          );
        },
        "saveAlternatives",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    saveSuggestions() {
      const chosenSuggestions = {};
      if (this.userSuggestionsList.length > 0) {
        this.userSuggestionsList.forEach((element) => {
          chosenSuggestions[element.eventId] = element.eventId;
        });
      }

      const payload = {
        EventId: Number(this.newEventId),
        Suggestions: chosenSuggestions,
      };

      // Add PartnerId to the request
      if (Number(this.$store.getters["auth/partnerId"]) <= 0) {
        payload.PartnerId = -1;
      } else {
        payload.PartnerId = Number(this.$store.getters["auth/partnerId"]);
      }

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call saveSuggestions was successful",
            response
          );

          // Clear category filters
          this.categoryFiltersSelected = [];
          this.unselectAllCategories(this.categoryFiltersAll);

          this.eventSuggestionsDialog = false;
        },
        (error) => {
          console.log(
            "The generic call saveSuggestions was not successful",
            error
          );
        },
        "saveSuggestions",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    cancelSubActivitiesDialog() {
      if (this.properties.params == null) {
        this.userSubActivitiesList = [];
      }

      // Clear category filters
      this.categoryFiltersSelected = [];
      this.unselectAllCategories(this.categoryFiltersAll);

      this.subActivitiesDialog = false;
    },
    cancelTourDialog() {
      if (this.properties.params == null) {
        this.userTourList = [];
      }
      this.eventTourDialog = false;
    },
    cancelDeliveryFeesDialog() {
      if (this.properties.params == null) {
        this.eventDeliveryFees = [];
      }
      this.deliveryFeesDialog = false;
    },
    cancelPriceCategoriesDialog() {
      if (this.properties.params == null) {
        this.eventPriceCategories = [];
      }
      this.priceCategoriesDialog = false;
    },
    cancelPoliciesDialog() {
      if (this.properties.params == null) {
        this.eventPolicies = [];
      }
      this.policiesDialog = false;
    },
    cancelAlternativesDialog() {
      if (this.properties.params == null) {
        this.userAlternativesList = [];
      }

      // Clear category filters
      this.categoryFiltersSelected = [];
      this.unselectAllCategories(this.categoryFiltersAll);

      this.eventAlternativesDialog = false;
    },
    cancelSuggestionsDialog() {
      if (this.properties.params == null) {
        this.userSuggestionsList = [];
      }

      // Clear category filters
      this.categoryFiltersSelected = [];
      this.unselectAllCategories(this.categoryFiltersAll);

      this.eventSuggestionsDialog = false;
    },
    removeFromSelected(data) {
      if (data == "sub") {
        if (this.userSelectionForSubActivities !== undefined) {
          for (let i = 0; i < this.userSelectionForSubActivities.length; i++) {
            const found = this.subActivitiesList.some(
              (el) =>
                el.eventId === this.userSelectionForSubActivities[i].eventId
            );
            if (!found) {
              this.subActivitiesList.push(
                this.userSelectionForSubActivities[i]
              );
            }
            this.removeByAttr(
              this.userSubActivitiesList,
              "eventId",
              this.userSelectionForSubActivities[i].eventId
            );
          }

          this.subActivitiesList.sort((a, b) =>
            a.name.localeCompare(b.name, "en", {
              sensitivity: "base",
            })
          );
        }
        this.selectedSubActivities = [];
      } else if (data == "alt") {
        if (this.userSelectionForAlternatives !== undefined) {
          for (let i = 0; i < this.userSelectionForAlternatives.length; i++) {
            const found = this.alternativesList.some(
              (el) =>
                el.eventId === this.userSelectionForAlternatives[i].eventId
            );
            if (!found) {
              this.alternativesList.push(this.userSelectionForAlternatives[i]);
            }
            this.removeByAttr(
              this.userAlternativesList,
              "eventId",
              this.userSelectionForAlternatives[i].eventId
            );
          }

          this.alternativesList.sort((a, b) =>
            a.name.localeCompare(b.name, "en", {
              sensitivity: "base",
            })
          );
        }
        this.selectedAlternatives = [];
      } else if (data == "sug") {
        if (this.userSelectionForSuggestions !== undefined) {
          for (let i = 0; i < this.userSelectionForSuggestions.length; i++) {
            const found = this.suggestionsList.some(
              (el) => el.eventId === this.userSelectionForSuggestions[i].eventId
            );
            if (!found) {
              this.suggestionsList.push(this.userSelectionForSuggestions[i]);
            }
            this.removeByAttr(
              this.userSuggestionsList,
              "eventId",
              this.userSelectionForSuggestions[i].eventId
            );
          }

          this.suggestionsList.sort((a, b) =>
            a.name.localeCompare(b.name, "en", {
              sensitivity: "base",
            })
          );
        }
        this.selectedSuggestions = [];
      } else {
        if (this.userSelectionForTour !== undefined) {
          for (let i = 0; i < this.userSelectionForTour.length; i++) {
            const found = this.tourList.some(
              (el) => el.eventId === this.userSelectionForTour[i].eventId
            );
            if (!found) {
              this.tourList.push(this.userSelectionForTour[i]);
            }
            this.removeByAttr(
              this.userTourList,
              "eventId",
              this.userSelectionForTour[i].eventId
            );
          }

          this.tourList.sort((a, b) =>
            a.name.localeCompare(b.name, "en", {
              sensitivity: "base",
            })
          );
        }
        this.selectedTourActivities = [];
      }
    },
    addToSelected(data) {
      if (data == "sub") {
        if (this.selectedSubActivities !== undefined) {
          for (let i = 0; i < this.selectedSubActivities.length; i++) {
            const found = this.userSubActivitiesList.some(
              (el) => el.eventId === this.selectedSubActivities[i].eventId
            );
            if (!found) {
              this.userSubActivitiesList.push(this.selectedSubActivities[i]);
            }
            this.removeByAttr(
              this.subActivitiesList,
              "eventId",
              this.selectedSubActivities[i].eventId
            );
          }
          this.userSubActivitiesList.sort((a, b) =>
            a.name.localeCompare(b.name, "en", {
              sensitivity: "base",
            })
          );
        }
        this.userSelectionForSubActivities = [];
      } else if (data == "alt") {
        if (this.selectedAlternatives !== undefined) {
          for (let i = 0; i < this.selectedAlternatives.length; i++) {
            const found = this.userAlternativesList.some(
              (el) => el.eventId === this.selectedAlternatives[i].eventId
            );
            if (!found) {
              this.userAlternativesList.push(this.selectedAlternatives[i]);
            }
            this.removeByAttr(
              this.alternativesList,
              "eventId",
              this.selectedAlternatives[i].eventId
            );
          }
          this.userAlternativesList.sort((a, b) =>
            a.name.localeCompare(b.name, "en", {
              sensitivity: "base",
            })
          );
        }
        this.userSelectionForAlternatives = [];
      } else if (data == "sug") {
        if (this.selectedSuggestions !== undefined) {
          for (let i = 0; i < this.selectedSuggestions.length; i++) {
            const found = this.userSuggestionsList.some(
              (el) => el.eventId === this.selectedSuggestions[i].eventId
            );
            if (!found) {
              this.userSuggestionsList.push(this.selectedSuggestions[i]);
            }
            this.removeByAttr(
              this.suggestionsList,
              "eventId",
              this.selectedSuggestions[i].eventId
            );
          }
          this.userSuggestionsList.sort((a, b) =>
            a.name.localeCompare(b.name, "en", {
              sensitivity: "base",
            })
          );
        }
        this.userSelectionForSuggestions = [];
      } else {
        if (this.selectedTourActivities !== undefined) {
          for (let i = 0; i < this.selectedTourActivities.length; i++) {
            const found = this.userTourList.some(
              (el) => el.eventId === this.selectedTourActivities[i].eventId
            );
            if (!found) {
              this.userTourList.push(this.selectedTourActivities[i]);
            }
            this.removeByAttr(
              this.tourList,
              "eventId",
              this.selectedTourActivities[i].eventId
            );
          }
          this.userTourList.sort((a, b) => a.seqNr - b.seqNr);
        }
        this.userSelectionForTour = [];
      }
    },
    removeByAttr(arr, attr, value) {
      let i = arr.length;
      while (i--) {
        if (
          arr[i] &&
          arr[i].hasOwnProperty(attr) &&
          arguments.length > 2 &&
          arr[i][attr] === value
        ) {
          arr.splice(i, 1);
        }
      }
      return arr;
    },
    showDeliveryFees() {
      if (this.newEventId == null) {
        this.saveEventFirstDialog = true;
      } else {
        this.deliveryFeesDialog = true;
      }
    },
    showPriceCategories() {
      if (this.newEventId == null) {
        this.saveEventFirstDialog = true;
      } else {
        this.getPriceCategories();
        this.priceCategoriesDialog = true;
      }
    },
    showBookingPolicies() {
      if (this.newEventId == null) {
        this.saveEventFirstDialog = true;
      } else {
        this.getPolicies();
        this.policiesDialog = true;
      }
    },
    showActivitiesList() {
      if (this.newEventId == null) {
        this.saveEventFirstDialog = true;
      } else {
        this.getPotentialChildrenEvents();
        this.selectedSubActivities = [];
        this.userSelectionForSubActivities = [];
        this.subActivitiesDialog = true;
      }
    },
    showTourList() {
      if (this.newEventId == null) {
        this.saveEventFirstDialog = true;
      } else {
        this.getPotentialTourEvents();
        this.selectedTourActivities = [];
        this.userSelectionForTour = [];
        this.eventTourDialog = true;
      }
    },
    showAlternativesList() {
      if (this.newEventId == null) {
        this.saveEventFirstDialog = true;
      } else {
        this.getPotentialAlternativesEvents();
        this.selectedAlternatives = [];
        this.userSelectionForAlternatives = [];
        this.eventAlternativesDialog = true;
      }
    },
    showSuggestionsList() {
      if (this.newEventId == null) {
        this.saveEventFirstDialog = true;
      } else {
        this.getPotentialSuggestionsEvents();
        this.selectedSuggestions = [];
        this.userSelectionForSuggestions = [];
        this.eventSuggestionsDialog = true;
      }
    },
    getPotentialTourEvents() {
      const filtersForTourActivities = {};

      for (const [key, value] of Object.entries(this.selectedTourTags)) {
        if (!_.isEmpty(value)) {
          for (const [innerKey, innerValue] of Object.entries(value)) {
            filtersForTourActivities[innerValue] = innerValue;
          }
        }
      }
      this.userSelectionForTour = [];
      this.tourList = [];
      const payload = {
        FunctionId: "EventFunctionLibrary::getPotentialTourActivities",
        EventId: Number(this.newEventId),
        Filters: filtersForTourActivities,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call getPotentialTourActivities was successful",
            response
          );
          if (!response.hasOwnProperty("data")) {
            console.log("error, in the response is no data available");
          }

          const tmpActivities = BaseObject._toLowerCaseInitialProperty(
            BaseObject._createArrayWithObjects(response.data.Events)
          );
          tmpActivities.sort((a, b) =>
            a.name.localeCompare(b.name, "en", {
              sensitivity: "base",
            })
          );
          this.tourList = tmpActivities.filter(
            (e) => e.eventId != this.eventCreationForm.eventId
          );
          this.getTourActivities();
        },
        (error) => {
          console.log(
            "The generic call getPotentialTourActivities was not successful",
            error
          );
        },
        "communicateWithDBLibrary",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    getPotentialChildrenEvents() {
      // const filtersForSubActivities = {};

      // for (const [key, value] of Object.entries(this.selectedSubActivitiesTags)) {
      //   if (!_.isEmpty(value)) {
      //     for (const [innerKey, innerValue] of Object.entries(value)) {
      //       filtersForSubActivities[innerValue] = innerValue;
      //     }
      //   }
      // }
      // console.log('filtersforSubActivities', filtersForSubActivities);
      // this.userSelectionForSubActivities = [];
      // this.subActivitiesList = [];
      // const payload = {
      //   FunctionId: 'EventFunctionLibrary::getPotentialChildrenEvents',
      //   EventId: Number(this.newEventId),
      //   Filters: filtersForSubActivities,
      // };
      // dssRequest.doRequest(
      //   (response) => {
      //     console.log(
      //       'The generic call getPotentialChildrenEvents was successful',
      //       response,
      //     );
      //     if (!response.hasOwnProperty('data')) {
      //       console.log('error, in the response is no data available');
      //     }

      //     const tmpActivities = BaseObject._toLowerCaseInitialProperty(
      //       BaseObject._createArrayWithObjects(response.data.Events),
      //     );
      //     tmpActivities.sort((a, b) => a.name.localeCompare(b.name, 'en', {
      //       sensitivity: 'base',
      //     }));
      //     this.subActivitiesList = tmpActivities.filter(
      //       (e) => e.eventId != this.eventCreationForm.eventId,
      //     );
      //     this.getChildren();
      //   },
      //   (error) => {
      //     console.log(
      //       'The generic call getPotentialChildrenEvents was not successful',
      //       error,
      //     );
      //   },
      //   'communicateWithDBLibrary',
      //   appConfig.dss.eventAdminMng,
      //   payload,
      // );

      // New implementation with categories
      this.userSelectionForSubActivities = [];
      this.subActivitiesList = [];

      let payload = {
        LanguageTagId: this.$store.getters.getUserLanguage,
        InterestIds: [],
      };

      let categoryFiltersSelectedTmp = [];
      if (this.categoryFiltersSelected.length > 0) {
        this.categoryFiltersSelected.forEach((category) =>
          categoryFiltersSelectedTmp.push(category.InterestId)
        );
      } else {
        this.getAllCategoryIds(
          this.categoryFiltersAll,
          categoryFiltersSelectedTmp
        );
      }

      categoryFiltersSelectedTmp.forEach((categoryId) =>
        payload.InterestIds.push(categoryId)
      );

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call [getEventsByInterestIds] on [LocationsNode_ESE] in component [EventCreation] succeeded",
            response
          );
          if (response.data.Events.length > 0) {
            const tmpActivities = BaseObject._toLowerCaseInitialProperty(
              response.data.Events
            );
            tmpActivities.sort((a, b) =>
              a.name.localeCompare(b.name, "en", {
                sensitivity: "base",
              })
            );
            this.subActivitiesList = tmpActivities.filter(
              (e) => e.eventId != this.eventCreationForm.eventId
            );
          }

          this.categoryFiltersSelected = [];
          this.unselectAllCategories(this.categoryFiltersAll);

          this.getChildren();
        },
        (error) => {
          console.log(
            "The call [getEventsByInterestIds] on [LocationsNode_ESE] in component [EventCreation] failed",
            error
          );
        },
        "getEventsByInterestIds",
        "LocationsNode_ESE",
        payload
      );
    },
    getPotentialAlternativesEvents() {
      // const filtersForAlternatives = {};

      // for (const [key, value] of Object.entries(this.selectedAlternativesTags)) {
      //   if (!_.isEmpty(value)) {
      //     for (const [innerKey, innerValue] of Object.entries(value)) {
      //       filtersForAlternatives[innerValue] = innerValue;
      //     }
      //   }
      // }
      // this.userSelectionForAlternatives = [];
      // this.alternativesList = [];
      // const payload = {
      //   EventId: Number(this.newEventId),
      //   Filters: filtersForAlternatives,
      // };
      // dssRequest.doRequest(
      //   (response) => {
      //     console.log(
      //       'The generic call getPotentialAlternativeEvents was successful',
      //       response,
      //     );
      //     if (!response.hasOwnProperty('data')) {
      //       console.log('error, in the response is no data available');
      //     }

      //     const tmpActivities = BaseObject._toLowerCaseInitialProperty(
      //       BaseObject._createArrayWithObjects(response.data.Alternatives),
      //     );
      //     tmpActivities.sort((a, b) => a.name.localeCompare(b.name, 'en', {
      //       sensitivity: 'base',
      //     }));
      //     this.alternativesList = tmpActivities.filter(
      //       (e) => e.eventId != this.eventCreationForm.eventId,
      //     );
      //     this.getAlternatives();
      //   },
      //   (error) => {
      //     console.log(
      //       'The generic call getPotentialAlternativeEvents was not successful',
      //       error,
      //     );
      //   },
      //   'getPotentialAlternativeEvents',
      //   appConfig.dss.eventAdminMng,
      //   payload,
      // );

      // New implementation with categories
      this.userSelectionForAlternatives = [];
      this.alternativesList = [];

      let payload = {
        LanguageTagId: this.$store.getters.getUserLanguage,
        InterestIds: [],
      };

      let categoryFiltersSelectedTmp = [];
      if (this.categoryFiltersSelected.length > 0) {
        this.categoryFiltersSelected.forEach((category) =>
          categoryFiltersSelectedTmp.push(category.InterestId)
        );
      } else {
        this.getAllCategoryIds(
          this.categoryFiltersAll,
          categoryFiltersSelectedTmp
        );
      }

      categoryFiltersSelectedTmp.forEach((categoryId) =>
        payload.InterestIds.push(categoryId)
      );

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call [getEventsByInterestIds] on [LocationsNode_ESE] in component [EventCreation] succeeded",
            response
          );
          if (response.data.Events.length > 0) {
            const tmpAlternatives = BaseObject._toLowerCaseInitialProperty(
              response.data.Events
            );
            tmpAlternatives.sort((a, b) =>
              a.name.localeCompare(b.name, "en", {
                sensitivity: "base",
              })
            );
            this.alternativesList = tmpAlternatives.filter(
              (e) => e.eventId != this.eventCreationForm.eventId
            );
          }

          this.getAlternatives();
        },
        (error) => {
          console.log(
            "The call [getEventsByInterestIds] on [LocationsNode_ESE] in component [EventCreation] failed",
            error
          );
        },
        "getEventsByInterestIds",
        "LocationsNode_ESE",
        payload
      );
    },
    getPotentialSuggestionsEvents() {
      const filtersForSuggestions = {};

      for (const [key, value] of Object.entries(this.selectedSuggestionsTags)) {
        if (!_.isEmpty(value)) {
          for (const [innerKey, innerValue] of Object.entries(value)) {
            filtersForSuggestions[innerValue] = innerValue;
          }
        }
      }
      this.userSelectionForSuggestions = [];
      this.suggestionsList = [];
      let payload = {};

      if (this.$store.getters["auth/partnerId"] == -1) {
        payload = {
          EventId: Number(this.newEventId),
          Filters: filtersForSuggestions,
        };
      } else {
        payload = {
          EventId: Number(this.newEventId),
          Filters: filtersForSuggestions,
          PartnerId: this.$store.getters["auth/partnerId"],
        };
      }
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call getPotentialSuggestionsEvents was successful",
            response
          );
          if (!response.hasOwnProperty("data")) {
            console.log("error, in the response is no data available");
          }

          const tmpActivities = BaseObject._toLowerCaseInitialProperty(
            BaseObject._createArrayWithObjects(response.data.Suggestions)
          );
          tmpActivities.sort((a, b) =>
            a.name.localeCompare(b.name, "en", {
              sensitivity: "base",
            })
          );
          this.suggestionsList = tmpActivities.filter(
            (e) => e.eventId != this.eventCreationForm.eventId
          );
          this.getSuggestions();
        },
        (error) => {
          console.log(
            "The generic call getPotentialSuggestionsEvents was not successful",
            error
          );
        },
        "getPotentialSuggestionEvents",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    getAccounts() {
      // This used to be the function getAccount on CommmunicateWithDBLibrary
      this.accounts = [];
      const payload = {
        FunctionId: "dbAction",
        Action: "SELECT",
        ReplyName: "Account",
        TableName: "config.Account",
        Columns: {},
      };
      dssRequest.doRequest(
        (response) => {
          console.log("The generic call getAccount was successful", response);
          if (!response.hasOwnProperty("data")) {
            console.log("error, in the response is no data available");
          }
          const tmpAccounts = BaseObject._toLowerCaseInitialProperty(
            BaseObject._createArrayWithObjects(response.data.Account)
          );
          tmpAccounts.sort((a, b) =>
            a.accountName.localeCompare(b.accountName, "en", {
              sensitivity: "base",
            })
          );
          tmpAccounts.forEach((e) => {
            if (e.accountId != this.currentAccountId) this.accounts.push(e);
          });

          console.log(
            "accounts initialized in EventCreation component: ",
            this.accounts
          );
        },
        (error) => {
          console.log("The generic call getAccount was not successful", error);
        },
        "communicateWithDBLibrary",
        appConfig.dss.locationMgr,
        payload
      );
    },
    setImageElement(e) {
      if (e.signalName == this.multiPicturesProperties.signalName) {
        if (e.url === "") {
          this.multiPicturesProperties.pictureUrl = [];
        } else {
          this.multiPicturesProperties.pictureUrl.push(e.url);
        }
      }
    },
    closeProductCategoriesTranslations() {
      this.openProductCategoriesTranslations = false;
    },
    saveProductCategoriesTranslations(translationData) {
      let payload = {};
      payload.Translations = translationData;
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call for saveProductCategoriesTranslations on - EventCreation.vue - was successful",
            response
          );
          this.openProductCategoriesTranslations = false;
        },
        (error) => {
          console.log(
            "The call for saveProductCategoriesTranslations on - EventCreation.vue - was not successful",
            error
          );
          // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
        },
        "saveProductCategoriesTranslations",
        Number(this.eventCreationForm.eventId),
        payload
      );
    },
    closePriceCategoryTranslations() {
      this.openPriceCategoryTranslations = false;
    },
    savePriceCategoryTranslations(translationData) {
      console.log("Lorenzo translationData", translationData);
      let payload = {
        Pricecategory: Number(this.selectedPriceCategory.Id),
      };
      payload.Translations = translationData;
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call for savePriceCategoryTranslations on - EventCreation.vue - was successful",
            response
          );
          this.openPriceCategoryTranslations = false;
        },
        (error) => {
          console.log(
            "The call for savePriceCategoryTranslations on - EventCreation.vue - was not successful",
            error
          );
          // window.EventBus.fire("triggerGenericErrorDialog", error.errorMsg);
        },
        "savePriceCategoryTranslations",
        Number(this.eventCreationForm.eventId),
        payload
      );
    },
    setSelectedTags(data) {
      this.selectedTags = data;
    },
    setSelectedSubActivitiesTags(data) {
      this.selectedSubActivitiesTags = data;
    },
    setSelectedTourTags(data) {
      this.selectedTourTags = data;
    },
    setSelectedAlternativesTags(data) {
      this.selectedAlternativesTags = data;
    },
    setSelectedSuggestionsTags(data) {
      this.selectedSuggestionsTags = data;
    },
    sendSignalToGetEvents() {
      window.EventBus.fire("getEventsBasedOnUserLevel", null);
    },
    dragInfo(item) {
      console.log("the dragged item is: ", item);
    },
    saveEventCreation() {
      console.log("Brian this.eventCreationForm check it NOW", this.eventCreationForm);

      console.log(
        "eventCreationForm to be saved: ",
        this.eventCreationForm,
        this.locationProps.params
      );

      if (this.eventCreationForm.hasOwnProperty("eventPartner")) {
        // If partner id is available, owner of event is the partner
        if (this.$store.getters["auth/partnerId"] !== -1) {
          this.eventCreationForm.owner = this.$store.getters["auth/partnerId"];
        } else {
          this.eventCreationForm.owner = this.$store.getters["auth/userName"];
        }
      } else {
        this.eventCreationForm.owner = this.$store.getters["auth/userName"];
      }

      if (this.$store.getters["auth/partnerId"] == -1) {
        if (this.eventCreationForm.eventPartner !== undefined) {
          if (this.eventCreationForm.eventPartner.hasOwnProperty("id")) {
            this.eventCreationForm.partnerId = this.eventCreationForm.eventPartner.id;
          } else if (this.eventCreationForm.hasOwnProperty("eventPartner")) {
            this.eventCreationForm.partnerId = this.eventCreationForm.eventPartner;
          } else {
            this.eventCreationForm.partnerId = this.$store.getters[
              "auth/partnerId"
            ];
          }
        } else {
          this.eventCreationForm.partnerId = this.$store.getters[
            "auth/partnerId"
          ];
        }
      } else {
        this.eventCreationForm.partnerId = this.$store.getters[
          "auth/partnerId"
        ];
      }
      if (
        this.eventCreationForm.partnerId == undefined ||
        this.eventCreationForm.partnerId == null
      ) {
        this.eventCreationForm.partnerId = -1;
      }

      if (this.eventCreationForm.type !== "OrderEvent")
        this.eventCreationForm.deliveryPartner = "";
      const toStoreCards = {};
      if (this.userDiscountCards.length > 0) {
        this.userDiscountCards.forEach((e) => {
          console.log("e", e.Key);
          toStoreCards[Number(e.Key)] = e.DiscountPercentage;
        });
        this.eventCreationForm.discountCards = toStoreCards;
      } else {
        this.eventCreationForm.discountCards = {};
      }

      const toStoreProductCategories = [];
      if (this.userProductCategories.length > 0) {
        this.userProductCategories.forEach((e) => {
          if (e.hasOwnProperty("Id")) {
            toStoreProductCategories.push({
              Id: e.Id,
              Description: e.Description,
            });
          } else {
            toStoreProductCategories.push({ Description: e.Description });
          }
        });
        this.eventCreationForm.productCategories = toStoreProductCategories;
      } else {
        this.eventCreationForm.productCategories = [];
      }

      const toStoreRewards = {};
      if (this.rewardsSelected.length > 0) {
        this.rewardsSelected.forEach((e) => {
          toStoreRewards[e.Name] = e.RewardLevel;
        });
        this.eventCreationForm.rewardLevels = toStoreRewards;
      } else {
        this.eventCreationForm.rewardLevels = {};
      }
      const toStoreParentEvents = {};
      if (this.themesSelected.length > 0) {
        this.themesSelected.forEach((e) => {
          if (e.key !== undefined) {
            toStoreParentEvents[e.EventId] = e.EventId;
          } else {
            toStoreParentEvents[e.EventId] = e.EventId;
          }
        });
        this.eventCreationForm.parentEvents = toStoreParentEvents;
      } else {
        this.eventCreationForm.parentEvents = {};
      }
      const toStoreParentEventRewards = {};
      if (this.eventRewardsSelected.length > 0) {
        this.eventRewardsSelected.forEach((e) => {
          toStoreParentEventRewards[e.Key] = e.Reward;
        });
        this.eventCreationForm.parentEventRewards = toStoreParentEventRewards;
      } else {
        this.eventCreationForm.parentEventRewards = {};
      }
      const toStoreExtraLocations = [];
      if (this.eventExtraLocationsSelected.length > 0) {
        this.eventExtraLocationsSelected.forEach((e) => {
          toStoreExtraLocations.push({
            Capacity: e.hasOwnProperty("Capacity") ? e.Capacity : e.capacity,
            LocationId: e.hasOwnProperty("LocationId")
              ? e.LocationId
              : e.locationId,
          });
        });
        this.eventCreationForm.extraLocations = toStoreExtraLocations;
      } else {
        this.eventCreationForm.extraLocations = [];
      }
      // TODO: Verify form is not attempting to submit empty defaults...
      if (this.eventCreationForm.leadTimeMin == null) {
        this.eventCreationForm.leadTimeMin = 0;
        this.eventCreationForm.leadTime = 0;
      } else {
        this.eventCreationForm.leadTime =
          this.eventCreationForm.leadTimeMin * 60;
      }
      if (this.eventCreationForm.cooldownTimeMin == null) {
        this.eventCreationForm.cooldownTimeMin = 0;
        this.eventCreationForm.cooldownTime = 0;
      } else {
        this.eventCreationForm.cooldownTime =
          this.eventCreationForm.cooldownTimeMin * 60;
      }
      if (this.eventCreationForm.type === "Rental") {
        if (this.eventCreationForm.durationMin == null) {
          this.eventCreationForm.durationMin = 1439.98333;
        }
      }
      if (this.$refs.eventCreationForm.validate() && this.newEventId == null) {
        this.setEventName = this.eventCreationForm.name;

        if (this.multiPicturesProperties.pictureUrl.length > 0) {
          this.eventCreationForm.picture = this.multiPicturesProperties.pictureUrl[0];
        }

        let extraPictures = [];
        if (this.multiPicturesProperties.pictureUrl.length > 1) {
          extraPictures = this.multiPicturesProperties.pictureUrl.slice(1);
          this.eventCreationForm.extraPictures = {};
          extraPictures.forEach((element, index) => {
            this.eventCreationForm.extraPictures[index] = element;
          });
        }

        this.eventCreationForm.selectedTags = this.selectedTags;

        if (this.eventCreationForm.type === undefined) {
          this.eventCreationForm.type = "";
        }
        if (this.eventCreationForm.infoUrl === undefined) {
          this.eventCreationForm.infoUrl = "";
        }
        if (this.eventCreationForm.endLocationId === undefined) {
          this.eventCreationForm.endLocationId = "";
        }
        if (this.eventCreationForm.eventRanking == null) {
          this.eventCreationForm.eventRanking = 0;
        }
        if (this.eventCreationForm.eventBudget == null) {
          this.eventCreationForm.eventBudget = 0;
        }
        if (this.eventCreationForm.maxEventCapacity == null) {
          this.eventCreationForm.maxEventCapacity = 0;
        }
        if (
          this.eventCreationForm.type === "Relay" ||
          this.eventCreationForm.type === "Tour"
        ) {
          this.relayData.waypoints = this.locationProps.params.route.DataFieldTable.Waypoints;
          this.relayData.PathPoints = this.locationProps.params.route.DataFieldTable.PathPoints;
          this.relayData.TravelMode = this.locationProps.params.route.DataFieldTable.TravelMode;
          this.relayData.Duration = this.locationProps.params.route.DataFieldTable.Duration;
          this.relayData.Distance = this.locationProps.params.route.Distance;
          this.relayData.AverageSpeed = this.eventCreationForm.averageSpeed;
        }
        const payload = CreateEventCreationObject._createRequestObject(
          this.eventCreationForm,
          this.accountsSelected,
          this.relayData
        );

        if (
          this.eventCreationForm.type === "Relay" ||
          this.eventCreationForm.type === "Tour"
        ) {
          payload.FunctionId = "EventFunctionLibrary::saveRelay";
        } else {
          payload.FunctionId = "EventFunctionLibrary::saveEvent";
        }

        // Add selected categories to payload
        payload.Interests = [];
        this.eventCategoriesSelected.forEach((category) =>
          payload.Interests.push(category.InterestId)
        );

        // Add selected related (pickup/delivery) events if event is type of 'Webshop'
        if (this.eventCreationForm.type === "Webshop") {
          payload.RelatedEvents = [];
          if (this.relatedEventsToBeSaved !== undefined) {
            this.relatedEventsToBeSaved.forEach((relatedEvent) =>
              payload.RelatedEvents.push(relatedEvent.EventId)
            );
          }
        }

        if (this.eventCreationForm.type === 'Promotion') {
          console.log("Lorenzo this.chosenStartDate, this.startTime", this.chosenStartDate, this.startTime);
          payload.ReleaseDate = this.formatDate(this.chosenStartDate);
          payload.ReleaseTime = this.startTime;
          payload.ExpirationDate = this.formatDate(this.chosenEndDate);
          payload.ExpirationTime = this.endTime;
        }

        console.log("Brian PLEAS PLEAS PLEAS payload", payload);

        dssRequest.doRequest(
          (response) => {
            console.log("The generic call saveEvent was successful", response);
            if (!response.hasOwnProperty("data")) {
              console.log("error, in the response is no data available");
            }
            window.EventBus.fire(
              "activateSnackBar",
              "Event data is stored successfully !"
            );
            this.showEventLanguages = true;
            this.newEventId = Number(response.data.EventId);
            this.sendSignalToGetEvents();
            this.saveEventTranslationOnSavingEvent();
          },
          (error) => {
            console.log("The generic call saveEvent was not successful", error);
          },
          "communicateWithDBLibrary",
          appConfig.dss.eventAdminMng,
          payload
        );
      } else if (
        this.$refs.eventCreationForm.validate() &&
        this.newEventId !== null
      ) {
        this.eventCreationForm.eventId = this.newEventId;
        this.setEventName = this.eventCreationForm.name;
        if (this.eventCreationForm.hasOwnProperty("eventPartner")) {
          // If partner id is available, owner of event is the partner
          if (this.$store.getters["auth/partnerId"] !== -1) {
            this.eventCreationForm.owner = this.$store.getters[
              "auth/partnerId"
            ];
          } else {
            this.eventCreationForm.owner = this.$store.getters["auth/userName"];
          }
        } else {
          this.eventCreationForm.owner = this.$store.getters["auth/userName"];
        }

        if (this.multiPicturesProperties.pictureUrl.length > 0) {
          this.eventCreationForm.picture = this.multiPicturesProperties.pictureUrl[0];
        }

        let extraPictures = [];
        if (this.multiPicturesProperties.pictureUrl.length > 1) {
          extraPictures = this.multiPicturesProperties.pictureUrl.slice(1);
          this.eventCreationForm.extraPictures = {};
          extraPictures.forEach((element, index) => {
            this.eventCreationForm.extraPictures[index] = element;
          });
        }
        if (
          this.eventCreationForm.type === "Relay" ||
          this.eventCreationForm.type === "Tour"
        ) {
          this.relayData.waypoints = this.locationProps.params.route.DataFieldTable.Waypoints;
          this.relayData.PathPoints = this.locationProps.params.route.DataFieldTable.PathPoints;
          this.relayData.TravelMode = this.locationProps.params.route.DataFieldTable.TravelMode;
          this.relayData.Duration = this.locationProps.params.route.DataFieldTable.Duration;
          this.relayData.Distance = this.locationProps.params.route.Distance;
          this.relayData.AverageSpeed = this.eventCreationForm.averageSpeed;
        }
        this.eventCreationForm.selectedTags = this.selectedTags;

        const payload = CreateEventCreationObject._createRequestObject(
          this.eventCreationForm,
          this.accountsSelected,
          this.relayData
        );
        if (
          this.eventCreationForm.type === "Relay" ||
          this.eventCreationForm.type === "Tour"
        ) {
          payload.FunctionId = "EventFunctionLibrary::saveRelay";
        } else {
          payload.FunctionId = "EventFunctionLibrary::saveEvent";
        }

        if (this.eventCreationForm.type === 'Promotion') {
          console.log("Lorenzo this.chosenStartDate, this.startTime", this.chosenStartDate, this.startTime);
          payload.ReleaseDate = this.formatDate(this.chosenStartDate);
          payload.ReleaseTime = this.startTime;
          payload.ExpirationDate = this.formatDate(this.chosenEndDate);
          payload.ExpirationTime = this.endTime;
        }

        // Add selected categories to payload
        payload.Interests = [];
        this.eventCategoriesSelected.forEach((category) =>
          payload.Interests.push(category.InterestId)
        );

        // Add selected related (pickup/delivery) events if event is type of 'Webshop'
        if (this.eventCreationForm.type === "Webshop") {
          payload.RelatedEvents = [];
          if (this.relatedEventsToBeSaved !== undefined) {
            this.relatedEventsToBeSaved.forEach((relatedEvent) =>
              payload.RelatedEvents.push(relatedEvent.EventId)
            );
          }
        }
        console.log("eventCreationForm: ", this.eventCreationForm);
        console.log("payload for saveEvent: ", payload);

        dssRequest.doRequest(
          (response) => {
            if (
              this.eventCreationForm.type === "Relay" ||
              this.eventCreationForm.type === "Tour"
            ) {
              console.log(
                "The generic call saveRelay was successful",
                response
              );
            } else {
              console.log(
                "The generic call saveEvent was successful",
                response
              );
            }
            if (!response.hasOwnProperty("data")) {
              console.log("error, in the response is no data available");
            }
            this.locationProps.params.location = {};
            this.relayData = {};
            this.showEventLanguages = true;
            this.sendSignalToGetEvents();
          },
          (error) => {
            if (
              this.eventCreationForm.type === "Relay" ||
              this.eventCreationForm.type === "Tour"
            ) {
              console.log(
                "The generic call saveRelay was not successful",
                error
              );
            } else {
              console.log(
                "The generic call saveEvent was not successful",
                error
              );
            }
          },
          "communicateWithDBLibrary",
          appConfig.dss.eventAdminMng,
          payload
        );
      } else {
        this.errorDialog = true;
      }
    },
    continueToLanguages() {
      this.showEventLanguages = true;
    },
    saveEventTranslationOnSavingEvent() {
      console.log(
        "event id and name at saving translation",
        this.newEventId,
        this.eventCreationForm.name
      );
      const payload = {
        EventId: Number(this.newEventId),
        13: {
          EventTranslationName: this.eventCreationForm.name,
          Description: "",
          ArrivalText: "",
          DepartureText: "",
          ArrivalAudio: "",
          DepartureAudio: "",
          Question: "",
          CorrectAnswer: "",
          AnswerA: "",
          AnswerB: "",
        },
        FunctionId: "EventFunctionLibrary::saveEventTranslation",
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call saveEventTranslation was successful",
            response
          );
        },
        (error) => {
          console.log(
            "The generic call saveEventTranslation was not successful",
            error
          );
        },
        "communicateWithDBLibrary",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    getAllLocations() {
      if (this.$store.getters.getAllVisibleLocations.length !== 0) {
        this.$store.getters.getAllVisibleLocations.forEach((e) => {
          this.locations.push({ name: e.Name, locationId: e.Id });
        });
        return;
      }
      const payload = {
        PartnerId: this.$store.getters["auth/partnerId"],
        FunctionId: "LocationFunctionLibrary::getLocationsV2",
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call 'getLocationsV2' on - EventCreation.vue - was successful",
            response
          );
          if (!response.data.hasOwnProperty("Locations")) {
            // window.EventBus.fire('triggerGenericErrorDialog', 'W_GL_001');
            return;
          }
          if (!response.hasOwnProperty("data")) {
            console.log("error, in the response is no data available");
          }
          const locationBulk = LocationObject._createArrayWithObjects(
            response.data.Locations
          );
          this.locations = locationBulk.map((E) => ({
            name: E.name,
            locationId: E.locationId,
          }));
        },
        (error) => {
          console.log(
            "The generic call 'getLocationsV2' on - EventCreation.vue - was not successful",
            error
          );
          // window.EventBus.fire('triggerGenericErrorDialog', 'W_GL_001');
        },
        "communicateWithDBLibrary",
        appConfig.dss.locationMgr,
        payload,
        600000,
        false
      );
    },
    handleSubActivitiesTagsDataAfterRecieved(data) {
      if (data.length > 0) {
        this.selectedTagsInArrayForSubActivities = data.split(",");
      } else {
        this.selectedTagsInArrayForSubActivities = [];
      }
    },
    handleTourTagsDataAfterRecieved(data) {
      if (data.length > 0) {
        this.selectedTagsInArrayForTourActivities = data.split(",");
      } else {
        this.selectedTagsInArrayForTourActivities = [];
      }
    },
    handleAlternativesTagsDataAfterRecieved(data) {
      if (data.length > 0) {
        this.selectedTagsInArrayForAlternatives = data.split(",");
      } else {
        this.selectedTagsInArrayForAlternatives = [];
      }
    },
    handleSuggestionsTagsDataAfterRecieved(data) {
      if (data.length > 0) {
        this.selectedTagsInArrayForSuggestions = data.split(",");
      } else {
        this.selectedTagsInArrayForSuggestions = [];
      }
    },
    handleFcAfterDateBack(event) {
      this.showEventLanguages = false;
      this.getEventDetails(event);
    },
    getEventDetails(item) {
      console.log("Lorenzo kom ik hier doorheen");
      const payload = {
        EventId: Number(item),
        LanguageTagId: this.$store.getters.getUserLanguage,
        FullPicture: true,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call getEventDetails was successful",
            response
          );
          this.eventCreationForm = BaseObject._toLowerCaseObjectPropertiesAtFirstLevel(
            response.data
          );

          if (this.eventCreationForm !== null) {
            console.log(
              "event creationform to check for the error message",
              this.eventCreationForm
            );
            if (
              (this.properties.params.hasOwnProperty("type") &&
                this.properties.params.type === "Relay") ||
              this.properties.params.type === "Tour"
            ) {
              this.eventCreationForm.relay = _.transform(
                this.eventCreationForm.relay,
                (result, val, key) => {
                  result[key.toLowerCase()] = val;
                }
              );
              this.eventCreationForm.endLocationId = this.eventCreationForm.relay.endlocationid;
              this.handleTourOrRelay();
              // setTimeout(() => {
              //   // window.EventBus.fire("generatePolyline", false);
              //   window.EventBus.fire("addMarkers");
              //   window.EventBus.fire(
              //     "addWaypointMarkers",
              //     this.waypointsOrderResult
              //   );
              // }, 600);
            }
            console.log("Brian this.eventCreationForm", this.eventCreationForm);

            if (this.eventCreationForm.type === 'Promotion') {
              console.log("Lorenzo this.chosenStartDate, this.startTime", this.chosenStartDate, this.startTime);
              this.chosenStartDate = this.formatDate(this.eventCreationForm.releaseDate);
              this.startTime = this.eventCreationForm.releaseTime;
              this.chosenEndDate = this.formatDate(this.eventCreationForm.expirationDate);
              this.endTime = this.eventCreationForm.expirationTime;
            }
            if (this.eventCreationForm.partnerName !== "") {
              this.eventCreationForm.eventPartner = {};
              this.eventCreationForm.eventPartner.id = this.eventCreationForm.partnerId;
              this.eventCreationForm.eventPartner.Name = this.eventCreationForm.partnerName;
            }
            this.eventCreationForm.tags = Object.values(
              this.eventCreationForm.tags
            );
            this.preselection = [];
            this.subActivitiesPreselection = [];
            if (this.eventCreationForm.duration != 0) {
              this.eventCreationForm.durationMin = Math.round(
                this.eventCreationForm.duration / 60
              );
            } else {
              this.eventCreationForm.durationMin = 0;
            }
            if (this.eventCreationForm.cooldownTime != 0) {
              this.eventCreationForm.cooldownTimeMin =
                this.eventCreationForm.cooldownTime / 60;
            } else {
              this.eventCreationForm.cooldownTimeMin = 0;
            }
            if (this.eventCreationForm.leadTime != 0) {
              this.eventCreationForm.leadTimeMin =
                this.eventCreationForm.leadTime / 60;
            } else {
              this.eventCreationForm.leadTimeMin = 0;
            }
            this.eventCreationForm.tags.forEach((e) => {
              if (e.Selected == "yes") {
                this.preselection.push(e);
              }
            });
            this.eventRewards = [];
            if (!_.isEmpty(this.eventCreationForm.ParentEventRewards)) {
              for (const [key, value] of Object.entries(
                this.eventCreationForm.ParentEventRewards
              )) {
                if (this.rewardsSelected.length == 0) {
                  console.log("rewards card length = 0");
                  this.eventRewards.push({ key, ...value });
                } else {
                  console.log(" rewards card length !== 0");
                  this.rewardsSelected.forEach((element) => {
                    console.log("element", element, value);
                    if (element.Name !== value.Name) {
                      this.eventRewards.push({ key, ...value });
                    } else {
                      this.eventRewards = [];
                    }
                  });
                }
              }
            } else {
              console.log(" recieved data is empty");
            }
          }
        },
        (error) => {
          console.log(
            "The generic call getEventDetails was not successful",
            error
          );
        },
        "getEventDetailsV2",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    handleCloseEventLanguages(event) {
      this.showEventLanguages = false;

      this.eventCreationForm.eventId = this.newEventId;
      window.EventBus.fire("dataForComponent", this.eventCreationForm);
      window.EventBus.fire("selectEvent", { eventId: this.eventCreationForm.eventId });

      const nav = {
        main: "Events_main_old",
        side: "EventView_Overview",
      };

      // if (event.sideParam != undefined) nav.sideParam = event.sideParam;
      this.showComponents(nav);

      // setTimeout(() => {
      //   window.EventBus.fire("dataForComponent", this.eventCreationForm);
      // }, 200);
    },
    resetBudget() {
      const payload = {
        FunctionId: "EventFunctionLibrary::resetEventBudget",
        EventBudget: this.eventCreationForm.eventBudget,
        EventId: this.eventCreationForm.eventId,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The gerenic call resetEventBudget was successful",
            response
          );
          this.eventCreationForm.remainingBudget = this.eventCreationForm.eventBudget;
        },
        (error) => {
          console.log(
            "The generic call resetEventBudget was not successful",
            error
          );
        },
        "communicateWithDBLibrary",
        this.currentAccountId,
        payload
      );
    },
    getPartners() {
      const payload = {
        FunctionId: "AccountFunctionLibrary::getPartners",
      };
      dssRequest.doRequest(
        (response) => {
          console.log("The gerenic call getPartners was successful", response);
          delete response.data.ErrorMsg;
          this.users = [];

          if(response.data.PartnerList !== undefined) {
            response.data.PartnerList.forEach(
              partner => {
                if(partner.Active) {
                  partner.id = Number(partner.PartnerId);
                  this.users.push(partner);
                }
              }
            );
          } else {
            if(response.data.Partners !== undefined) {
              for (const [k, v] of Object.entries(response.data.Partners)) {
                if(v.Active) {
                  this.users.push({ id: Number(k), ...v });
                }
              }
            }
          }
          console.log("this.users", this.users);
        },
        (error) => {
          console.log("The generic call getPartners was not successful", error);
        },
        "communicateWithDBLibrary",
        this.currentAccountId,
        payload
      );
    },
    editPriceCategoriesItem(item) {
      console.log("Lorenzo item12", item);
      this.editedPriceCategoriesIndex = this.eventPriceCategories.indexOf(item);
      this.editedPriceCategoriesItem = { ...item };
      console.log(
        "Lorenzo this.editedPriceCategoriesItem",
        this.editedPriceCategoriesItem
      );
      this.addPriceCategoriesDialog = true;
      this.editPriceCategorie = true;
    },
    editPoliciesItem(item) {
      this.editedPoliciesIndex = this.eventPolicies.indexOf(item);
      this.editedPoliciesItem = { ...item };
      this.addPoliciesDialog = true;
      this.editPolicies = true;
    },
    editItem(item) {
      this.editedIndex = this.userDiscountCards.indexOf(item);
      this.editedItem = { ...item };
      this.discountCardDialog = true;
    },
    editProductCategoryItem(item) {
      this.editedProductCategoryIndex = this.userProductCategories.indexOf(
        item
      );
      this.editedProductCategoryItem = { ...item };
      this.productCategoriesDialog = true;
    },
    editReward(item) {
      this.editedRewardIndex = this.eventRewards.indexOf(item);
      this.editedRewardItem = { ...item };
      this.eventRewardsDialog = true;
    },
    editEventRewardItem(item) {
      this.editedThemeIndex = this.eventRewardsSelected.indexOf(item);
      this.editedThemeItem = { ...item };
      this.themesDialog = true;
    },
    editExtraLocationItem(item) {
      this.editedExtraLocationItem = this.eventExtraLocationsSelected.indexOf(
        item
      );
      this.editedExtraLocationItem = { ...item };
      this.extraLocationsDialog = true;
    },
    deleteItem(item) {
      const index = this.userDiscountCards.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.userDiscountCards.splice(index, 1);
    },
    deleteProductCategory(item) {
      const payload = {
        Id: item.Id,
        Description: item.Description,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call deleteProductCategory was successful",
            response
          );
          const index = this.userProductCategories.indexOf(item);
          this.userProductCategories.splice(index, 1);
        },
        (error) => {
          console.log(
            "The call deleteProductCategory was not successful",
            error
          );
        },
        "deleteProductCategory",
        this.newEventId,
        payload
      );
    },
    deleteEventRewardItem(item) {
      const index = this.eventRewardsSelected.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.eventRewardsSelected.splice(index, 1);
    },
    deleteExtraLocationItem(item) {
      const index = this.eventExtraLocationsSelected.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.eventExtraLocationsSelected.splice(index, 1);
    },
    deleteReward(item) {
      const index = this.rewardsSelected.indexOf(item);
      confirm("Are you sure you want to delete this item?") &&
        this.rewardsSelected.splice(index, 1);
    },
    close() {
      this.discountCardDialog = false;
      this.newCard = false;
      setTimeout(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      }, 300);
    },
    closeProductCategories() {
      this.productCategoriesDialog = false;
      this.newProductCategory = false;
      setTimeout(() => {
        this.editedProductCategoryItem = { ...this.defaultProductCategoryItem };
        this.editedProductCategoryIndex = -1;
      }, 300);
    },
    closeRewardsDialog() {
      this.eventRewardsDialog = false;
      setTimeout(() => {
        this.editedRewardItem = { ...this.defaultRewardItem };
        this.editedRewardIndex = -1;
      }, 300);
    },
    closeThemesDialog() {
      this.themesDialog = false;
      setTimeout(() => {
        this.editedThemeItem = { ...this.defaultThemeItem };
      }, 300);
    },
    closeExtraLocationsDialog() {
      this.extraLocationsDialog = false;
      setTimeout(() => {
        this.editedExtraLocationItem = { ...this.defaultExtraLocationItem };
      }, 300);
    },
    closeAddPriceCategoriesDialog() {
      this.addPriceCategoriesDialog = false;
      setTimeout(() => {
        this.editedPriceCategoriesItem = {};
      }, 300);
    },
    closeAddPoliciesDialog() {
      this.addPoliciesDialog = false;
      setTimeout(() => {
        this.editedPoliciesItem = {};
      }, 300);
    },
    savePriceCategories(item, optionNew, optionUpdate, optionDelete) {
      console.log("Lorenzo item", item);
      const payload = {};
      const toSendData = {};
      if (this.externallyPriced) {
        this.eventPriceCategories = [];
        this.toSendData = {
          EventId: this.newEventId,
          Id: 0,
          Name: "Free",
          Description: "This event is free",
          VatId: "None",
          CapacityManaged: true,
          MinimumQuantity: 0,
          MaximumQuantity: 20,
        };
        this.payload = {
          ExternalPricing: true,
          EventId: this.newEventId,
          New: {
            0: this.toSendData,
          },
        };
      } else if (optionNew && !optionUpdate) {
        this.toSendData = {
          Name: item.Name,
          Description: item.Description,
          VatId: item.VatId,
          CapacityManaged: Boolean(item.CapacityManaged),
          MinimumQuantity: item.MinimumQuantity,
          MaximumQuantity: item.MaximumQuantity,
        };
        this.toSendData.Active = true;
        this.toSendData.EventId = this.newEventId;
        this.payload = {
          ExternalPricing: false,
          EventId: this.newEventId,
          New: {
            0: this.toSendData,
          },
        };
      } else if (!optionNew && optionUpdate && !optionDelete) {
        this.toSendData = {
          Name: item.Name,
          Description: item.Description,
          VatId: item.VatId,
          CapacityManaged: Boolean(item.CapacityManaged),
          MinimumQuantity: item.MinimumQuantity,
          MaximumQuantity: item.MaximumQuantity,
        };
        this.toSendData.Active = true;
        this.toSendData.EventId = this.newEventId;
        this.payload = {
          ExternalPricing: false,
          EventId: this.newEventId,
          Update: {
            [item.Id]: this.toSendData,
          },
        };
      } else if (!optionNew && optionUpdate && optionDelete) {
        this.toSendData = {
          Name: item.Name,
          Description: item.Description,
          VatId: item.VatId,
          CapacityManaged: Boolean(item.CapacityManaged),
          MinimumQuantity: item.MinimumQuantity,
          MaximumQuantity: item.MaximumQuantity,
        };
        this.toSendData.Active = false;
        this.toSendData.EventId = this.newEventId;
        this.payload = {
          ExternalPricing: false,
          EventId: this.newEventId,
          Update: {
            [item.Id]: this.toSendData,
          },
        };
      }

      // Add PartnerId to the request
      if (Number(this.$store.getters["auth/partnerId"]) <= 0) {
        this.payload.PartnerId = -1;
      } else {
        this.payload.PartnerId = Number(this.$store.getters["auth/partnerId"]);
      }
      this.payload.AccountId = this.currentAccountId;

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call savePriceCategories was successful",
            response
          );
          this.editPriceCategorie = false;
          this.closeAddPriceCategoriesDialog();
          this.getPriceCategories();
        },
        (error) => {
          console.log(
            "The generic call savePriceCategories was not successful",
            error
          );
        },
        "savePriceCategories",
        appConfig.dss.eventAdminMng,
        this.payload
      );
    },
    getPriceCategories() {
      const payload = {
        EventId: this.newEventId,
      };
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The gerenic call getPriceCategories was successful",
            response
          );
          this.eventPriceCategories = Object.values(response.data.Tickets);
          if (this.eventPriceCategories.length == 0 && !this.externallyPriced) {
            // Adding Free if none available for the event tickets
            const x = {
              Id: 0,
              Name: "Free",
              Description: "This event is free",
              VatId: "None",
              CapacityManaged: true,
              MinimumQuantity: 0,
              MaximumQuantity: 20,
            };
            this.savePriceCategories(x, true, false, false);
          }
        },
        (error) => {
          console.log(
            "The generic call getPriceCategories was not successful",
            error
          );
        },
        "getPriceCategories",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    savePolicies(item, optionNew, optionUpdate, optionActive) {
      const payload = {};
      const toSendData = {};
      if (optionNew && !optionUpdate) {
        this.toSendData = {
          Name: item.Name,
          Description: item.Description,
          Timeout: Number(item.Timeout),
        };
        this.toSendData.Active = true;
        this.toSendData.EventId = this.newEventId;
        this.payload = {
          EventId: Number(this.newEventId),
          New: {
            0: this.toSendData,
          },
        };
      } else if (!optionNew && optionUpdate && !optionActive) {
        this.toSendData = {
          Name: item.Name,
          Description: item.Description,
          Timeout: Number(item.Timeout),
        };
        this.toSendData.Active = true;
        this.toSendData.EventId = this.newEventId;
        this.payload = {
          EventId: Number(this.newEventId),
          Update: {
            [item.PolicyId]: this.toSendData,
          },
        };
      } else if (!optionNew && optionUpdate && optionActive) {
        this.toSendData = {
          Name: item.Name,
          Description: item.Description,
          Timeout: Number(item.Timeout),
        };
        this.toSendData.Active = false;
        this.toSendData.EventId = this.newEventId;
        this.payload = {
          EventId: Number(this.newEventId),
          Update: {
            [item.PolicyId]: this.toSendData,
          },
        };
      }

      // Add PartnerId to the request
      if (Number(this.$store.getters["auth/partnerId"]) <= 0) {
        this.payload.PartnerId = -1;
      } else {
        this.payload.PartnerId = Number(this.$store.getters["auth/partnerId"]);
      }
      dssRequest.doRequest(
        (response) => {
          console.log("The gerenic call savePolicies was successful", response);
          this.getPolicies();
          if (this.addPoliciesDialog) this.addPoliciesDialog = false;
        },
        (error) => {
          console.log(
            "The generic call savePolicies was not successful",
            error
          );
        },
        "savePolicies",
        appConfig.dss.eventAdminMng,
        this.payload
      );
    },
    getPolicies() {
      const payload = {
        EventId: this.newEventId,
      };
      dssRequest.doRequest(
        (response) => {
          console.log("The gerenic call getPolicies was successful", response);
          this.eventPolicies = Object.values(response.data);
          if (this.eventPolicies.length == 0) {
            // Adding Free if none available for the event policies
            const x = {
              Name: "Strict",
              Description: "This policy has a time-out of 30 minutes",
              Timeout: 1800,
              Active: true,
            };
            this.savePolicies(x, true, false, false);
          }
        },
        (error) => {
          console.log("The generic call getPolicies was not successful", error);
        },
        "getPolicies",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    save() {
      if (this.editedIndex > -1) {
        Object.assign(
          this.userDiscountCards[this.editedIndex],
          this.editedItem
        );
      } else {
        this.discountCards.forEach((e) => {
          if (this.editedItem.Name == e.Name) {
            this.editedItem.Key = e.key;
          }
        });
        this.userDiscountCards.push(this.editedItem);
      }
      this.close();
    },
    saveProductCategory() {
      if (this.editedProductCategoryIndex > -1) {
        Object.assign(
          this.userProductCategories[this.editedProductCategoryIndex],
          this.editedProductCategoryItem
        );
      } else {
        this.productCategories.forEach((e) => {
          if (this.editedProductCategoryItem.Description == e.Description) {
            this.editedProductCategoryItem.Id = e.id;
          }
        });
        this.userProductCategories.push(this.editedProductCategoryItem);
      }
      this.closeProductCategories();
    },
    saveExtraLocation() {
      console.log(
        "Lorenzo this.editedExtraLocationItem",
        this.editedExtraLocationItem
      );
      if (this.editedExtraLocationIndex > -1) {
        Object.assign(
          this.eventExtraLocationsSelected[this.editedExtraLocationIndex],
          this.editedExtraLocationItem
        );
      } else {
        this.extraLocations.forEach((e) => {
          if (this.editedExtraLocationItem.Name === e.Name) {
            this.editedExtraLocationItem.Key = e.key;
          }
        });
        console.log(
          "Lorenzo this.editedExtraLocationItem",
          this.editedExtraLocationItem
        );
        this.eventExtraLocationsSelected.push(this.editedExtraLocationItem);
      }
      this.closeExtraLocationsDialog();
    },
    saveReward() {
      if (this.editedThemeIndex > -1) {
        Object.assign(
          this.eventRewardsSelected[this.editedThemeIndex],
          this.editedThemeItem
        );
      } else {
        this.rewards.forEach((e) => {
          if (this.editedThemeItem.Name == e.Name) {
            this.editedThemeItem.Key = e.key;
          }
        });
        this.eventRewardsSelected.push(this.editedThemeItem);
      }
      this.closeThemesDialog();
    },
    saveEventReward() {
      if (this.editedRewardIndex > -1) {
        Object.assign(
          this.eventRewards[this.editedRewardIndex],
          this.editedRewardItem
        );
      } else {
        this.eventRewards.forEach((e) => {
          if (this.editedRewardItem.Name == e.Name) {
            this.editedRewardItem.Key = e.key;
          }
        });
        this.rewardsSelected.push(this.editedRewardItem);
      }
      this.closeRewardsDialog();
    },
    getHeightOfAlert() {
      this.waypointsOrderResult;
      setTimeout(() => {
        const elementHeight = document.getElementById("alertWaypoint")
          .clientHeight;
      }, 600);
      return elementHeight;
    },
    handleTimeWindowTypeChange() {
      if (this.eventCreationForm.timeWindowType == "Fixed") {
        this.eventCreationForm.durationType = "Fixed";
        this.disableDurationType = true;
      } else {
        this.eventCreationForm.durationType = "";
        this.disableDurationType = false;
      }
    },
    getBase64(file) {
      console.log("Lorenzo file", file);
      let x = "";
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        x = reader.result;
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
      setTimeout(() => {
        this.generateRouteFromGPX(x);
      }, 1000);
    },
    generateRouteFromGPX(file) {
      const payload = {
        File: file,
        TravelMode: this.eventCreationForm.travelMode,
        AverageSpeed: this.eventCreationForm.averageSpeed,
      };
      console.log("Lorenzo payload", payload);
      dssRequest.doRequest(
        (response) => {
          console.log(
            "The generic call generateRouteFromGPX was successful",
            response
          );
          this.locationProps.params.route = response.data;

          this.locationProps2.params.route.PathPoints =
            response.data.DataFieldTable.PathPoints;
          this.polylineTableItems = response.data.DataFieldTable.PathPoints;
          // window.EventBus.fire('generateTourPoints', { routeAspects: [response.data], disableChangeView: false });
          this.showTourOnMap(
            "bigMap",
            response.data.DataFieldTable,
            true,
            true
          );
          this.toggleTabsMap = 1;
        },
        (error) => {
          console.log(
            "The generic call generateRouteFromGPX was not successful",
            error
          );
        },
        "generateRouteFromGpx",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    setSelectedEventCategories(categoriesSelected) {
      this.eventCategoriesSelected = [];
      this.eventCategoriesSelected = [...categoriesSelected];
    },
    setSelectedCategoryFilters(categoriesSelected) {
      this.categoryFiltersSelected = [];
      this.categoryFiltersSelected = [...categoriesSelected];
    },
    getAllEventCategories() {
      const payload = {
        LanguageTagId: this.$store.getters.getUserLanguage,
      };

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call [getInterestsForEvent] on [LocationsNode_ISE] in component [EventCreation] succeeded",
            response
          );
          this.eventCategoriesAll = [];
          if (
            response.data.hasOwnProperty("Interests") &&
            response.data.Interests !== undefined
          ) {
            this.eventCategoriesAll = [...response.data.Interests];
          }
        },
        (error) => {
          console.log(
            "The call [getInterestsForEvent] on [LocationsNode_ISE] in component [EventCreation] failed",
            error
          );
        },
        "getInterestsForEvent",
        "LocationsNode_ISE",
        payload
      );
    },
    unselectAllCategories(categoriesArray) {
      for (let category of categoriesArray) {
        if (category !== undefined) {
          category.Selected = false;
          if (
            category.hasOwnProperty("SubCategories") &&
            category.SubCategories.length > 0
          ) {
            for (let subCategory of category.SubCategories) {
              if (subCategory !== undefined) {
                subCategory.Selected = false;
              }
            }
          }
        }
      }
    },
    getAllCategoryIds(categoriesArray, categoryIds) {
      for (let category of categoriesArray) {
        if (category !== undefined) {
          categoryIds.push(category.InterestId);
          if (
            category.hasOwnProperty("SubCategories") &&
            category.SubCategories.length > 0
          ) {
            for (let subCategory of category.SubCategories) {
              if (subCategory !== undefined) {
                categoryIds.push(subCategory.InterestId);
              }
            }
          }
        }
      }
    },
    getEventsByCategoryFilters() {
      let payload = {
        LanguageTagId: this.$store.getters.getUserLanguage,
        InterestIds: [],
      };

      this.categoryFiltersSelected.forEach((category) =>
        payload.InterestIds.push(category.InterestId)
      );

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The call [getEventsByInterstIds] on [LocationsNode_ESE] in component [EventCreation] succeeded",
            response
          );
          this.eventCategoriesAll = [];
          if (
            response.data.hasOwnProperty("Interests") &&
            response.data.Interests !== undefined
          ) {
            this.eventCategoriesAll = [...response.data.Interests];
          }
        },
        (error) => {
          console.log(
            "The call [getEventsByInterstIds] on [LocationsNode_ESE] in component [EventCreation] failed",
            error
          );
        },
        "getInterestsForEvent",
        "LocationsNode_ESE",
        payload
      );
    },
    showRelatedEventsList() {
      if (
        this.possibleRelatedEvents === undefined ||
        this.possibleRelatedEvents.length === 0
      ) {
        this.getPossibleRelatedEvents();
      } else {
        // Possible related events already loaded, update the list instead of loading it again
        this.removeSelectedRelatedEvents();
      }
    },
    getPossibleRelatedEvents() {
      let payload = {};

      dssRequest.doRequest(
        (response) => {
          console.log(
            "The request [getPossibleRelatedEvents] to [EventAdministrationMgr] in component [EventCreation] succeeded",
            response
          );
          this.possibleRelatedEvents = [];
          this.possibleRelatedEvents = [...response.data.RelatedEvents];

          this.removeSelectedRelatedEvents();
        },
        (error) => {
          console.log(
            "The request [getPossibleRelatedEvents] to [EventAdministrationMgr] in component [EventCreation] failed",
            error
          );
        },
        "getPossibleRelatedEvents",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    removeSelectedRelatedEvents() {
      // Filter out related events that already / tobe connected to the event
      if (
        this.relatedEventsToBeSaved !== undefined &&
        this.relatedEventsToBeSaved.length > 0
      ) {
        let possibleRelatedEventsTmp = this.possibleRelatedEvents.filter(
          (relatedEvent) => {
            const eventIndex = this.relatedEventsToBeSaved.findIndex(
              (relatedEventCurr) =>
                relatedEventCurr.EventId === relatedEvent.EventId
            );
            if (eventIndex === -1) return true;
          }
        );

        this.possibleRelatedEvents = [];
        possibleRelatedEventsTmp.forEach((relatedEvent) => {
          let relatedEventTmp = Object.assign({}, relatedEvent);
          this.possibleRelatedEvents.push(relatedEventTmp);
        });
      }

      // Ready to show the related events dialog
      this.showRelatedEventsDialog = true;
    },
    saveRelatedEventsChanges(relatedEventsSelected) {
      console.log(
        "Received selected related events from component [RelatedEventsDialog]: ",
        relatedEventsSelected
      );
      this.relatedEventsToBeSaved = [];
      this.relatedEventsToBeSaved = [...relatedEventsSelected];
      this.showRelatedEventsDialog = false;
    },
    cancelRelatedEventsChanges() {
      this.showRelatedEventsDialog = false;
    },
    showProductCategories() {
      // Test data of product categories
      if(this.eventCreationForm.eventId !== undefined && this.eventCreationForm.eventId !== null) {
        this.getProductCategories();
      } else {
        this.saveEventFirstDialog = true;
      }
    },
    getProductCategories() {
      const payload = {
        EventId: this.eventCreationForm.eventId
      };

      dssRequest.doRequest(
        response => {
          console.log(
            "The request [getProductCategories] to [EventAdministrationMgr] in component [EventCreation] succeeded",
            response
          );

          this.productCategoryList = [];
          if(response.data.hasOwnProperty("ProductCategories")) {
            this.productCategoryList = [...response.data.ProductCategories];
          }

          this.showProductCategoriesDialog = true;

          // this.successMsg =
          //   "Your request to update product categories has been processed successfully.";
          // this.successDialogActive = true;
        },
        error => {
          console.log(
            "The request [getProductCategories] to [EventAdministrationMgr] in component [EventCreation] failed",
            error
          );

          // this.failureMsg =
          //   "Your request to update product categories failed. Please try again later. If the problem persists, please contact the administrator.";
          // this.failureDialogActive = true;
        },
        "getProductCategories",
        appConfig.dss.eventAdminMng,
        payload
      );
    },
    productCategoriesDialogClosedHandler() {
      this.showProductCategoriesDialog = false;
    },
    productCategoriesUpdatedHandler(newProductCategoryList) {
      this.showProductCategoriesDialog = false;
    }
  },
};
</script>
<style lang="scss" scoped="">
.toolbarSet {
  max-height: 3em;
}
.scrollableEvent {
  height: 90vh;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 2em;
}

.routeMapCard {
  max-height: 35em;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 2em;
}

.autoScrollabe {
  height: 30vh;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 2em;
}
.imageBorder {
  padding-right: 1em;
  padding-left: 1em !important;
  margin-bottom: 1.5em;
  margin-top: 0.1em;
  border: 2px solid rgba(0, 0, 0, 0.54);
}

.outlineH4 {
  margin-bottom: -1.5em;
}
.checkBoxer {
  margin-left: -0.3em;
  margin-top: -0.5em;
  margin-bottom: 1em;
}

.outerLining {
  margin-bottom: 5em;
  margin-top: 2em;
  margin-left: 1em;
  max-width: calc(130vh);
  background-color: #ffffff;
  border-radius: 1em;
}

.dialogActivitiesSelecter {
  background-color: #ffffff;
  border-radius: 1em;
}

.listOutline {
  margin-top: 1em;
  margin-left: 2.6em;
}

.tourCard {
  margin-right: 1em;
  border: 1.5px solid black;
  min-height: 30em;
  max-height: 30em;
  min-width: 25em !important;
  max-width: 30em !important;
  overflow-x: hidden;
  overflow-y: auto;
}

.cardEvents {
  margin-right: 1em;
  border: 1.5px solid black;
  min-height: 30em;
  max-height: 30em;
  max-width: 20em !important;
  overflow-x: hidden;
  overflow-y: auto;
}

.thisOne {
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.layoutForRightCard {
  margin-top: 5.6em;
  margin-bottom: 2em;
}

.listOutlineSub {
  border-bottom: 1px solid black;
  margin-left: -0.5em;
  margin-right: -0.5em;
}

.tourListOutlineSub {
  border: 1px solid black;
  margin-left: -0.5em;
  margin-right: -0.5em;
}

.tourCheckbox {
  margin-left: 0.5em;
}

.tourText {
  margin-top: 1.2em;
}

.dot {
  background-color: #006e95;
  margin-right: 0.5em;
  margin-top: 1.2em;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: inline-block;
}

.pStyle {
  margin-left: 0.5em;
  color: #fff;
}

.dragIcon {
  // margin-left: 15em;
  // margin-top: -3em;
}
.discountCard {
  border: 1px solid black !important;
}

.ticketCard {
  min-height: 32em;
  width: 100%;
}

.deleteMarkerBtn {
  margin-top: -5em !important;
}
.backgroundHolder {
  cursor: pointer;
  border-radius: 50%;
  width: 30px !important;
  height: 30px !important;
  margin: 9px;
}

.tablePadding {
  padding-left: 25px;
  font-weight: normal !important;
}
.startEndLocationTextTable {
  font-weight: normal !important;
  font-size: 12px !important;
  color: rgba(0, 0, 0, 0.54) !important;
  padding-left: 24px !important;
}
.tableIcons {
  padding-left: 10px !important;
  padding-right: 24px !important;
}
.markerLetter {
  font-size: 20px;
  color: white;
}
.inlineBlock {
  display: inline-block;
}

.scrollingPossible {
  min-height: calc(29vh);
  max-height: calc(30vh);
  overflow-y: auto;
  overflow-x: hidden;
}
.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
  cursor: pointer;
}
.inputfile + label {
  font-size: 1.25em;
  font-weight: 700;
  color: white;
  background-color: black;
  display: inline-block;
}

.addEventScreen {
  padding: 2em;
  max-width: 100%;
  overflow-y: hidden;
}

.innerEventSection {
  padding-top: 2em;
  max-width: 100%;
  min-height: calc(59vh);
  max-height: calc(60vh);
  overflow-y: auto;
  overflow-x: hidden;
}
.checkboxWholeCountry {
  margin-top: 0;
}
</style>
